var _style, _polygon, _polygon2, _path, _path2, _path3, _path4, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path5, _ellipse7, _ellipse8, _g, _g2, _g3, _g4, _g5, _g6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCohete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 548.24",
    style: {
      enableBackground: "new 0 0 600 548.24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000088817873545421577740000018291614377028867462_);}\n\t.st2{fill:#6971FF;}\n\t\n\t\t.st3{fill:none;stroke:url(#SVGID_00000064321342326522888650000003379084970701331090_);stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st4{fill:none;stroke:url(#SVGID_00000111159651917719744580000017387763407945408154_);stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st5{fill:none;stroke:url(#SVGID_00000039104133623997164610000003626493448394677659_);stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st6{fill:none;stroke:url(#SVGID_00000112591907130223533800000005170005056183216775_);stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st7{fill:none;stroke:url(#SVGID_00000096031144518053081700000016191211908501416835_);stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st8{fill:none;stroke:url(#SVGID_00000000183132844465532610000012994254495501500321_);stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st9{fill:none;stroke:url(#SVGID_00000125561895660027417590000012622176930489589897_);stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st10{fill:none;stroke:url(#SVGID_00000008150390371214609390000003902929129375330998_);stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t\n\t\t.st11{fill:none;stroke:url(#SVGID_00000138558253893814561180000017694463010764419758_);stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st12{opacity:0.7;}\n\t.st13{fill:url(#SVGID_00000079469558653246722320000016776282734269549448_);}\n\t.st14{fill:url(#SVGID_00000139270659168934343120000017559337979416246194_);}\n\t.st15{fill:url(#SVGID_00000042702800976081007580000016189458797535329434_);}\n\t\n\t\t.st16{fill:none;stroke:url(#SVGID_00000062164575666702361660000013515405589625964991_);stroke-width:1.9865;stroke-miterlimit:10;}\n\t.st17{fill:url(#SVGID_00000080188561232909372560000000179873454647766947_);}\n\t.st18{fill:url(#SVGID_00000127035396155886474640000003504610349710959266_);}\n\t.st19{fill:url(#SVGID_00000084489101867460160320000010326002386203588528_);}\n\t\n\t\t.st20{fill:none;stroke:url(#SVGID_00000150063305809545560290000017533092321101260954_);stroke-width:1.9865;stroke-miterlimit:10;}\n\t.st21{fill:url(#SVGID_00000174601399373817192350000001055021581551256973_);}\n\t.st22{fill:url(#SVGID_00000018229309176261264110000008291370222656109231_);}\n\t.st23{fill:url(#SVGID_00000016063744467332531180000007291850029770385833_);}\n\t\n\t\t.st24{fill:none;stroke:url(#SVGID_00000023258265537914523280000010839520582315222668_);stroke-width:0.8153;stroke-miterlimit:10;}\n\t.st25{fill:url(#SVGID_00000018921314567716787220000004100504789165982136_);}\n\t.st26{fill:url(#SVGID_00000035496109910302413470000003424141057338953126_);}\n\t.st27{fill:url(#SVGID_00000086673646744984586610000016010685276247774618_);}\n\t\n\t\t.st28{fill:none;stroke:url(#SVGID_00000124148307528495949550000015337604386600431531_);stroke-width:0.8153;stroke-miterlimit:10;}\n\t.st29{fill:url(#SVGID_00000114069274066998778620000003815623110626243986_);}\n\t.st30{fill:url(#SVGID_00000125567754607671879660000016079719617766014106_);}\n\t.st31{fill:url(#SVGID_00000140007833283723584750000015293508062439654835_);}\n\t\n\t\t.st32{fill:none;stroke:url(#SVGID_00000176038525949046733190000013927570684456693898_);stroke-width:0.8583;stroke-miterlimit:10;}\n\t.st33{fill:url(#SVGID_00000067216632244481436440000001311065859298103440_);}\n\t.st34{fill:url(#SVGID_00000109021442338933369030000008131555872135602074_);}\n\t.st35{fill:url(#SVGID_00000096771014604138261760000002235456254978287247_);}\n\t\n\t\t.st36{fill:none;stroke:url(#SVGID_00000017494840938566458160000014168653988952514479_);stroke-width:0.8583;stroke-miterlimit:10;}\n\t.st37{fill:url(#SVGID_00000094609633802118274940000013284404828122449288_);}\n\t.st38{fill:url(#SVGID_00000161632507878264893640000016476329371043255998_);}\n\t.st39{fill:url(#SVGID_00000114068628466493710890000003270506960700904121_);}\n\t.st40{fill:none;stroke:url(#SVGID_00000109736665600571426130000003889481775960055696_);stroke-width:0.9;stroke-miterlimit:10;}\n\t.st41{fill:url(#SVGID_00000101812733885279899330000008732953445149372803_);}\n\t.st42{fill:url(#SVGID_00000148628642343938710200000013199463234615353756_);}\n\t.st43{fill:url(#SVGID_00000061464159548945876760000015603234848123680651_);}\n\t.st44{fill:none;stroke:url(#SVGID_00000160887898444734120150000003140704451499444097_);stroke-width:0.9;stroke-miterlimit:10;}\n\t.st45{fill:url(#SVGID_00000074401879570004748160000001957434479037348993_);}\n\t.st46{fill:url(#SVGID_00000121267177759244221580000016681442238570078600_);}\n\t.st47{fill:url(#SVGID_00000158747069771518569140000012448364984037546128_);}\n\t\n\t\t.st48{fill:none;stroke:url(#SVGID_00000147927819389296904070000007862393284373916849_);stroke-width:0.8153;stroke-miterlimit:10;}\n\t.st49{fill:url(#SVGID_00000031916923420858408550000012979485055289559434_);}\n\t.st50{fill:url(#SVGID_00000127746742873144974910000002201748622177457820_);}\n\t.st51{fill:url(#SVGID_00000016063465362930854230000004773193733114770339_);}\n\t\n\t\t.st52{fill:none;stroke:url(#SVGID_00000025426662241410423040000016537662216204479369_);stroke-width:0.8153;stroke-miterlimit:10;}\n\t.st53{fill:url(#SVGID_00000173877761355011243160000011876222567582301623_);}\n\t.st54{fill:url(#SVGID_00000182510199245760120200000009502745778369666215_);}\n\t.st55{fill:url(#SVGID_00000015354066901077391000000015544757720584141752_);}\n\t.st56{fill:#2D31FA;}\n\t.st57{fill:url(#SVGID_00000028299243776910148210000016299885899781084553_);}\n\t.st58{fill:url(#SVGID_00000078023801044184519030000012104487227988235451_);}\n\t.st59{fill:url(#SVGID_00000034786416419408453110000003568737633265363095_);}\n\t.st60{fill:url(#SVGID_00000110453385576382363220000006293724919116796060_);}\n\t.st61{fill:url(#SVGID_00000176034568770899504290000006257560585084142214_);}\n\t.st62{fill:url(#SVGID_00000165914007930929703930000011658337821760767879_);}\n\t.st63{fill:url(#SVGID_00000137843154996722329490000006891828440815520440_);}\n\t.st64{fill:url(#SVGID_00000111900249555043088700000016411809225852963237_);}\n\t.st65{fill:url(#SVGID_00000032634324373590609690000004851923028241792921_);}\n\t.st66{fill:url(#SVGID_00000057145093393709596550000016375530318883407028_);}\n\t.st67{fill:url(#SVGID_00000119107981652909579350000000228426000383576484_);}\n\t.st68{fill:url(#SVGID_00000154391199614207282150000007455855481855440518_);}\n\t.st69{fill:url(#SVGID_00000078735323893011659740000012126177289520717753_);}\n\t.st70{fill:url(#SVGID_00000036235521214030569570000015239731935081492115_);}\n\t.st71{fill:url(#SVGID_00000153692612557799630800000005436618130584821675_);}\n\t.st72{fill:url(#SVGID_00000015317164199525636900000015522496025001732763_);}\n\t.st73{fill:url(#SVGID_00000049909757317398584000000011627137839470471812_);}\n\t.st74{fill:url(#SVGID_00000008137129938120233430000010882208586466141589_);}\n\t.st75{fill:url(#SVGID_00000030455383570054660000000000449301971404591764_);}\n\t.st76{fill:url(#SVGID_00000049903247469409660450000002049596053100831112_);}\n\t.st77{fill:url(#SVGID_00000078015278120868900600000002444634939194137989_);}\n\t.st78{fill:url(#SVGID_00000177466111070968393930000010201734824357477042_);}\n\t.st79{fill:url(#SVGID_00000101090506448445233880000000919191410750249376_);}\n\t.st80{fill:url(#SVGID_00000154420143856229513970000002508363384009220792_);}\n\t.st81{fill:url(#SVGID_00000094583151782513125690000007719029754442145709_);}\n\t.st82{fill:url(#SVGID_00000080925860710017192840000014535618469254124678_);}\n\t.st83{fill:url(#SVGID_00000070091554764782538990000004252567522072467084_);}\n\t.st84{fill:url(#SVGID_00000145047146296641197490000006970342453684020122_);}\n\t.st85{fill:url(#SVGID_00000148646065293283656600000001653279384976398758_);}\n\t.st86{fill:url(#SVGID_00000163050517383405485500000009958623612784753854_);}\n\t.st87{fill:url(#SVGID_00000160190390966391350370000006269556026265203637_);}\n\t.st88{fill:url(#SVGID_00000044899413578926269410000015276488636712733075_);}\n\t.st89{fill:url(#SVGID_00000172433358867128769900000005615905476743980436_);}\n\t.st90{fill:url(#SVGID_00000086665427799657168520000002275509699967116417_);}\n\t.st91{fill:url(#SVGID_00000124156020680401049990000006889986118741654169_);}\n\t.st92{fill:url(#SVGID_00000035509059294878880530000005253186752890281405_);}\n\t.st93{fill:url(#SVGID_00000128479438336629088440000004403584311312908688_);}\n\t.st94{fill:url(#SVGID_00000026875279092445219570000007362408012389131394_);}\n\t.st95{fill:url(#SVGID_00000110437073054807812050000001101219915960793010_);}\n\t.st96{fill:url(#SVGID_00000138549019799036448710000009149796108267971500_);}\n\t.st97{fill:url(#SVGID_00000003800763033394927400000014623104470654375825_);}\n\t.st98{fill:url(#SVGID_00000073001839245145623030000013962577160535919771_);}\n\t.st99{fill:url(#SVGID_00000017486866628500927510000012829354438665738391_);}\n\t.st100{fill:url(#SVGID_00000036960687634261968030000015035138034711131041_);}\n\t.st101{fill:url(#SVGID_00000127011437324437215700000006252985436308433552_);}\n\t.st102{fill:url(#SVGID_00000021808715425681108020000011004501843864342433_);}\n\t.st103{fill:url(#SVGID_00000083083237333011745770000011013845017838138794_);}\n\t.st104{fill:url(#SVGID_00000178894263092310065700000012384299624764750501_);}\n\t.st105{fill:url(#SVGID_00000059999696622760461410000006297280617275782030_);}\n\t.st106{fill:url(#SVGID_00000070808616314072313180000013591976792917993889_);}\n\t.st107{fill:#FFFFFF;}\n\t.st108{fill:url(#SVGID_00000005966523266505023670000005516525929211315618_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 408.9435,
    y1: 268.8544,
    x2: 568.0896,
    y2: 399.0005
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7D57C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0766,
    style: {
      stopColor: "#8B6CCD",
      stopOpacity: 0.9104
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2527,
    style: {
      stopColor: "#A898DE",
      stopOpacity: 0.7044
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4232,
    style: {
      stopColor: "#BFBAEC",
      stopOpacity: 0.5049
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5843,
    style: {
      stopColor: "#D0D2F6",
      stopOpacity: 0.3164
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    style: {
      stopColor: "#DAE1FC",
      stopOpacity: 0.1433
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8547,
    style: {
      stopColor: "#DDE6FE",
      stopOpacity: 0
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "545.01,380.67 393.03,292.93 420,277.35 571.98,365.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000043425161795519288510000008464144063925715329_",
    gradientUnits: "userSpaceOnUse",
    x1: 26.5919,
    y1: 1263.7573,
    x2: 506.135,
    y2: 1108.0437,
    gradientTransform: "matrix(0.866 0.5 -1 0.5774 1571.7516 -466.338)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000043425161795519288510000008464144063925715329_)"
    },
    points: "545.01,368.01 393.03,280.26  420,264.69 571.98,352.43  "
  }), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "544.15,363.83 412.53,288.13 433.62,275.95 565.25,351.65  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000137826867177711638240000017085685746206019217_",
    gradientUnits: "userSpaceOnUse",
    x1: 298.1504,
    y1: 364.1474,
    x2: 481.5856,
    y2: 364.1474
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000137826867177711638240000017085685746206019217_)",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 480.09,390.59 467.43,382.65 437.13,400.15 358.87,355.43 345.89,347.94 316.29,364.56 299.65,355.23 299.65,328.15  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100352399406600182120000006738120745993915304_",
    gradientUnits: "userSpaceOnUse",
    x1: 291.6957,
    y1: 388.108,
    x2: 487.7419,
    y2: 388.108
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000100352399406600182120000006738120745993915304_)",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 486.24,447.32 469.92,437.9 486.24,428.48 469.92,419.05 441.35,435.08 408.7,415.98 376.06,434.75 327.08,406.53 351.27,393.23  293.2,360.41 293.2,328.89  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000155837924937107573350000011524487896358229668_",
    gradientUnits: "userSpaceOnUse",
    x1: 358.9474,
    y1: 373.3218,
    x2: 588.9727,
    y2: 373.3218
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000155837924937107573350000011524487896358229668_)",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 360.45,338.35 377.84,327.66 421.64,352.68 453.59,334.23 469.92,343.65 437.27,362.5 453.59,371.93 486.24,353.08  535.21,381.35 502.47,400.15 535.21,418.98 587.47,388.81 557.02,371.49 557.02,360.75  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159459025701642176880000003063019487690753701_",
    gradientUnits: "userSpaceOnUse",
    x1: 299.8677,
    y1: 386.7285,
    x2: 411.4342,
    y2: 386.7285
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000159459025701642176880000003063019487690753701_)",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 409.93,434.82 379.63,452.32 301.37,407.6 327.08,393.13 302.45,377.96 303.23,321.14  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000070818602112059654780000002793208222530466202_",
    gradientUnits: "userSpaceOnUse",
    x1: 227.918,
    y1: 426.5514,
    x2: 366.5713,
    y2: 426.5514
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000070818602112059654780000002793208222530466202_)",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 274.87,337.78 275.51,388.5 284.77,393.55 241.38,419.27 269.44,435.3 295.63,420.19 365.07,460.74 335.25,477.95 302.6,459.11  229.42,501.36 253.32,515.32 298.67,489.14 313.78,497.86  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085950145444781589350000009180329999042153139_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.0273,
    y1: 396.0252,
    x2: 258.5984,
    y2: 396.0252
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000085950145444781589350000009180329999042153139_)",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 61.5,447.51 45.5,456.75 12.53,437.71 58.25,411.68 142.61,459.37 257.1,393.27 249.54,388.15 249.54,332.68  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000066504224916688613850000006925011354909622177_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.6467,
    y1: 339.0349,
    x2: 190.3674,
    y2: 339.0349
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000066504224916688613850000006925011354909622177_)",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 188.87,354.68 176.09,362.5 94.15,315.57  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000019666489112487226200000007967283688386207106_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.5624,
    y1: 355.6147,
    x2: 233.8765,
    y2: 355.6147
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000019666489112487226200000007967283688386207106_)",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 51.06,309.01 143.44,362.89 127.12,371.93 94.47,353.08 78.47,362.32 146.94,402.22 197.72,372 211.06,379.88 232.38,366.43  232.38,330.03  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075140445305680752850000011929170597665001886_",
    gradientUnits: "userSpaceOnUse",
    x1: 11.3496,
    y1: 369.9248,
    x2: 239.4054,
    y2: 369.9248
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000075140445305680752850000011929170597665001886_)",
      strokeWidth: 3,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 12.85,374.83 83.98,415.68 102.95,404.73 52.85,377.11 66.27,369.36 147.01,415.49 177.32,397.99 194.99,408.14 228.7,388.11  228.7,379.88 237.91,373.5 237.91,324.17  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000006705370845078549700000008927082713100657808_",
    cx: 395.4616,
    cy: 1229.2902,
    r: 285.4579,
    gradientTransform: "matrix(0 0.4252 -0.1283 0 412.4933 182.721)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0028F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0634,
    style: {
      stopColor: "#0022CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    style: {
      stopColor: "#001997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2739,
    style: {
      stopColor: "#001169"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3789,
    style: {
      stopColor: "#000B43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4827,
    style: {
      stopColor: "#000626"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5852,
    style: {
      stopColor: "#000311"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6857,
    style: {
      stopColor: "#000104"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7818,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000006705370845078549700000008927082713100657808_)"
    },
    cx: 254.77,
    cy: 350.88,
    rx: 43.11,
    ry: 140.63
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000125592917088239977240000017943767915989606024_",
    cx: 395.4616,
    cy: 1229.2902,
    r: 285.4579,
    gradientTransform: "matrix(0 0.4252 -0.1283 0 412.4933 182.721)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0028F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0634,
    style: {
      stopColor: "#0022CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    style: {
      stopColor: "#001997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2739,
    style: {
      stopColor: "#001169"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3789,
    style: {
      stopColor: "#000B43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4827,
    style: {
      stopColor: "#000626"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5852,
    style: {
      stopColor: "#000311"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6857,
    style: {
      stopColor: "#000104"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7818,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000125592917088239977240000017943767915989606024_)"
    },
    cx: 254.77,
    cy: 350.88,
    rx: 43.11,
    ry: 140.63
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000042698046093412916390000001554808638033640579_",
    cx: 395.4616,
    cy: 3746.6489,
    r: 285.4579,
    gradientTransform: "matrix(0 0.4252 -0.0244 0 346.0196 182.721)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0323,
    style: {
      stopColor: "#BBBBBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1627,
    style: {
      stopColor: "#8A8A8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2964,
    style: {
      stopColor: "#5F5F5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4313,
    style: {
      stopColor: "#3D3D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5678,
    style: {
      stopColor: "#222222"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    style: {
      stopColor: "#0F0F0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8487,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000042698046093412916390000001554808638033640579_)"
    },
    cx: 254.77,
    cy: 350.88,
    rx: 8.18,
    ry: 140.63
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000164481349137264702190000010720337872330526911_",
    cx: 373.0392,
    cy: 1229.2902,
    r: 210.7128,
    gradientTransform: "matrix(0 0.4252 -3.7472 0 4861.1865 182.721)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0323,
    style: {
      stopColor: "#BBBBBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1627,
    style: {
      stopColor: "#8A8A8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2964,
    style: {
      stopColor: "#5F5F5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4313,
    style: {
      stopColor: "#3D3D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5678,
    style: {
      stopColor: "#222222"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    style: {
      stopColor: "#0F0F0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8487,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000164481349137264702190000010720337872330526911_)",
      strokeWidth: 1.9865,
      strokeMiterlimit: 10
    },
    x1: 254.77,
    y1: 214.63,
    x2: 254.77,
    y2: 468.07
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000042003690702037249220000011281382047140819116_",
    cx: 496.1425,
    cy: 1223.927,
    r: 285.4579,
    gradientTransform: "matrix(0 0.4252 -0.1283 0 431.902 182.721)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0028F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0634,
    style: {
      stopColor: "#0022CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    style: {
      stopColor: "#001997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2739,
    style: {
      stopColor: "#001169"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3789,
    style: {
      stopColor: "#000B43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4827,
    style: {
      stopColor: "#000626"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5852,
    style: {
      stopColor: "#000311"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6857,
    style: {
      stopColor: "#000104"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7818,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000042003690702037249220000011281382047140819116_)"
    },
    cx: 274.87,
    cy: 393.7,
    rx: 43.11,
    ry: 140.63
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000141455560071924626830000017685884790603501968_",
    cx: 496.1425,
    cy: 1223.9265,
    r: 285.4579,
    gradientTransform: "matrix(0 0.4252 -0.1283 0 431.9019 182.721)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0028F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0634,
    style: {
      stopColor: "#0022CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    style: {
      stopColor: "#001997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2739,
    style: {
      stopColor: "#001169"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3789,
    style: {
      stopColor: "#000B43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4827,
    style: {
      stopColor: "#000626"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5852,
    style: {
      stopColor: "#000311"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6857,
    style: {
      stopColor: "#000104"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7818,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000141455560071924626830000017685884790603501968_)"
    },
    cx: 274.87,
    cy: 393.7,
    rx: 43.11,
    ry: 140.63
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000125577401274554404090000011677387066070730381_",
    cx: 496.1425,
    cy: 3718.3953,
    r: 285.4579,
    gradientTransform: "matrix(0 0.4252 -0.0244 0 365.4283 182.721)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0323,
    style: {
      stopColor: "#BBBBBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1627,
    style: {
      stopColor: "#8A8A8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2964,
    style: {
      stopColor: "#5F5F5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4313,
    style: {
      stopColor: "#3D3D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5678,
    style: {
      stopColor: "#222222"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    style: {
      stopColor: "#0F0F0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8487,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000125577401274554404090000011677387066070730381_)"
    },
    cx: 274.87,
    cy: 393.7,
    rx: 8.18,
    ry: 140.63
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000139988649467277391040000004059222600688937101_",
    cx: 473.7201,
    cy: 1223.927,
    r: 210.7128,
    gradientTransform: "matrix(0 0.4252 -3.7472 0 4861.1865 182.721)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0323,
    style: {
      stopColor: "#BBBBBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1627,
    style: {
      stopColor: "#8A8A8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2964,
    style: {
      stopColor: "#5F5F5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4313,
    style: {
      stopColor: "#3D3D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5678,
    style: {
      stopColor: "#222222"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    style: {
      stopColor: "#0F0F0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8487,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000139988649467277391040000004059222600688937101_)",
      strokeWidth: 1.9865,
      strokeMiterlimit: 10
    },
    x1: 274.87,
    y1: 257.45,
    x2: 274.87,
    y2: 510.88
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000065076387646352969520000012768460260008263569_",
    cx: 416.0865,
    cy: 1594.6597,
    r: 162.0312,
    gradientTransform: "matrix(0 0.4252 -0.0671 0 389.3201 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0028F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0634,
    style: {
      stopColor: "#0022CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    style: {
      stopColor: "#001997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2739,
    style: {
      stopColor: "#001169"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3789,
    style: {
      stopColor: "#000B43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4827,
    style: {
      stopColor: "#000626"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5852,
    style: {
      stopColor: "#000311"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6857,
    style: {
      stopColor: "#000104"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7818,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000065076387646352969520000012768460260008263569_)"
    },
    cx: 282.35,
    cy: 359.66,
    rx: 12.8,
    ry: 79.82
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000116203824382061190180000014862705076031622802_",
    cx: 416.0865,
    cy: 1594.6597,
    r: 162.0312,
    gradientTransform: "matrix(0 0.4252 -0.0671 0 389.3201 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0028F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0634,
    style: {
      stopColor: "#0022CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    style: {
      stopColor: "#001997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2739,
    style: {
      stopColor: "#001169"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3789,
    style: {
      stopColor: "#000B43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4827,
    style: {
      stopColor: "#000626"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5852,
    style: {
      stopColor: "#000311"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6857,
    style: {
      stopColor: "#000104"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7818,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000116203824382061190180000014862705076031622802_)"
    },
    cx: 282.35,
    cy: 359.66,
    rx: 12.8,
    ry: 79.82
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000104693746108909684800000004706364810656650681_",
    cx: 416.0865,
    cy: 5671.4458,
    r: 162.0312,
    gradientTransform: "matrix(0 0.4252 -0.0127 0 354.5649 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0323,
    style: {
      stopColor: "#BBBBBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1627,
    style: {
      stopColor: "#8A8A8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2964,
    style: {
      stopColor: "#5F5F5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4313,
    style: {
      stopColor: "#3D3D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5678,
    style: {
      stopColor: "#222222"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    style: {
      stopColor: "#0F0F0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8487,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000104693746108909684800000004706364810656650681_)"
    },
    cx: 282.35,
    cy: 359.66,
    rx: 2.43,
    ry: 79.82
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000167382354111903340560000007657282971558383807_",
    cx: 403.3591,
    cy: 1594.6597,
    r: 119.6042,
    gradientTransform: "matrix(0 0.4252 -1.9592 0 3406.6028 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0323,
    style: {
      stopColor: "#BBBBBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1627,
    style: {
      stopColor: "#8A8A8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2964,
    style: {
      stopColor: "#5F5F5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4313,
    style: {
      stopColor: "#3D3D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5678,
    style: {
      stopColor: "#222222"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    style: {
      stopColor: "#0F0F0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8487,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000167382354111903340560000007657282971558383807_)",
      strokeWidth: 0.8153,
      strokeMiterlimit: 10
    },
    x1: 282.35,
    y1: 282.32,
    x2: 282.35,
    y2: 426.17
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000023260693351775292170000012870221167042222981_",
    cx: 473.2349,
    cy: 1591.6155,
    r: 162.0312,
    gradientTransform: "matrix(0 0.4252 -0.0671 0 395.0801 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0028F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0634,
    style: {
      stopColor: "#0022CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    style: {
      stopColor: "#001997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2739,
    style: {
      stopColor: "#001169"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3789,
    style: {
      stopColor: "#000B43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4827,
    style: {
      stopColor: "#000626"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5852,
    style: {
      stopColor: "#000311"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6857,
    style: {
      stopColor: "#000104"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7818,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000023260693351775292170000012870221167042222981_)"
    },
    cx: 288.31,
    cy: 383.96,
    rx: 12.8,
    ry: 79.82
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000056395381887799040970000007615822450701746850_",
    cx: 473.2349,
    cy: 1591.615,
    r: 162.0312,
    gradientTransform: "matrix(0 0.4252 -0.0671 0 395.08 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0028F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0634,
    style: {
      stopColor: "#0022CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    style: {
      stopColor: "#001997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2739,
    style: {
      stopColor: "#001169"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3789,
    style: {
      stopColor: "#000B43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4827,
    style: {
      stopColor: "#000626"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5852,
    style: {
      stopColor: "#000311"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6857,
    style: {
      stopColor: "#000104"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7818,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000056395381887799040970000007615822450701746850_)"
    },
    cx: 288.31,
    cy: 383.96,
    rx: 12.8,
    ry: 79.82
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000079479095131891800390000016738865039447893947_",
    cx: 473.2349,
    cy: 5655.4082,
    r: 162.0312,
    gradientTransform: "matrix(0 0.4252 -0.0127 0 360.3249 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0323,
    style: {
      stopColor: "#BBBBBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1627,
    style: {
      stopColor: "#8A8A8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2964,
    style: {
      stopColor: "#5F5F5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4313,
    style: {
      stopColor: "#3D3D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5678,
    style: {
      stopColor: "#222222"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    style: {
      stopColor: "#0F0F0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8487,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000079479095131891800390000016738865039447893947_)"
    },
    cx: 288.31,
    cy: 383.96,
    rx: 2.43,
    ry: 79.82
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000061442596966341718270000005459377995192780472_",
    cx: 460.5074,
    cy: 1591.6155,
    r: 119.6042,
    gradientTransform: "matrix(0 0.4252 -1.9592 0 3406.6028 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0323,
    style: {
      stopColor: "#BBBBBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1627,
    style: {
      stopColor: "#8A8A8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2964,
    style: {
      stopColor: "#5F5F5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4313,
    style: {
      stopColor: "#3D3D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5678,
    style: {
      stopColor: "#222222"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    style: {
      stopColor: "#0F0F0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8487,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000061442596966341718270000005459377995192780472_)",
      strokeWidth: 0.8153,
      strokeMiterlimit: 10
    },
    x1: 288.31,
    y1: 306.62,
    x2: 288.31,
    y2: 450.47
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000031181053595171991450000010456808950233548193_",
    cx: 412.61,
    cy: 1509.3058,
    r: 162.0312,
    gradientTransform: "matrix(0 0.4252 -0.0743 0 411.0553 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0028F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0634,
    style: {
      stopColor: "#0022CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    style: {
      stopColor: "#001997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2739,
    style: {
      stopColor: "#001169"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3789,
    style: {
      stopColor: "#000B43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4827,
    style: {
      stopColor: "#000626"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5852,
    style: {
      stopColor: "#000311"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6857,
    style: {
      stopColor: "#000104"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7818,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000031181053595171991450000010456808950233548193_)"
    },
    cx: 298.85,
    cy: 358.18,
    rx: 14.18,
    ry: 79.82
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000023281880066436933540000005232996194666656391_",
    cx: 412.61,
    cy: 1509.3058,
    r: 162.0312,
    gradientTransform: "matrix(0 0.4252 -0.0743 0 411.0553 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0028F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0634,
    style: {
      stopColor: "#0022CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    style: {
      stopColor: "#001997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2739,
    style: {
      stopColor: "#001169"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3789,
    style: {
      stopColor: "#000B43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4827,
    style: {
      stopColor: "#000626"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5852,
    style: {
      stopColor: "#000311"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6857,
    style: {
      stopColor: "#000104"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7818,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000023281880066436933540000005232996194666656391_)"
    },
    cx: 298.85,
    cy: 358.18,
    rx: 14.18,
    ry: 79.82
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000057864872677483498770000012134267440235342219_",
    cx: 412.61,
    cy: 5221.7939,
    r: 162.0312,
    gradientTransform: "matrix(0 0.4252 -0.0141 0 372.5378 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0323,
    style: {
      stopColor: "#BBBBBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1627,
    style: {
      stopColor: "#8A8A8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2964,
    style: {
      stopColor: "#5F5F5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4313,
    style: {
      stopColor: "#3D3D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5678,
    style: {
      stopColor: "#222222"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    style: {
      stopColor: "#0F0F0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8487,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000057864872677483498770000012134267440235342219_)"
    },
    cx: 298.85,
    cy: 358.18,
    rx: 2.69,
    ry: 79.82
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000006692126421238195630000016371451815351957636_",
    cx: 399.8826,
    cy: 1509.3058,
    r: 119.6042,
    gradientTransform: "matrix(0 0.4252 -2.1713 0 3575.9788 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0323,
    style: {
      stopColor: "#BBBBBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1627,
    style: {
      stopColor: "#8A8A8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2964,
    style: {
      stopColor: "#5F5F5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4313,
    style: {
      stopColor: "#3D3D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5678,
    style: {
      stopColor: "#222222"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    style: {
      stopColor: "#0F0F0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8487,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000006692126421238195630000016371451815351957636_)",
      strokeWidth: 0.8583,
      strokeMiterlimit: 10
    },
    x1: 298.85,
    y1: 280.84,
    x2: 298.85,
    y2: 424.69
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000088824093029855937730000015987444944069252028_",
    cx: 469.7583,
    cy: 1506.2615,
    r: 162.0312,
    gradientTransform: "matrix(0 0.4252 -0.0743 0 417.4388 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0028F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0634,
    style: {
      stopColor: "#0022CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    style: {
      stopColor: "#001997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2739,
    style: {
      stopColor: "#001169"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3789,
    style: {
      stopColor: "#000B43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4827,
    style: {
      stopColor: "#000626"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5852,
    style: {
      stopColor: "#000311"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6857,
    style: {
      stopColor: "#000104"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7818,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000088824093029855937730000015987444944069252028_)"
    },
    cx: 305.46,
    cy: 382.48,
    rx: 14.18,
    ry: 79.82
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000104694377118348343050000004056464681070567093_",
    cx: 469.7583,
    cy: 1506.2611,
    r: 162.0312,
    gradientTransform: "matrix(0 0.4252 -0.0743 0 417.4388 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0028F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0634,
    style: {
      stopColor: "#0022CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    style: {
      stopColor: "#001997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2739,
    style: {
      stopColor: "#001169"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3789,
    style: {
      stopColor: "#000B43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4827,
    style: {
      stopColor: "#000626"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5852,
    style: {
      stopColor: "#000311"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6857,
    style: {
      stopColor: "#000104"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7818,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000104694377118348343050000004056464681070567093_)"
    },
    cx: 305.46,
    cy: 382.48,
    rx: 14.18,
    ry: 79.82
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000055690143804837405140000005826897128710722471_",
    cx: 469.7583,
    cy: 5205.7568,
    r: 162.0312,
    gradientTransform: "matrix(0 0.4252 -0.0141 0 378.9214 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0323,
    style: {
      stopColor: "#BBBBBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1627,
    style: {
      stopColor: "#8A8A8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2964,
    style: {
      stopColor: "#5F5F5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4313,
    style: {
      stopColor: "#3D3D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5678,
    style: {
      stopColor: "#222222"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    style: {
      stopColor: "#0F0F0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8487,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000055690143804837405140000005826897128710722471_)"
    },
    cx: 305.46,
    cy: 382.48,
    rx: 2.69,
    ry: 79.82
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000155139331005645258010000007752103307148454307_",
    cx: 457.0309,
    cy: 1506.2615,
    r: 119.6042,
    gradientTransform: "matrix(0 0.4252 -2.1713 0 3575.9788 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0323,
    style: {
      stopColor: "#BBBBBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1627,
    style: {
      stopColor: "#8A8A8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2964,
    style: {
      stopColor: "#5F5F5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4313,
    style: {
      stopColor: "#3D3D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5678,
    style: {
      stopColor: "#222222"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    style: {
      stopColor: "#0F0F0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8487,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000155139331005645258010000007752103307148454307_)",
      strokeWidth: 0.8583,
      strokeMiterlimit: 10
    },
    x1: 305.46,
    y1: 305.14,
    x2: 305.46,
    y2: 448.99
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000027603762440645136030000011400173808279620761_",
    cx: 420.1591,
    cy: 1478.0414,
    r: 162.0312,
    gradientTransform: "matrix(0 0.4252 -0.0817 0 350.2393 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0028F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0634,
    style: {
      stopColor: "#0022CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    style: {
      stopColor: "#001997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2739,
    style: {
      stopColor: "#001169"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3789,
    style: {
      stopColor: "#000B43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4827,
    style: {
      stopColor: "#000626"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5852,
    style: {
      stopColor: "#000311"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6857,
    style: {
      stopColor: "#000104"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7818,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000027603762440645136030000011400173808279620761_)"
    },
    cx: 229.42,
    cy: 361.39,
    rx: 15.59,
    ry: 79.82
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000127019368998688095560000003379577921045143432_",
    cx: 420.1591,
    cy: 1478.0414,
    r: 162.0312,
    gradientTransform: "matrix(0 0.4252 -0.0817 0 350.2393 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0028F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0634,
    style: {
      stopColor: "#0022CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    style: {
      stopColor: "#001997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2739,
    style: {
      stopColor: "#001169"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3789,
    style: {
      stopColor: "#000B43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4827,
    style: {
      stopColor: "#000626"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5852,
    style: {
      stopColor: "#000311"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6857,
    style: {
      stopColor: "#000104"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7818,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000127019368998688095560000003379577921045143432_)"
    },
    cx: 229.42,
    cy: 361.39,
    rx: 15.59,
    ry: 79.82
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000161594941755112594000000013070062768948438186_",
    cx: 420.1591,
    cy: 5057.0903,
    r: 162.0312,
    gradientTransform: "matrix(0 0.4252 -0.0155 0 307.8883 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0323,
    style: {
      stopColor: "#BBBBBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1627,
    style: {
      stopColor: "#8A8A8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2964,
    style: {
      stopColor: "#5F5F5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4313,
    style: {
      stopColor: "#3D3D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5678,
    style: {
      stopColor: "#222222"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    style: {
      stopColor: "#0F0F0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8487,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000161594941755112594000000013070062768948438186_)"
    },
    cx: 229.42,
    cy: 361.39,
    rx: 2.96,
    ry: 79.82
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000146500366268018520230000008307356682718127796_",
    cx: 407.4317,
    cy: 1478.0414,
    r: 119.6043,
    gradientTransform: "matrix(0 0.4252 -2.3874 0 3758.0769 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0323,
    style: {
      stopColor: "#BBBBBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1627,
    style: {
      stopColor: "#8A8A8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2964,
    style: {
      stopColor: "#5F5F5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4313,
    style: {
      stopColor: "#3D3D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5678,
    style: {
      stopColor: "#222222"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    style: {
      stopColor: "#0F0F0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8487,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000146500366268018520230000008307356682718127796_)",
      strokeWidth: 0.9,
      strokeMiterlimit: 10
    },
    x1: 229.42,
    y1: 284.05,
    x2: 229.42,
    y2: 427.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000110467076950331403490000009950822734953600150_",
    cx: 477.3074,
    cy: 1474.9971,
    r: 162.0312,
    gradientTransform: "matrix(0 0.4252 -0.0817 0 357.2582 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0028F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0634,
    style: {
      stopColor: "#0022CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    style: {
      stopColor: "#001997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2739,
    style: {
      stopColor: "#001169"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3789,
    style: {
      stopColor: "#000B43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4827,
    style: {
      stopColor: "#000626"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5852,
    style: {
      stopColor: "#000311"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6857,
    style: {
      stopColor: "#000104"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7818,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000110467076950331403490000009950822734953600150_)"
    },
    cx: 236.69,
    cy: 385.69,
    rx: 15.59,
    ry: 79.82
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000119095840551828315050000005748537680289035431_",
    cx: 477.3074,
    cy: 1474.9967,
    r: 162.0312,
    gradientTransform: "matrix(0 0.4252 -0.0817 0 357.2582 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0028F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0634,
    style: {
      stopColor: "#0022CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    style: {
      stopColor: "#001997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2739,
    style: {
      stopColor: "#001169"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3789,
    style: {
      stopColor: "#000B43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4827,
    style: {
      stopColor: "#000626"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5852,
    style: {
      stopColor: "#000311"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6857,
    style: {
      stopColor: "#000104"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7818,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000119095840551828315050000005748537680289035431_)"
    },
    cx: 236.69,
    cy: 385.69,
    rx: 15.59,
    ry: 79.82
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000048465890530461239290000012624113211788513946_",
    cx: 477.3074,
    cy: 5041.0532,
    r: 162.0312,
    gradientTransform: "matrix(0 0.4252 -0.0155 0 314.9072 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0323,
    style: {
      stopColor: "#BBBBBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1627,
    style: {
      stopColor: "#8A8A8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2964,
    style: {
      stopColor: "#5F5F5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4313,
    style: {
      stopColor: "#3D3D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5678,
    style: {
      stopColor: "#222222"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    style: {
      stopColor: "#0F0F0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8487,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000048465890530461239290000012624113211788513946_)"
    },
    cx: 236.69,
    cy: 385.69,
    rx: 2.96,
    ry: 79.82
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000149373531708996770070000016013423569011473550_",
    cx: 464.58,
    cy: 1474.9971,
    r: 119.6043,
    gradientTransform: "matrix(0 0.4252 -2.3874 0 3758.0769 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0323,
    style: {
      stopColor: "#BBBBBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1627,
    style: {
      stopColor: "#8A8A8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2964,
    style: {
      stopColor: "#5F5F5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4313,
    style: {
      stopColor: "#3D3D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5678,
    style: {
      stopColor: "#222222"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    style: {
      stopColor: "#0F0F0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8487,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000149373531708996770070000016013423569011473550_)",
      strokeWidth: 0.9,
      strokeMiterlimit: 10
    },
    x1: 236.69,
    y1: 308.35,
    x2: 236.69,
    y2: 452.2
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st12"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000011739121121489771500000016588036232767609008_",
    cx: 425.0767,
    cy: 1613.4578,
    r: 162.0312,
    gradientTransform: "matrix(0 0.4252 -0.0671 0 353.7518 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0028F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0634,
    style: {
      stopColor: "#0022CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    style: {
      stopColor: "#001997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2739,
    style: {
      stopColor: "#001169"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3789,
    style: {
      stopColor: "#000B43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4827,
    style: {
      stopColor: "#000626"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5852,
    style: {
      stopColor: "#000311"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6857,
    style: {
      stopColor: "#000104"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7818,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000011739121121489771500000016588036232767609008_)"
    },
    cx: 245.52,
    cy: 363.48,
    rx: 12.8,
    ry: 79.82
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000011740096497029270080000016458358603994074270_",
    cx: 425.0767,
    cy: 1613.4578,
    r: 162.0312,
    gradientTransform: "matrix(0 0.4252 -0.0671 0 353.7518 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0028F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0634,
    style: {
      stopColor: "#0022CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    style: {
      stopColor: "#001997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2739,
    style: {
      stopColor: "#001169"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3789,
    style: {
      stopColor: "#000B43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4827,
    style: {
      stopColor: "#000626"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5852,
    style: {
      stopColor: "#000311"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6857,
    style: {
      stopColor: "#000104"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7818,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000011740096497029270080000016458358603994074270_)"
    },
    cx: 245.52,
    cy: 363.48,
    rx: 12.8,
    ry: 79.82
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000175309830693755081720000016508234806550767254_",
    cx: 425.0767,
    cy: 5770.4756,
    r: 162.0312,
    gradientTransform: "matrix(0 0.4252 -0.0127 0 318.9966 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0323,
    style: {
      stopColor: "#BBBBBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1627,
    style: {
      stopColor: "#8A8A8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2964,
    style: {
      stopColor: "#5F5F5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4313,
    style: {
      stopColor: "#3D3D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5678,
    style: {
      stopColor: "#222222"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    style: {
      stopColor: "#0F0F0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8487,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000175309830693755081720000016508234806550767254_)"
    },
    cx: 245.52,
    cy: 363.48,
    rx: 2.43,
    ry: 79.82
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000079486199294856539340000016795765182853324192_",
    cx: 412.3493,
    cy: 1613.4578,
    r: 119.6042,
    gradientTransform: "matrix(0 0.4252 -1.9592 0 3406.6028 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0323,
    style: {
      stopColor: "#BBBBBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1627,
    style: {
      stopColor: "#8A8A8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2964,
    style: {
      stopColor: "#5F5F5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4313,
    style: {
      stopColor: "#3D3D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5678,
    style: {
      stopColor: "#222222"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    style: {
      stopColor: "#0F0F0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8487,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000079486199294856539340000016795765182853324192_)",
      strokeWidth: 0.8153,
      strokeMiterlimit: 10
    },
    x1: 245.52,
    y1: 286.14,
    x2: 245.52,
    y2: 429.99
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000135687023979450761230000014367893301104548224_",
    cx: 482.225,
    cy: 1610.4136,
    r: 162.0312,
    gradientTransform: "matrix(0 0.4252 -0.0671 0 359.5118 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0028F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0634,
    style: {
      stopColor: "#0022CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    style: {
      stopColor: "#001997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2739,
    style: {
      stopColor: "#001169"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3789,
    style: {
      stopColor: "#000B43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4827,
    style: {
      stopColor: "#000626"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5852,
    style: {
      stopColor: "#000311"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6857,
    style: {
      stopColor: "#000104"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7818,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000135687023979450761230000014367893301104548224_)"
    },
    cx: 251.48,
    cy: 387.78,
    rx: 12.8,
    ry: 79.82
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000074401847690440355850000004053129374987532989_",
    cx: 482.225,
    cy: 1610.4131,
    r: 162.0312,
    gradientTransform: "matrix(0 0.4252 -0.0671 0 359.5118 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0028F1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0634,
    style: {
      stopColor: "#0022CD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    style: {
      stopColor: "#001997"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2739,
    style: {
      stopColor: "#001169"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3789,
    style: {
      stopColor: "#000B43"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4827,
    style: {
      stopColor: "#000626"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5852,
    style: {
      stopColor: "#000311"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6857,
    style: {
      stopColor: "#000104"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7818,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000074401847690440355850000004053129374987532989_)"
    },
    cx: 251.48,
    cy: 387.78,
    rx: 12.8,
    ry: 79.82
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000108305174786088518120000015016700604011072408_",
    cx: 482.225,
    cy: 5754.4385,
    r: 162.0312,
    gradientTransform: "matrix(0 0.4252 -0.0127 0 324.7566 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0323,
    style: {
      stopColor: "#BBBBBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1627,
    style: {
      stopColor: "#8A8A8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2964,
    style: {
      stopColor: "#5F5F5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4313,
    style: {
      stopColor: "#3D3D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5678,
    style: {
      stopColor: "#222222"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    style: {
      stopColor: "#0F0F0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8487,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_00000108305174786088518120000015016700604011072408_)"
    },
    cx: 251.48,
    cy: 387.78,
    rx: 2.43,
    ry: 79.82
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000048470160750588810550000002740314439189778591_",
    cx: 469.4976,
    cy: 1610.4136,
    r: 119.6042,
    gradientTransform: "matrix(0 0.4252 -1.9592 0 3406.6028 182.7207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C8C8C8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0323,
    style: {
      stopColor: "#BBBBBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1627,
    style: {
      stopColor: "#8A8A8A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2964,
    style: {
      stopColor: "#5F5F5F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4313,
    style: {
      stopColor: "#3D3D3D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5678,
    style: {
      stopColor: "#222222"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7065,
    style: {
      stopColor: "#0F0F0F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8487,
    style: {
      stopColor: "#040404"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "url(#SVGID_00000048470160750588810550000002740314439189778591_)",
      strokeWidth: 0.8153,
      strokeMiterlimit: 10
    },
    x1: 251.48,
    y1: 310.44,
    x2: 251.48,
    y2: 454.29
  }))))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002358813462877492700000016995459031079687843_",
    gradientUnits: "userSpaceOnUse",
    x1: 339.1274,
    y1: 308.3124,
    x2: 202.2618,
    y2: 396.9037
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCB29"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000002358813462877492700000016995459031079687843_)"
    },
    d: "M310.74,344.02 c-2.45-3.49-6.05-6.65-10.72-9.35c-9.35-5.39-21.35-8-33.34-8c-11.99,0.01-23.98,2.62-33.34,8c-4.67,2.7-8.27,5.86-10.72,9.35 c-2.45,3.48-3.75,7.32-3.74,11.18c0,3.86,1.29,7.7,3.74,11.18c2.45,3.49,6.05,6.65,10.72,9.35c9.35,5.39,21.35,8,33.34,8 c11.99-0.01,23.98-2.62,33.34-8h0c4.67-2.7,8.27-5.86,10.72-9.35c2.45-3.48,3.75-7.32,3.74-11.18 C314.49,351.34,313.19,347.51,310.74,344.02z M307.09,363.82c-2,2.84-5.07,5.61-9.3,8.05l0,0c-8.44,4.88-19.77,7.41-31.1,7.41 c-11.34,0.01-22.66-2.52-31.1-7.41c-4.22-2.44-7.3-5.21-9.3-8.05c-2-2.85-2.93-5.75-2.93-8.62c0-2.87,0.93-5.77,2.93-8.62 c2-2.84,5.07-5.61,9.3-8.05c8.44-4.88,19.77-7.41,31.1-7.41c11.34-0.01,22.66,2.52,31.1,7.41c4.22,2.44,7.3,5.21,9.3,8.05 c2,2.85,2.93,5.75,2.93,8.62C310.01,358.07,309.08,360.97,307.09,363.82z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143618244651856905580000004354435219720457914_",
    gradientUnits: "userSpaceOnUse",
    x1: 194.4749,
    y1: 203.5476,
    x2: 337.9508,
    y2: 203.5476
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000143618244651856905580000004354435219720457914_)"
    },
    d: "M320.69,319.18 c-0.99,7.14-6.23,14.12-15.69,19.59c-21.16,12.21-55.46,12.21-76.62,0c-8.01-4.63-12.99-10.34-14.93-16.32c0,0-0.01-0.01-0.01-0.03 c-0.58-1.12-19.42-37.9-18.95-102.37c0.05-7.45,0.36-15.26,0.99-23.44c5.31-69.15,30.34-119.03,37.04-131.31 c1.06-1.93,1.66-2.93,1.66-2.93l64-3.22c0,0,0.91,1.51,2.46,4.41c7.69,14.42,31.13,63.17,36.25,129.83 c0.68,8.77,1,17.12,1.06,25.06C338.4,282.91,320.69,319.18,320.69,319.18z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136413559870200723580000004175424326620718526_",
    gradientUnits: "userSpaceOnUse",
    x1: 494.9272,
    y1: 219.3988,
    x2: 166.2906,
    y2: 191.5482
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000136413559870200723580000004175424326620718526_)"
    },
    d: "M337.94,218.45 c-0.39,61.56-17.26,96.08-17.26,96.08c-0.99,7.14-6.23,14.12-15.69,19.59c-21.16,12.21-55.46,12.21-76.62,0 c-8.01-4.63-12.99-10.34-14.93-16.32c0,0-0.01-0.01-0.01-0.03c-0.57-1.09-18.52-36.13-18.95-97.71c0.05-7.45,0.36-15.26,0.99-23.44 c5.31-69.15,30.34-119.03,37.04-131.31c1.06-1.93,1.66-2.93,1.66-2.93l64-3.22c0,0,0.91,1.51,2.46,4.41 c7.69,14.42,31.13,63.17,36.25,129.83C337.56,202.16,337.89,210.52,337.94,218.45z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M317.55,80.92c-2.84-4.04-6.99-7.69-12.39-10.81c-0.47-0.27-0.95-0.54-1.43-0.8 c-0.06-0.03-0.12-0.06-0.19-0.09c1.09,2.08,3.49,7.26,4.31,9.15c0.12,0.1,0.24,0.2,0.37,0.31c0.55,0.46,1.08,0.93,1.57,1.4 c1.34,1.27,2.47,2.58,3.39,3.9c2.29,3.27,3.36,6.6,3.36,9.88c0,3.29-1.07,6.61-3.36,9.88c-2.29,3.27-5.83,6.45-10.69,9.26 c-9.67,5.59-22.63,8.54-35.61,8.53c-13.13,0.01-26.27-2.88-36.03-8.53c-4.85-2.8-8.39-5.98-10.69-9.23 c-2.3-3.26-3.37-6.57-3.37-9.85c0-3.3,1.07-6.64,3.36-9.92c1.11-1.59,2.52-3.16,4.23-4.68c0.8-0.71,0.99-1.01,1.93-1.69l4.26-8.8 c-0.5,0.26-1,0.51-1.49,0.79c-0.3,0.16-0.59,0.33-0.88,0.5c-5.41,3.13-9.57,6.79-12.4,10.84c-2.83,4.04-4.32,8.49-4.32,12.97 c0,4.47,1.5,8.9,4.34,12.92c2.84,4.02,6.99,7.67,12.37,10.78c10.86,6.26,24.79,9.23,38.69,9.24c13.77-0.01,27.53-3.05,38.27-9.24 l0,0c5.4-3.12,9.55-6.77,12.39-10.81c2.84-4.03,4.33-8.47,4.33-12.94C321.88,89.39,320.39,84.95,317.55,80.92z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M290.84,79.78c-13.34,7.7-34.98,7.7-48.33,0c-6.9-3.98-10.22-9.24-10-14.47c1.06-1.93,1.66-2.93,1.66-2.93 l64-3.22c0,0,0.91,1.51,2.46,4.41C301.78,69.34,298.52,75.35,290.84,79.78z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049193180092222495920000017026567775828122038_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.8158,
    y1: 36.2675,
    x2: 283.728,
    y2: 85.296
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000049193180092222495920000017026567775828122038_)"
    },
    d: "M294.47,52.76L294.47,52.76l-15.67-15.74 c-6.69-6.72-17.56-6.72-24.25,0c-7.7,7.73-16.27,16.33-16.53,16.6c-0.95,1.01-1.73,2.05-2.35,3.12l-0.02,0.02l0.01,0 c-3.72,6.54-1.09,14.02,7.92,19.23c12.75,7.36,33.43,7.36,46.18,0C300.69,69.68,302.25,60.02,294.47,52.76z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008834142945009003020000010069087206135982235_",
    gradientUnits: "userSpaceOnUse",
    x1: 440.288,
    y1: 268.1072,
    x2: 318.6245,
    y2: 299.9378
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008834142945009003020000010069087206135982235_)"
    },
    d: "M316.64,195.66l-9.62,3.24 c6.51,41.05,15.15,98.69,10.66,130.7c12.03,8.98,19.54,24.34,22.71,43.21l20.67,20.83c3.19-2.15,5.84-4.44,7.51-6.96 c0,0-9.23-124.65-18.1-150.56S316.64,195.66,316.64,195.66z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111165831043633510830000001612754109882359739_",
    gradientUnits: "userSpaceOnUse",
    x1: 307.4904,
    y1: 189.3905,
    x2: 348.338,
    y2: 397.8718
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111165831043633510830000001612754109882359739_)"
    },
    d: "M307.02,198.89 c7.73,41.58,7.71,101.28,2.96,135.15c12.03,8.98,19.54,24.34,22.71,43.21l28.37,16.38c0,0-9.42-127.17-18.29-153.08 S307.02,198.89,307.02,198.89z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152978447501855283120000003465485917305793718_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.1149,
    y1: 263.3051,
    x2: 197.8709,
    y2: 295.93
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000152978447501855283120000003465485917305793718_)"
    },
    d: "M216.12,195.66l9.62,3.24 c-6.51,41.05-15.15,98.69-10.66,130.7c-12.03,8.98-19.54,24.34-22.71,43.21l-20.67,20.83c-2.95-2.44-5.47-5.15-7.41-8.22 c0,0,9.14-123.39,18-149.3S216.12,195.66,216.12,195.66z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000010289788987571984660000006027738839130360712_",
    gradientUnits: "userSpaceOnUse",
    x1: 226.5216,
    y1: 184.5427,
    x2: 178.2473,
    y2: 427.5057
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000010289788987571984660000006027738839130360712_)"
    },
    d: "M225.74,198.89 c-7.73,41.58-7.71,101.28-2.96,135.15c-12.03,8.98-19.54,24.34-22.71,43.21l-28.37,16.38c0,0,9.42-127.17,18.29-153.08 S225.74,198.89,225.74,198.89z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000120560195130523237750000014148424001775750805_",
    gradientUnits: "userSpaceOnUse",
    x1: 3583.5032,
    y1: 267.7769,
    x2: 3556.9622,
    y2: 257.0995,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000120560195130523237750000014148424001775750805_)"
    },
    points: "455.19,260.87 443.6,254.25  429.12,262.54 440.71,269.24  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000048485445466526035410000006017494894270110364_",
    gradientUnits: "userSpaceOnUse",
    x1: 3552.2896,
    y1: 259.838,
    x2: 3578.5293,
    y2: 310.19,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "url(#SVGID_00000048485445466526035410000006017494894270110364_)"
    },
    points: "455.13,290.54 455.19,260.86  440.7,269.23 440.65,298.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000096039354526883956800000004392229167533868169_",
    gradientUnits: "userSpaceOnUse",
    x1: 3569.9504,
    y1: 280.7189,
    x2: 3581.655,
    y2: 280.7189,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "url(#SVGID_00000096039354526883956800000004392229167533868169_)"
    },
    points: "440.65,298.9 440.7,269.23  429.11,262.54 429,292.18  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136376385249727727530000012944386065774833327_",
    gradientUnits: "userSpaceOnUse",
    x1: 3566.8162,
    y1: 280.2078,
    x2: 3540.2754,
    y2: 269.5305,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000136376385249727727530000012944386065774833327_)"
    },
    points: "471.88,273.3 460.29,266.68  445.8,274.98 457.39,281.67  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000100383366507701997580000009497844015551555246_",
    gradientUnits: "userSpaceOnUse",
    x1: 3536.2432,
    y1: 272.0995,
    x2: 3560.8743,
    y2: 319.3644,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "url(#SVGID_00000100383366507701997580000009497844015551555246_)"
    },
    points: "471.82,300.17 471.88,273.29  457.39,281.66 457.33,308.54  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000143596953459272582670000003075065121676685744_",
    gradientUnits: "userSpaceOnUse",
    x1: 3553.2637,
    y1: 291.7515,
    x2: 3564.9683,
    y2: 291.7515,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "url(#SVGID_00000143596953459272582670000003075065121676685744_)"
    },
    points: "457.33,308.54 457.39,281.66  445.8,274.97 445.69,301.81  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000051352365080925097990000001106857700105567907_",
    gradientUnits: "userSpaceOnUse",
    x1: 3550.1294,
    y1: 281.586,
    x2: 3523.5884,
    y2: 270.9086,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000051352365080925097990000001106857700105567907_)"
    },
    points: "488.57,274.68 476.98,268.05  462.49,276.35 474.08,283.04  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000040543542277225808660000014778438078545084575_",
    gradientUnits: "userSpaceOnUse",
    x1: 3517.666,
    y1: 273.978,
    x2: 3547.0459,
    y2: 330.3556,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "url(#SVGID_00000040543542277225808660000014778438078545084575_)"
    },
    points: "488.51,309.81 488.56,274.67  474.08,283.04 474.02,318.17  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000135692407955125671670000002126052963359792012_",
    gradientUnits: "userSpaceOnUse",
    x1: 3536.5769,
    y1: 297.2577,
    x2: 3548.2815,
    y2: 297.2577,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "url(#SVGID_00000135692407955125671670000002126052963359792012_)"
    },
    points: "474.02,318.17 474.08,283.04  462.49,276.35 462.37,311.45  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049907280577790745630000012171173855067037106_",
    gradientUnits: "userSpaceOnUse",
    x1: 3533.4426,
    y1: 309.1723,
    x2: 3506.9016,
    y2: 298.4949,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000049907280577790745630000012171173855067037106_)"
    },
    points: "505.25,302.27 493.66,295.64  479.18,303.94 490.77,310.63  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098196547164453549810000018406613179938724766_",
    gradientUnits: "userSpaceOnUse",
    x1: 3505.0898,
    y1: 300.4763,
    x2: 3524.1436,
    y2: 337.039,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "url(#SVGID_00000098196547164453549810000018406613179938724766_)"
    },
    points: "505.19,319.44 505.25,302.26  490.76,310.62 490.71,327.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124846110317782037510000011780407654365348543_",
    gradientUnits: "userSpaceOnUse",
    x1: 3519.8901,
    y1: 315.8679,
    x2: 3531.5947,
    y2: 315.8679,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "url(#SVGID_00000124846110317782037510000011780407654365348543_)"
    },
    points: "490.71,327.8 490.76,310.62  479.17,303.93 479.06,321.08  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000134945864375040554500000015025605650456469895_",
    gradientUnits: "userSpaceOnUse",
    x1: 3516.7559,
    y1: 327.7209,
    x2: 3490.2148,
    y2: 317.0435,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000134945864375040554500000015025605650456469895_)"
    },
    points: "521.94,320.82 510.35,314.19  495.86,322.49 507.45,329.18  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000125585187883297129310000001457138166323848086_",
    gradientUnits: "userSpaceOnUse",
    x1: 3490.4441,
    y1: 318.4845,
    x2: 3504.3704,
    y2: 345.2079,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "url(#SVGID_00000125585187883297129310000001457138166323848086_)"
    },
    points: "521.88,329.07 521.94,320.81  507.45,329.17 507.39,337.44  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035494623012431432440000011534902403272593304_",
    gradientUnits: "userSpaceOnUse",
    x1: 3503.2034,
    y1: 329.9592,
    x2: 3514.9077,
    y2: 329.9592,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "url(#SVGID_00000035494623012431432440000011534902403272593304_)"
    },
    points: "507.39,337.44 507.45,329.17  495.86,322.48 495.75,330.71  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062181848315471519080000017431879980022195117_",
    gradientUnits: "userSpaceOnUse",
    x1: 3500.0688,
    y1: 338.6929,
    x2: 3473.5281,
    y2: 328.0155,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000062181848315471519080000017431879980022195117_)"
    },
    points: "538.63,331.79 527.04,325.16  512.55,333.46 524.14,340.15  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009568570594956270640000008748431263018214025_",
    gradientUnits: "userSpaceOnUse",
    x1: 3474.0637,
    y1: 329.3755,
    x2: 3487.2205,
    y2: 354.6221,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "url(#SVGID_00000009568570594956270640000008748431263018214025_)"
    },
    points: "538.57,338.71 538.62,331.78  524.14,340.14 524.08,347.07  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000152964284331070060060000009529148581980454823_",
    gradientUnits: "userSpaceOnUse",
    x1: 3486.5164,
    y1: 340.2623,
    x2: 3498.2209,
    y2: 340.2623,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "url(#SVGID_00000152964284331070060060000009529148581980454823_)"
    },
    points: "524.08,347.07 524.14,340.14  512.55,333.45 512.43,340.35  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000172397997102544364040000017407827199003407005_",
    gradientUnits: "userSpaceOnUse",
    x1: 3483.3821,
    y1: 325.5817,
    x2: 3456.8413,
    y2: 314.9043,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000172397997102544364040000017407827199003407005_)"
    },
    points: "555.31,318.68 543.72,312.05  529.24,320.35 540.83,327.04  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000159464539827826876300000013628490527912295857_",
    gradientUnits: "userSpaceOnUse",
    x1: 3452.1687,
    y1: 317.6428,
    x2: 3478.4084,
    y2: 367.9949,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "url(#SVGID_00000159464539827826876300000013628490527912295857_)"
    },
    points: "555.25,348.34 555.31,318.67  540.82,327.03 540.77,356.71  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041286813324088356200000007160779025682655924_",
    gradientUnits: "userSpaceOnUse",
    x1: 3469.8296,
    y1: 338.5238,
    x2: 3481.5342,
    y2: 338.5238,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "url(#SVGID_00000041286813324088356200000007160779025682655924_)"
    },
    points: "540.77,356.71 540.82,327.03  529.23,320.34 529.12,349.98  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000035514796790959138240000014525053401355212199_",
    gradientUnits: "userSpaceOnUse",
    x1: 3565.8828,
    y1: 127.6967,
    x2: 3570.2134,
    y2: 160.7959,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7D57C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0766,
    style: {
      stopColor: "#8B6CCD",
      stopOpacity: 0.9104
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2527,
    style: {
      stopColor: "#A898DE",
      stopOpacity: 0.7044
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4232,
    style: {
      stopColor: "#BFBAEC",
      stopOpacity: 0.5049
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5843,
    style: {
      stopColor: "#D0D2F6",
      stopOpacity: 0.3164
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    style: {
      stopColor: "#DAE1FC",
      stopOpacity: 0.1433
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8547,
    style: {
      stopColor: "#DDE6FE",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000035514796790959138240000014525053401355212199_)"
    },
    points: "455.19,146.85 443.6,140.23  429.12,148.53 440.71,155.22  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060716052422977115930000011021914029151214781_",
    gradientUnits: "userSpaceOnUse",
    x1: 3517.79,
    y1: 187.7109,
    x2: 3591.6772,
    y2: 245.5168,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7D57C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0766,
    style: {
      stopColor: "#8B6CCD",
      stopOpacity: 0.9104
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2527,
    style: {
      stopColor: "#A898DE",
      stopOpacity: 0.7044
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4232,
    style: {
      stopColor: "#BFBAEC",
      stopOpacity: 0.5049
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5843,
    style: {
      stopColor: "#D0D2F6",
      stopOpacity: 0.3164
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    style: {
      stopColor: "#DAE1FC",
      stopOpacity: 0.1433
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8547,
    style: {
      stopColor: "#DDE6FE",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000060716052422977115930000011021914029151214781_)"
    },
    points: "455.13,290.54 455.19,146.85  440.7,155.21 440.65,298.9  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000049937659402963181140000003673780941576245645_",
    gradientUnits: "userSpaceOnUse",
    x1: 3614.4851,
    y1: 213.6333,
    x2: 3549.2913,
    y2: 230.6044,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7D57C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0766,
    style: {
      stopColor: "#8B6CCD",
      stopOpacity: 0.9104
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2527,
    style: {
      stopColor: "#A898DE",
      stopOpacity: 0.7044
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4232,
    style: {
      stopColor: "#BFBAEC",
      stopOpacity: 0.5049
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5843,
    style: {
      stopColor: "#D0D2F6",
      stopOpacity: 0.3164
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    style: {
      stopColor: "#DAE1FC",
      stopOpacity: 0.1433
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8547,
    style: {
      stopColor: "#DDE6FE",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000049937659402963181140000003673780941576245645_)"
    },
    points: "429.11,148.52 429,292.18  440.65,298.9 440.7,155.21  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000079448454122342107300000002039615965992535941_",
    gradientUnits: "userSpaceOnUse",
    x1: 3549.1958,
    y1: 191.0966,
    x2: 3553.5266,
    y2: 224.1958,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7D57C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0766,
    style: {
      stopColor: "#8B6CCD",
      stopOpacity: 0.9104
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2527,
    style: {
      stopColor: "#A898DE",
      stopOpacity: 0.7044
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4232,
    style: {
      stopColor: "#BFBAEC",
      stopOpacity: 0.5049
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5843,
    style: {
      stopColor: "#D0D2F6",
      stopOpacity: 0.3164
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    style: {
      stopColor: "#DAE1FC",
      stopOpacity: 0.1433
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8547,
    style: {
      stopColor: "#DDE6FE",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000079448454122342107300000002039615965992535941_)"
    },
    points: "471.88,210.25 460.29,203.63  445.8,211.93 457.39,218.62  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000156587449516872740090000011140227273532410029_",
    gradientUnits: "userSpaceOnUse",
    x1: 3515.2664,
    y1: 235.3125,
    x2: 3565.8704,
    y2: 274.9027,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7D57C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0766,
    style: {
      stopColor: "#8B6CCD",
      stopOpacity: 0.9104
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2527,
    style: {
      stopColor: "#A898DE",
      stopOpacity: 0.7044
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4232,
    style: {
      stopColor: "#BFBAEC",
      stopOpacity: 0.5049
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5843,
    style: {
      stopColor: "#D0D2F6",
      stopOpacity: 0.3164
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    style: {
      stopColor: "#DAE1FC",
      stopOpacity: 0.1433
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8547,
    style: {
      stopColor: "#DDE6FE",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000156587449516872740090000011140227273532410029_)"
    },
    points: "471.82,300.17 471.88,210.25  457.39,218.62 457.33,308.54  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041975143890005840140000003586012140228075674_",
    gradientUnits: "userSpaceOnUse",
    x1: 3587.1062,
    y1: 252.9377,
    x2: 3539.9192,
    y2: 265.2213,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7D57C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0766,
    style: {
      stopColor: "#8B6CCD",
      stopOpacity: 0.9104
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2527,
    style: {
      stopColor: "#A898DE",
      stopOpacity: 0.7044
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4232,
    style: {
      stopColor: "#BFBAEC",
      stopOpacity: 0.5049
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5843,
    style: {
      stopColor: "#D0D2F6",
      stopOpacity: 0.3164
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    style: {
      stopColor: "#DAE1FC",
      stopOpacity: 0.1433
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8547,
    style: {
      stopColor: "#DDE6FE",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000041975143890005840140000003586012140228075674_)"
    },
    points: "445.8,211.93 445.69,301.81  457.33,308.54 457.39,218.62  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000064312305413414593200000004820621017957444277_",
    gradientUnits: "userSpaceOnUse",
    x1: 3532.509,
    y1: 233.5279,
    x2: 3536.8398,
    y2: 266.6271,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7D57C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0766,
    style: {
      stopColor: "#8B6CCD",
      stopOpacity: 0.9104
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2527,
    style: {
      stopColor: "#A898DE",
      stopOpacity: 0.7044
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4232,
    style: {
      stopColor: "#BFBAEC",
      stopOpacity: 0.5049
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5843,
    style: {
      stopColor: "#D0D2F6",
      stopOpacity: 0.3164
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    style: {
      stopColor: "#DAE1FC",
      stopOpacity: 0.1433
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8547,
    style: {
      stopColor: "#DDE6FE",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000064312305413414593200000004820621017957444277_)"
    },
    points: "488.57,252.69 476.98,246.06  462.49,254.36 474.08,261.05  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009581605050884946630000004795866650076456334_",
    gradientUnits: "userSpaceOnUse",
    x1: 3507.2156,
    y1: 268.0976,
    x2: 3543.6226,
    y2: 296.5807,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7D57C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0766,
    style: {
      stopColor: "#8B6CCD",
      stopOpacity: 0.9104
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2527,
    style: {
      stopColor: "#A898DE",
      stopOpacity: 0.7044
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4232,
    style: {
      stopColor: "#BFBAEC",
      stopOpacity: 0.5049
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5843,
    style: {
      stopColor: "#D0D2F6",
      stopOpacity: 0.3164
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    style: {
      stopColor: "#DAE1FC",
      stopOpacity: 0.1433
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8547,
    style: {
      stopColor: "#DDE6FE",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000009581605050884946630000004795866650076456334_)"
    },
    points: "488.51,309.81 488.56,252.68  474.08,261.04 474.02,318.17  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160904349793851110200000015197944231172844450_",
    gradientUnits: "userSpaceOnUse",
    x1: 3563.8997,
    y1: 280.6636,
    x2: 3527.6926,
    y2: 290.0889,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7D57C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0766,
    style: {
      stopColor: "#8B6CCD",
      stopOpacity: 0.9104
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2527,
    style: {
      stopColor: "#A898DE",
      stopOpacity: 0.7044
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4232,
    style: {
      stopColor: "#BFBAEC",
      stopOpacity: 0.5049
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5843,
    style: {
      stopColor: "#D0D2F6",
      stopOpacity: 0.3164
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    style: {
      stopColor: "#DAE1FC",
      stopOpacity: 0.1433
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8547,
    style: {
      stopColor: "#DDE6FE",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000160904349793851110200000015197944231172844450_)"
    },
    points: "462.49,254.35 462.37,311.45  474.02,318.17 474.08,261.04  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106830832838187395290000013233848378460662460_",
    gradientUnits: "userSpaceOnUse",
    x1: 3515.8223,
    y1: 171.4655,
    x2: 3520.1531,
    y2: 204.5648,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7D57C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0766,
    style: {
      stopColor: "#8B6CCD",
      stopOpacity: 0.9104
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2527,
    style: {
      stopColor: "#A898DE",
      stopOpacity: 0.7044
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4232,
    style: {
      stopColor: "#BFBAEC",
      stopOpacity: 0.5049
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5843,
    style: {
      stopColor: "#D0D2F6",
      stopOpacity: 0.3164
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    style: {
      stopColor: "#DAE1FC",
      stopOpacity: 0.1433
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8547,
    style: {
      stopColor: "#DDE6FE",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000106830832838187395290000013233848378460662460_)"
    },
    points: "505.25,190.62 493.66,184  479.18,192.3 490.77,198.99  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000149355460296551706460000015301148967787745187_",
    gradientUnits: "userSpaceOnUse",
    x1: 3471.6453,
    y1: 227.1099,
    x2: 3539.0955,
    y2: 279.8799,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7D57C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0766,
    style: {
      stopColor: "#8B6CCD",
      stopOpacity: 0.9104
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2527,
    style: {
      stopColor: "#A898DE",
      stopOpacity: 0.7044
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4232,
    style: {
      stopColor: "#BFBAEC",
      stopOpacity: 0.5049
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5843,
    style: {
      stopColor: "#D0D2F6",
      stopOpacity: 0.3164
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    style: {
      stopColor: "#DAE1FC",
      stopOpacity: 0.1433
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8547,
    style: {
      stopColor: "#DDE6FE",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000149355460296551706460000015301148967787745187_)"
    },
    points: "505.19,319.44 505.25,190.61  490.76,198.98 490.71,327.8  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101077387434175004850000009017443136844831105_",
    gradientUnits: "userSpaceOnUse",
    x1: 3561.4688,
    y1: 250.7384,
    x2: 3501.2532,
    y2: 266.4136,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7D57C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0766,
    style: {
      stopColor: "#8B6CCD",
      stopOpacity: 0.9104
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2527,
    style: {
      stopColor: "#A898DE",
      stopOpacity: 0.7044
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4232,
    style: {
      stopColor: "#BFBAEC",
      stopOpacity: 0.5049
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5843,
    style: {
      stopColor: "#D0D2F6",
      stopOpacity: 0.3164
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    style: {
      stopColor: "#DAE1FC",
      stopOpacity: 0.1433
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8547,
    style: {
      stopColor: "#DDE6FE",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000101077387434175004850000009017443136844831105_)"
    },
    points: "479.17,192.29 479.06,321.08  490.71,327.8 490.76,198.98  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007386435539205332830000000527779892836298656_",
    gradientUnits: "userSpaceOnUse",
    x1: 3499.1355,
    y1: 263.0179,
    x2: 3503.4661,
    y2: 296.1172,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7D57C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0766,
    style: {
      stopColor: "#8B6CCD",
      stopOpacity: 0.9104
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2527,
    style: {
      stopColor: "#A898DE",
      stopOpacity: 0.7044
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4232,
    style: {
      stopColor: "#BFBAEC",
      stopOpacity: 0.5049
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5843,
    style: {
      stopColor: "#D0D2F6",
      stopOpacity: 0.3164
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    style: {
      stopColor: "#DAE1FC",
      stopOpacity: 0.1433
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8547,
    style: {
      stopColor: "#DDE6FE",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000007386435539205332830000000527779892836298656_)"
    },
    points: "521.94,282.18 510.35,275.55  495.86,283.85 507.45,290.54  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106118499280861854500000018324803985325466256_",
    gradientUnits: "userSpaceOnUse",
    x1: 3476.5339,
    y1: 294.5829,
    x2: 3508.5151,
    y2: 319.6035,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7D57C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0766,
    style: {
      stopColor: "#8B6CCD",
      stopOpacity: 0.9104
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2527,
    style: {
      stopColor: "#A898DE",
      stopOpacity: 0.7044
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4232,
    style: {
      stopColor: "#BFBAEC",
      stopOpacity: 0.5049
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5843,
    style: {
      stopColor: "#D0D2F6",
      stopOpacity: 0.3164
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    style: {
      stopColor: "#DAE1FC",
      stopOpacity: 0.1433
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8547,
    style: {
      stopColor: "#DDE6FE",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000106118499280861854500000018324803985325466256_)"
    },
    points: "521.88,329.07 521.94,282.17  507.45,290.53 507.39,337.44  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058578841785186221020000008355663530292708229_",
    gradientUnits: "userSpaceOnUse",
    x1: 3528.4934,
    y1: 305.5718,
    x2: 3495.7095,
    y2: 314.106,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7D57C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0766,
    style: {
      stopColor: "#8B6CCD",
      stopOpacity: 0.9104
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2527,
    style: {
      stopColor: "#A898DE",
      stopOpacity: 0.7044
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4232,
    style: {
      stopColor: "#BFBAEC",
      stopOpacity: 0.5049
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5843,
    style: {
      stopColor: "#D0D2F6",
      stopOpacity: 0.3164
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    style: {
      stopColor: "#DAE1FC",
      stopOpacity: 0.1433
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8547,
    style: {
      stopColor: "#DDE6FE",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000058578841785186221020000008355663530292708229_)"
    },
    points: "495.86,283.84 495.75,330.71  507.39,337.44 507.45,290.53  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000058552867818209514810000004347367441163182269_",
    gradientUnits: "userSpaceOnUse",
    x1: 3482.4485,
    y1: 219.7802,
    x2: 3486.7793,
    y2: 252.8795,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7D57C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0766,
    style: {
      stopColor: "#8B6CCD",
      stopOpacity: 0.9104
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2527,
    style: {
      stopColor: "#A898DE",
      stopOpacity: 0.7044
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4232,
    style: {
      stopColor: "#BFBAEC",
      stopOpacity: 0.5049
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5843,
    style: {
      stopColor: "#D0D2F6",
      stopOpacity: 0.3164
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    style: {
      stopColor: "#DAE1FC",
      stopOpacity: 0.1433
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8547,
    style: {
      stopColor: "#DDE6FE",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000058552867818209514810000004347367441163182269_)"
    },
    points: "538.63,238.94 527.04,232.31  512.55,240.61 524.14,247.3  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047030575929461238430000015220979987382486913_",
    gradientUnits: "userSpaceOnUse",
    x1: 3445.9219,
    y1: 266.8866,
    x2: 3500.7957,
    y2: 309.8172,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0126,
    style: {
      stopColor: "#7D57C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.088,
    style: {
      stopColor: "#8B6CCD",
      stopOpacity: 0.9104
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2615,
    style: {
      stopColor: "#A898DE",
      stopOpacity: 0.7044
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    style: {
      stopColor: "#BFBAEC",
      stopOpacity: 0.5049
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5883,
    style: {
      stopColor: "#D0D2F6",
      stopOpacity: 0.3164
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7341,
    style: {
      stopColor: "#DAE1FC",
      stopOpacity: 0.1433
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8547,
    style: {
      stopColor: "#DDE6FE",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000047030575929461238430000015220979987382486913_)"
    },
    points: "538.57,338.71 538.62,238.93  524.14,247.29 524.08,347.07  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000056403067307435575850000002846059835541933440_",
    gradientUnits: "userSpaceOnUse",
    x1: 3465.7617,
    y1: 286.0848,
    x2: 3470.0925,
    y2: 319.1841,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7D57C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0766,
    style: {
      stopColor: "#8B6CCD",
      stopOpacity: 0.9104
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2527,
    style: {
      stopColor: "#A898DE",
      stopOpacity: 0.7044
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4232,
    style: {
      stopColor: "#BFBAEC",
      stopOpacity: 0.5049
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5843,
    style: {
      stopColor: "#D0D2F6",
      stopOpacity: 0.3164
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    style: {
      stopColor: "#DAE1FC",
      stopOpacity: 0.1433
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8547,
    style: {
      stopColor: "#DDE6FE",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000056403067307435575850000002846059835541933440_)"
    },
    points: "555.31,305.24 543.72,298.62  529.24,306.92 540.83,313.61  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000032608270842657513850000012569886437549319070_",
    gradientUnits: "userSpaceOnUse",
    x1: 3444.1609,
    y1: 316.5333,
    x2: 3474.4973,
    y2: 340.2671,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7D57C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0766,
    style: {
      stopColor: "#8B6CCD",
      stopOpacity: 0.9104
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2527,
    style: {
      stopColor: "#A898DE",
      stopOpacity: 0.7044
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4232,
    style: {
      stopColor: "#BFBAEC",
      stopOpacity: 0.5049
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5843,
    style: {
      stopColor: "#D0D2F6",
      stopOpacity: 0.3164
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    style: {
      stopColor: "#DAE1FC",
      stopOpacity: 0.1433
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8547,
    style: {
      stopColor: "#DDE6FE",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000032608270842657513850000012569886437549319070_)"
    },
    points: "555.25,348.34 555.31,305.23  540.82,313.6 540.77,356.71  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000047027060398489691020000008911396581542270355_",
    gradientUnits: "userSpaceOnUse",
    x1: 3494.3645,
    y1: 326.936,
    x2: 3462.8525,
    y2: 335.1391,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7D57C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0766,
    style: {
      stopColor: "#8B6CCD",
      stopOpacity: 0.9104
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2527,
    style: {
      stopColor: "#A898DE",
      stopOpacity: 0.7044
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4232,
    style: {
      stopColor: "#BFBAEC",
      stopOpacity: 0.5049
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5843,
    style: {
      stopColor: "#D0D2F6",
      stopOpacity: 0.3164
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7323,
    style: {
      stopColor: "#DAE1FC",
      stopOpacity: 0.1433
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8547,
    style: {
      stopColor: "#DDE6FE",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000047027060398489691020000008911396581542270355_)"
    },
    points: "529.23,306.91 529.12,349.98  540.77,356.71 540.82,313.6  "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000030466696798761112340000014394104715006392252_",
    gradientUnits: "userSpaceOnUse",
    x1: 3522.3196,
    y1: 286.0334,
    x2: 3471.8306,
    y2: 299.1765,
    gradientTransform: "matrix(-1 0 0 1 4010.6536 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0126,
    style: {
      stopColor: "#7D57C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.088,
    style: {
      stopColor: "#8B6CCD",
      stopOpacity: 0.9104
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2615,
    style: {
      stopColor: "#A898DE",
      stopOpacity: 0.7044
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4295,
    style: {
      stopColor: "#BFBAEC",
      stopOpacity: 0.5049
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5883,
    style: {
      stopColor: "#D0D2F6",
      stopOpacity: 0.3164
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7341,
    style: {
      stopColor: "#DAE1FC",
      stopOpacity: 0.1433
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8547,
    style: {
      stopColor: "#DDE6FE",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000030466696798761112340000014394104715006392252_)"
    },
    points: "512.55,240.6 512.43,340.35  524.08,347.07 524.14,247.29  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M83.22,286.03l0.12-0.15l0.02-0.03l4-2.14c-0.44-3.01-0.4-2.78-0.84-5.77l-5.78-4.03 c-0.81-2.2-1.09-2.96-1.91-5.16l2.65-4.44c-1.75-2.94-1.61-2.72-3.37-5.65l-5.03,0.45c-1.54-1.73-2.08-2.34-3.61-4.08l-0.9-7.15 c-2.4-1.75-2.22-1.61-4.61-3.36l-4.01,2.31l1.65,2.46c-1.06-0.39-1.69-0.61-2.43-0.89c-0.42-0.15-0.89-0.32-1.51-0.54l-4.1-7.13 c-2.13,0.1-1.96,0.1-4.09,0.2l-4.01,2.31l5.22,4.95c-1.17,0.75-1.58,1.01-2.75,1.76l-1.54-1.18l-4.2-3.2l-4.01,2.31 c-0.01,0.01-0.01,0.01-0.01,0.02c0,0.63,6.33,8.33,6.33,8.33c-0.22,1.82-0.3,2.46-0.52,4.28l-3.74,0.03l-1.45,0.01l-4.01,2.31 l10.64,7.49c0.81,2.2,1.09,2.97,1.9,5.16l-2.65,4.44c1.76,2.94,1.62,2.72,3.37,5.66l5.03-0.46c1.54,1.73,2.08,2.34,3.62,4.08 l1.5,12.83l4-2.31l0.78-1.57l1.58-3.2c1.68,0.61,2.26,0.83,3.94,1.44l4.18,9.23l4.01-2.31l-0.92-5.54l-0.29-1.73 c1.18-0.75,4.49,4.93,4.49,4.93l4.01-2.31c1.04-1.92,0.96-1.78,2-3.69l-4.32-6.99L83.22,286.03z M66.3,281.7 c-0.14,0.03-0.29,0.04-0.44,0.06c-4,0.36-9.13-4.19-11.45-10.15c-1.17-3.01-1.4-5.81-0.82-7.89c0.14-0.03,0.29-0.04,0.44-0.06 c4-0.36,9.13,4.18,11.45,10.15C66.65,276.82,66.88,279.62,66.3,281.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121242015865008917000000016033742400523390863_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.5276,
    y1: 258.9767,
    x2: 6.2183,
    y2: 298.8948
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121242015865008917000000016033742400523390863_)"
    },
    d: "M83.22,286.03h0.14 c-0.01-0.05-0.01-0.1-0.02-0.15c-0.42-2.84-0.39-2.68-0.83-5.63l-5.78-4.03c-0.81-2.2-1.09-2.96-1.9-5.16l2.65-4.44 c-1.76-2.94-1.62-2.72-3.38-5.65l-5.03,0.45c-1.54-1.73-2.07-2.34-3.61-4.08l-0.9-7.14c-2.4-1.76-2.22-1.62-4.61-3.37l-0.77,1.57 l-1.59,3.2c-1.67-0.61-2.25-0.82-3.94-1.43l-4.1-7.13c-2.13,0.1-1.96,0.1-4.09,0.2l0.93,5.54l0.29,1.73 c-1.18,0.74-1.58,1-2.76,1.76l-5.74-4.38c-0.01,0.01-0.01,0.01-0.01,0.02c-1.03,1.9-0.97,1.76-2,3.67l4.32,6.98 c-0.1,0.85-0.17,1.43-0.25,1.99c-0.07,0.67-0.16,1.3-0.28,2.28l-5.19,0.04c0.44,3,0.41,2.77,0.85,5.77l5.78,4.03 c0.81,2.2,1.09,2.97,1.9,5.16l-2.65,4.45c1.76,2.93,1.62,2.71,3.38,5.65l5.03-0.46c1.53,1.74,2.07,2.34,3.61,4.08l0.9,7.15 c2.4,1.75,2.21,1.61,4.61,3.36l2.36-4.77c1.06,0.39,1.69,0.62,2.43,0.89c0.42,0.16,0.89,0.33,1.5,0.55l4.11,7.12 c2.12-0.1,1.96-0.1,4.09-0.2l-1.21-7.26c1.18-0.75,1.58-1.01,2.76-1.76l1.54,1.18l4.2,3.21c1.04-1.92,0.96-1.78,2-3.69 l-4.32-6.99c0.22-1.82,0.31-2.46,0.53-4.28L83.22,286.03z M54.04,263.66c4-0.36,9.13,4.18,11.45,10.15 c1.17,3.01,1.4,5.81,0.82,7.89c-0.14,0.03-0.29,0.04-0.44,0.06c-4,0.36-9.13-4.19-11.45-10.15c-1.17-3.01-1.4-5.81-0.82-7.89 C53.74,263.69,53.89,263.67,54.04,263.66z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M66.3,281.7c-0.57,2.04-1.91,3.38-3.88,3.56c-4.01,0.36-9.13-4.19-11.45-10.15 c-2.23-5.74-1.04-10.7,2.63-11.39c-0.58,2.08-0.35,4.87,0.82,7.89c2.31,5.96,7.44,10.51,11.45,10.15 C66.01,281.74,66.16,281.73,66.3,281.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000014613069020887733260000012024247212592782750_",
    gradientUnits: "userSpaceOnUse",
    x1: 791.6583,
    y1: -780.8972,
    x2: 1062.1996,
    y2: -780.8972,
    gradientTransform: "matrix(0.7864 -0.6177 0.6177 0.7864 35.4648 1353.11)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6B3DEA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00323682,
    style: {
      stopColor: "#6E42EB",
      stopOpacity: 0.993
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0316,
    style: {
      stopColor: "#8868EF",
      stopOpacity: 0.9315
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    style: {
      stopColor: "#9F8AF3",
      stopOpacity: 0.8634
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0972,
    style: {
      stopColor: "#B2A7F7",
      stopOpacity: 0.7892
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1353,
    style: {
      stopColor: "#C2BEF9",
      stopOpacity: 0.7066
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1789,
    style: {
      stopColor: "#CED0FB",
      stopOpacity: 0.6122
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2311,
    style: {
      stopColor: "#D7DDFD",
      stopOpacity: 0.4989
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3009,
    style: {
      stopColor: "#DCE4FE",
      stopOpacity: 0.3475
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4612,
    style: {
      stopColor: "#DDE6FE",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5288,
    style: {
      stopColor: "#D9E1FD",
      stopOpacity: 0.116
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6113,
    style: {
      stopColor: "#CFD2FC",
      stopOpacity: 0.2577
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7017,
    style: {
      stopColor: "#BFB9F9",
      stopOpacity: 0.4128
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7976,
    style: {
      stopColor: "#A797F5",
      stopOpacity: 0.5776
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8969,
    style: {
      stopColor: "#8A6BEF",
      stopOpacity: 0.748
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9854,
    style: {
      stopColor: "#6B3DEA",
      stopOpacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000014613069020887733260000012024247212592782750_)"
    },
    d: "M376.23,67.31c0,0-0.28,1.19-0.82,3.44 c-0.27,1.13-0.61,2.53-1.01,4.18c-0.4,1.65-0.92,3.54-1.48,5.68c-0.28,1.07-0.58,2.19-0.9,3.38c-0.34,1.18-0.69,2.41-1.06,3.7 c-0.37,1.29-0.76,2.64-1.16,4.04c-0.43,1.39-0.89,2.84-1.35,4.34c-1.85,6-4.18,12.76-7,20.16c-2.81,7.4-6.2,15.4-10.26,23.79 c-4.05,8.4-8.8,17.19-14.4,26.09c-0.7,1.11-1.41,2.23-2.12,3.35c-0.74,1.11-1.48,2.22-2.23,3.34c-1.47,2.26-3.09,4.45-4.67,6.71 c-3.26,4.44-6.69,8.91-10.41,13.28c-3.72,4.37-7.66,8.69-11.84,12.89c-4.2,4.19-8.65,8.25-13.35,12.15 c-9.38,7.79-19.32,14.47-29.49,19.89c-10.16,5.42-20.54,9.57-30.74,12.42c-5.1,1.43-10.16,2.52-15.13,3.27 c-4.97,0.75-9.84,1.19-14.57,1.22c-4.73,0.05-9.32-0.27-13.69-1.13c-2.18-0.43-4.31-0.99-6.34-1.78c-0.5-0.22-1.01-0.42-1.5-0.65 c-0.48-0.25-0.99-0.49-1.44-0.76c-0.45-0.27-0.89-0.54-1.33-0.81c-0.44-0.27-0.88-0.53-1.29-0.84c-3.37-2.33-6.16-5.12-8.33-8.07 c-2.16-2.97-3.7-6.07-4.83-9.06c-2.24-6-2.87-11.49-3.07-15.91c-0.17-4.44,0.11-7.87,0.39-10.18c0.28-2.31,0.54-3.5,0.54-3.5 s-0.18,1.21-0.32,3.52c-0.13,2.31-0.2,5.74,0.22,10.1c0.44,4.34,1.37,9.69,3.8,15.34c1.22,2.81,2.84,5.68,4.99,8.37 c2.16,2.67,4.86,5.14,8.07,7.16c0.39,0.27,0.81,0.5,1.23,0.73c0.42,0.23,0.84,0.47,1.26,0.7c0.42,0.23,0.85,0.4,1.28,0.61 c0.45,0.17,0.9,0.34,1.35,0.52c1.84,0.64,3.83,1.08,5.88,1.4c4.11,0.64,8.5,0.8,13.04,0.6c4.54-0.18,9.22-0.75,13.99-1.62 c4.77-0.86,9.64-2.05,14.54-3.55c9.81-2.99,19.78-7.2,29.57-12.58c9.79-5.38,19.38-11.93,28.51-19.5 c4.56-3.79,8.91-7.73,13.03-11.78c4.11-4.07,7.99-8.25,11.68-12.47c3.69-4.22,7.11-8.55,10.39-12.84c1.59-2.18,3.22-4.3,4.71-6.49 c0.76-1.08,1.51-2.16,2.26-3.23c0.73-1.09,1.45-2.17,2.16-3.24c5.72-8.61,10.65-17.13,14.93-25.29 c4.29-8.16,7.94-15.94,11.04-23.16c3.11-7.21,5.74-13.82,7.88-19.7c0.54-1.47,1.06-2.88,1.56-4.25c0.48-1.37,0.93-2.69,1.37-3.96 c0.44-1.27,0.86-2.48,1.26-3.63c0.38-1.16,0.74-2.27,1.08-3.31c0.68-2.1,1.31-3.95,1.8-5.57c0.5-1.62,0.92-2.99,1.26-4.1 C375.87,68.47,376.23,67.31,376.23,67.31z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000059989602142131219330000002627112072024934528_",
    gradientUnits: "userSpaceOnUse",
    x1: 61.8637,
    y1: 549.0524,
    x2: 303.7657,
    y2: 194.6872,
    gradientTransform: "matrix(0.9871 0.1603 -0.1603 0.9871 143.0597 -271.1038)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7D57C4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0148,
    style: {
      stopColor: "#8969CB",
      stopOpacity: 0.968
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0467,
    style: {
      stopColor: "#9F8AD9",
      stopOpacity: 0.8987
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0824,
    style: {
      stopColor: "#B3A7E4",
      stopOpacity: 0.8214
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.122,
    style: {
      stopColor: "#C2BEEE",
      stopOpacity: 0.7354
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1673,
    style: {
      stopColor: "#CED0F5",
      stopOpacity: 0.6373
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2217,
    style: {
      stopColor: "#D7DDFA",
      stopOpacity: 0.5193
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2944,
    style: {
      stopColor: "#DCE4FD",
      stopOpacity: 0.3617
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4612,
    style: {
      stopColor: "#DDE6FE",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5329,
    style: {
      stopColor: "#DAE1FC",
      stopOpacity: 0.128
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6205,
    style: {
      stopColor: "#CFD2F6",
      stopOpacity: 0.2843
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7163,
    style: {
      stopColor: "#BFB9EC",
      stopOpacity: 0.4554
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8181,
    style: {
      stopColor: "#A897DE",
      stopOpacity: 0.6371
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9234,
    style: {
      stopColor: "#8A6BCC",
      stopOpacity: 0.8252
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9653,
    style: {
      stopColor: "#7D57C4",
      stopOpacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000059989602142131219330000002627112072024934528_)"
    },
    d: "M191.73,200.82c0,0,3.63-1.27,10.14-3.56 c6.49-2.41,15.91-5.78,27.27-10.62c2.85-1.19,5.79-2.53,8.88-3.87c3.07-1.39,6.24-2.88,9.52-4.43 c6.51-3.19,13.41-6.72,20.45-10.79c7.03-4.09,14.25-8.67,21.35-13.91c7.09-5.25,14.1-11.14,20.5-17.92 c1.57-1.72,3.17-3.4,4.61-5.18c1.51-1.73,2.87-3.56,4.25-5.36c2.64-3.67,5.11-7.39,7.14-11.26c2.04-3.86,3.79-7.79,5.17-11.75 c1.35-3.98,2.35-7.97,3.03-11.93c0.7-3.95,0.98-7.88,1.01-11.68c0.02-3.81-0.19-7.52-0.7-11.07c-0.49-3.56-1.18-6.96-2-10.2 c-0.85-3.23-1.84-6.29-2.89-9.17c-2.13-5.76-4.57-10.78-6.93-15.06c-2.37-4.28-4.66-7.83-6.64-10.66 c-1.97-2.84-3.63-4.95-4.78-6.36c-1.15-1.41-1.8-2.12-1.8-2.12s0.68,0.67,1.91,2.02c1.21,1.36,2.98,3.39,5.08,6.15 c2.11,2.75,4.56,6.23,7.12,10.45c2.54,4.23,5.19,9.21,7.55,14.99c1.17,2.89,2.27,5.97,3.24,9.25c0.94,3.28,1.75,6.75,2.34,10.39 c0.61,3.64,0.93,7.45,1,11.39c0.05,3.94-0.15,8.01-0.8,12.12c-0.62,4.12-1.6,8.29-2.94,12.44c-1.37,4.14-3.14,8.25-5.22,12.27 c-2.07,4.03-4.59,7.9-7.3,11.71c-1.41,1.86-2.81,3.75-4.35,5.54c-1.48,1.85-3.12,3.57-4.73,5.34 c-6.57,6.96-13.77,12.93-21.03,18.2c-7.27,5.26-14.65,9.79-21.84,13.79c-7.2,3.98-14.23,7.37-20.87,10.41 c-3.34,1.47-6.57,2.88-9.69,4.19c-3.14,1.25-6.14,2.51-9.04,3.61c-11.56,4.48-21.14,7.47-27.72,9.59 C195.42,199.72,191.73,200.82,191.73,200.82z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 376,
    height: 431,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAXsAAAGxCAYAAACDTRbZAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAJVZJREFUeNrs3c9uHEm23/E4kVnF //rTkqZH4x5bGPTFhSnYG61mYYwWs7xbzfquvPQrSHoNP8LwAbzxQgMvZnEhGLhAC/BFo9ENy61W s8V/xfqXmRHhczKLYpGqIotsSqqSvp8ZtiSyKiurkPzFicjISOcAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAItM+AjwKUop/epjW0QSnyQIe+ATCXUaARD2 wOKH+2WO8QuFOeEPwh74cAH/IY7lc0Od4AdhD1xtwM/DsZsIfRD2wNWH/CIcr4nQB2EPzB70i35s Evog7IFPOOQJfRD2wBkhPw/H41W+fpr2bwIfhD2o5j/NYzIR+vjYPB8BPmLQy2cQ9PX72jp+b3JG zwagsscnGfSf3XGooe8eHVf3iQofhD0+h6D/LI8/Ah+EPT7VlB9Psk8i6J/9iv1/qJ/IUeA/1T8f 65/SJD6BD8Ien0ZFb2PXjz5y2M4DAh+EPT6LoH/GsVd/CNsPXToR+IQ93hNm4+C9ezoW7BbyBP1x eX/nWdMIPrbP6akTZuiAyh4LWdU/HQWZBdqdz+h423g+23vtPHCprvC3tcJ/VJ+spboHYY/FDPvN LScaZB986GbWwP3YLPAf2hi+togEPgh7LGTY2zGmISZ37jjZ2OB4mxr4HZeo7vE+MWaPDxL0Dx/y mQAfU85HgA/h+fPFr+pXVubjblgAYY9P3gcKXICwBy7iaKyekAYIe2AhtdtX04B9/bVLL144efCg npEjzUlaO+fBSVoQ9sCVBi5A2AMX1lwFOqpSnVWtm5vOffstwQwQ9sC8/pLk77eR0kbQaWOYbMaS DeE0yybYXHs+exD2IHABXAC/QLhy9TIJWp0+fuxEq1X/4IETG8L5XAP7vPddVS7ZV1G4pBV+cI6r aEFlD9AzAAh7zKPxqp7Qnd4QWWX/7Fm9tAQVPQh7LIbHj5s/xy+mmvegz7KPs38hNOFuM5Z+/plj B4Q9PgMfK3ABwh64pNGQhPv++2YYZ1GDfHtb9/vL97f9Ur8K/arsOoSHHDcg7PEZ2/YfsaH4ks8f hD0w3cPm5Oz2spO2VvUtP/+V/aRcf/PmPe93NSrvr4/urvWAQweEPT4DHyVwj15n0jfvTOpqXGLj d6Z8PzZfL/9PvUKoO14MDSDssQDqKlWr1fZrrepbs19U9VECdyTbmbCPO5MeeInX3pny/aC7ddOl 4b26UQMIe3wi5jFwP4CzTlDbOYnuKyd//KNz333HIQLCHgvChiL+8Idmbv3vfufc7u7YbJw5DdyP yYauvvs9xw0Ieywwm7qY5/MfuJe1P+OJ55tn/MzOSfz+WrMctC0LDRD2WBgPHjj39783Ff7e3vud Z38VgXtZV7HNXf1s+vq1wmGD94SrFXHlbNVL/cNrlZpdu+aygwOXddrO56NAvjmH+3zwgaeF3hj7 e4wulaWLh9dcWNl11Wjly8iql6Cyx2K549ytfU3/OQ7cG79yW50L7ntn7O+W7EOr6u1K3f/M4QLC HgvotYbYYMfJcstJNiEQ5yVwP7TssNnX9XWXbJq9XVfV+9K59rdOnr1slpkACHsshk3nWv/qpFpt gn5S2M9D4NaufeAXH73eoXNilX2hn02LIwaEPT5V8xC4s/CH72+IaX3VJavsB3aVcLv5nt3pyzmu ogVhjzlnK15+9ZVW9V/qQdbd1ar+5sTKfl4C1238yp8f7WP34vvo9XOx8xXtO869/IZJEyDssSCs Kv3Tn0YHmFar68s36wOtd15YX0HgXiZsa90P9/l0/eHbfVxbW0+H0UnW2ZdseF3u3XPOvv72N44j EPZYEC9fOvnNfecONIBva+XqzzuB+pEC9/yif/2KOxHr4+9Z1lZc2rl+3bk+xwwIeyyobOcXubF0 e74D95SenNyvnp1GvUJrY6+9tubSwYFW9tWB7LUr+dJ90fzAbuv4hHF7EPaYc6M7VLnh8HY9JfIL ebeynxa4p8P2fQfueT/r97sywwZn1h/vwsia817f27Vr7tbAuVf5S3nz/LU8fvBAs95yniF8EPaY T+IeH/9jL9uRjcNcurmIv7bhet2x8eopgTvp++81cC+4Xd+fkMCXHILxuh+dnnPtqiP7Wtn/3n3l XusXQNhjzqU6658/fy7Fl1/KneorV1zTUBscitTVvci8Be65Vs/5t7VwfblUCd6XpJW96FeS7EC3 cZsjCIQ9FsoDZyv2vva7sqaVfa8Q2ci6MjGkP3LgztANmMnAO1m94KZjvw5619VG8OaNG+7161f6 Hu42zWbS98QoDgh7LAKrVv1qU9FrromZt8C9Kn4gMrjgspXLGvSHUVyrl6Qj++J+d/co6wHCHvMr jc0dsSr11q27brc6lCUNYau8/Xte7EzbFBl8wPc7nu02TPXOam+9cxqnpE+J+qFdW68f29p+Lfnu G3GbmxxMIOyxAB7o16u7rvPLvmQpk35LZF2DfiBXPzBxInAnNSa99/c2B2PdiLohO93SnLPUZ4yu GbPvd8VnQSq75HjiLdcBwh5zaOXFCw2uW+JuaHCVGmgHPRms1WX3lYf9icCdtH3//t7nsDhuvFYu 9TppFPgnT14DV42DC1dqdOMSefHC5VXlWnl+sBRj1grB5yLuvQzjDMdC8kPf6Wkov+79LCWXujEl n6VqTVaLGLeHzt0pvvlmKzx69IgbmIDKHothVK2KVq/yvqpXPxa4w1+xneXzgn34brDL8q/b96Fz b6dedqUjK/HO6CfciBaEPebc1taW3L//yO3k2/Jbd8f1pSet1RU3LAbiz6mEP0bgjgfv6U0VxfHr +UnDNMVFS/mT/7QVjW2ikc3ksRsR7q7+Il9mt+lxg7DHImiq0t9o0Hd9R3zKNOT74puJlzJvgfu2 0ShEytPfu+rY1X0txj6DIrmUt1K0z8VuyH6bq6pA2GOR/PDDt3Lt2g25c+d2vcJLGGrpasM4R8E9 R4F7/EJTd+vyL1Wc0xOxk7P6mKF+Nktx3e3t7citW19wAIGwx2L4h3/42oXQrGzp47q0pQn6txdV zVPgzthJWD73dYZyuutwXk/EZuJIS9vBoX4+S11xBD0IeyyirKdBu+qkHDhfljaScxy88xK4Jyyd 2SHQnkcxtZ8hcvFmyvatGM1S6ved5MNdednZl0eP7nHwgLDHYtjbc7K2JnahkaTReP2JqZfFxcL2 fQXuuLIszhw0av/KIaXT20/JpeCSW5Kon81o6/cIehD2WACPHtk9aL+Xr76653Z3LfCbqtVOQJ53 gtbSvJQPG7gnGov2OfvWthk0S5ff/jsnIFJ9nsJGuPTzcVkmQtSDsMdC2d/f1aBva4wNREaV/VHY z1fgjv/Qnf0zffHqnMboYieUmzn29pfxXs+zZ8/kod0BBiDsMc/u3btXn3zc3e1JCENvo9Mp1euU yfwF7rHKlmCe1tiEprVpty/ak5j+jmwYR0M+NWEv0umI9oJeMs8ehD0Wx8HBXj0OrYEmTb6fP8++ qvTndpXRBwzcdxoJObsROmpIylJm3+ZUyc4z6COS9n+i2H3HDw/tTlXcrQqEPeacDUEsLX0tKytf aT3fr5dKsMwLwfnzwv5tMH7QwD312GrKq/u3DdKFtllVZfPIVmus9Tmq7LUtTEVqtVr19MvDSrdq d335luMIhD3m3sP6v1m2L71eWzTHpCnsZ795yYcM3BNa9f8vts1zniEy+nn1bqM1eg9SVYX3vlVX 9v3Xr2TIHUxA2GNxXK8rezvxWJbOx6z0YpXrUeBOCdvz4/PqA3f86aGatbfQvsD+Td7FZEIr5Xmq P6fDQ5uVQ9CDsMeCaLdfaXCtSbvdFhuTFilFqnYzZl9NCNuPGLj1t0NrciMwyzbP+hzk7K5CvZTE 6CqE4XCgvaCMk7Mg7LFYbM64Vas2RBFCpZW9jCr7+Qrci2zrqMV421OY1ABV1dtthVY1Oqk8JeyV D1rcS/TeN0H/5s1rbSS5WxUIeywEG4roOKtW9TCrZ+VYXa+FuMxb4DY9BJn661CNbWv0nWkdklHr cvr5Z029lJRJK7oy6mcTpNcT+e1v7cTzc2nu7QgQ9phjVp3eurVan5i1qZchlN6mkp91gnZa4L4b tlcbuNO2edwzOHl6QcLJbYXTuxxOv6+zX9U+mxSjzwsvWdaV5h60LzmIQNhjvj3Ur391TUDaSpdp Sb+aYel6+uVFA/doeYT3FbghWGPSmvrLYJvyZ7QsGtbizm56pspsbZxYpiCZ2D0IXVpzOzvbsrFB VQ/CHnPu+cZzabUeOB8Ope81Z6vSa+FqeTl1nv1ZgXuU2+8rcFuj4aBwugfRmvJrEk83JK0p7+f8 X7AYnTaDLf104mi5hJ5wa2gQ9lgQD+rqtN1eqav55iraIDHK1LA/O3AnHKZXGbijR4g/+cgqHO1L deFfo6Nmqwrh7Otn7Q7trcqHkPk0LHy+uuZ+49bqi4gBwh4LIetrlbq+XI/X+xi8rQIjfnLYnx24 1aUO5VkD923fYXwT+pKSy6jRON7n/KznT/jO0fBRmNLI2QlafbAtblwP41h1v9v6RZbdbff06VN7 TuJIAmGP+ba+5soy1ksbxyA+y3MN/uBnCtyjK2Tz5qTt+VX65QN3Ym/BH/+7dfR8Df14yY/CTzkx 7X2Kdh4j2DpofkkGg/oiNICwx2KwJRK8VvbSssq+8jbF3oI+Ro3RfIbA9eP/rk4E7mX3ycvl1sI8 2qXorcGZsvNndD7y/HhI6d3n2xoSuRb10e69K37g5KDy8uOPL/Txj/XnTziYQNhj/tjQwz/90+P6 74NMY8xrNRxb+hV9skLWa2UfL37YHQfuGWF/6cA9b2P5WGMxZcL+GdV4jJl+yahnEk49LdNX0nTX d+ZbbRnqZ/aFvvQhhxIIeyyG2/rVc1Vv4F07+RSzep59ltlQzhkV8rmBe8b4+9TAzeq19acF7mTy dg+ax2fnDwNN21I9hnWy0Tre5+BildUzlVy/9Cv2ty+cu69p/4KDCIQ95tdj9913L+Tfr/9WqmvR bsMkSWxMp6jD3m46bkF6kcBthDps06VOV9rZz2p64E4SjtsPe3yQKHmSmToU70z5t97ItP2OSf9f +Uw/J9vNoXYfqo7Ixv1N0h6EPRaAVqfDrsiyhVeovN1Pu74ZU6pHLs4P3AltQbTR7Rn6AKcP7KC9 geTlYvNaRr2EMJrJk6ds6j77d/azec2330jZxP2qmq6K89H+7zTwrU3UFoUTtCDssQjuu033Y2dX 8rxZJiH6lpb3yeeZhloSP1PojgJPxqZN+ssGbv162UwHfXX6Nd3svYE4er2s3tfJLVcce3XbdgqV pEw/lhjqz6jwuX5uwlVVIOyxEGnvbv7oXLewa53a4mOplb0mmpdmNs4FAveiozYXDdzx6v9tIe5l Qu8i2jKex98c+9nRhWIyGuY5q2GQsdexTYh9MtrrSfq51KNdg4G4fMX98MO3+rivOZZA2GO+dQ73 pVpfktVqRdPMZuOUPrehnFHYX0ngHgVoPB7cv2jgHvcajl8um9JdiFWYMBsnczOdRxi95vhj7Rve a28lBZ/sa5BpZa971z1grj0Ie8w/q0pXbtx2K1Vyg1jZqUcNM1dX9fUwzpUGbjZ79T8hcE//Gsio oYhx2qwfOeffk9+bO3Fy97jBilFsSmiWZ7nY1cXLbln3ZsV13Daz7EHYYzEMC7EzqvWaOMlrloeY 5XlmF1fJ1QWuzFy9uymzaWTC68xSWNc3Us/ePZN8ZqVfT/+Mb/semvXio31E4qtU+uWQS3fQEbfO EA4IeyzCgdUVqbIkQSv7eiWAVK/p6Ksq+onV8GUDd8q8+6mBa6W0OzkUlMZO3k4P9iBZdtzzqLdR n2F1Mzcgbvx58aipEhdT8pJCPfmy9ENx1641P6e0B2GPeWX59D/qE4v7riiHkrdbGvihuXGJftlw zmUD991q3ca7z3j8xMCd/jpidfYUtlxniicboRinPz5Nu5VsPW5z3COxbYh2duwEbQri87aTvNeR bH9HH3CPAwqEPeY67V03F8krkWhj9snX8+tLF7N6nv2UwLXgy84o59OkYZiLBu7bx4//LI4anLMq e923E32NWD8rG3sr4bjsd9rCySyNjGhrlfRzyWy6vd2WvZx+LQFA2GOuvH79vdy9+4VW9k7aGvrR 2QJowS4S9clOQ04J3Ho0+8xK/fT4j37jVIZeJnDPH3pp1rAZ37Wj4aMQpjVMJ19PpjRKobmFV7CL qmxWjq9y6Rde1jmMQNhj3tngQ+h1pMramnGpCXj9X6yiLX7pp1e559zo49Tz6sANZ/UEZgvc4+3L qe2Pf+PkZE59U+8s0Jnebv/dS7GmtWH62bgYYpbsDoX6OQUbL9pwzf3aAcIe8++a8+W+yNKSlq3J 16clU16P2U8L3TThxO20wLU4lSsI3JhGj/dHzzoeqpF01Gi8u79x4t+bhsVO5s48Td5OZFgfxGmj WAWfLWtXqC+y3c+5ihaEPea/tO8fHoq38efCxuwzH7KQpejqMft0RtjOGrhxavheLHCPHhRHQ0Rh tmXS6ttKTWg6jvK7bliinG54JjRwoa7tM1v82Utef2ZHnZWtrS0CH4Q95jvts/5PtoqAZWKzfG/Q QAsuS/5k8p0O21kDd3LYXiJwT9/LNp4f0Ee9hLqhOuthqV7z7cxZO7YBsck+KfqY6qEuKQovbpmj CIQ95tz29ktZ10Or8iJZDD5KyGy1L63pfayXgPTTS/QZA/eod3Ac5pNZ6+LOCdzT2031SYbzr8u1 ifHNhV/Z1K2FUaQ37+vdE8z2FWzeUNLPJSSftVuytu7cfsVxBMIec6wZevijGwy60m6vato7SZXN wrGJkFLPyInnniidPXDd27CfHLjh7TakHs/3ExuQkzeftSGjMNMVXb5+XUmzNSTh9NVksbn6wMWQ 2SJxmeQyGJQ+y5fkK/3NfMnhBMIe825tfd2FKklR1nFWr4+jIZ+lep3H6ePdbwNXHzTL7U2O1oqf JXCTVtbBx+kvO/qGDT7ZMPps/QDrNaQzXtsf/3dCLyTZLbTELjaTZuql9oaGw5686SyJu8lxBMIe c+wr/doe9DTRVySz1Rxd7kOImdRzJ5OfVOG+G7izruk+S+COBe9YC1IPAcXTsVwvXyMz3s/qqNNw xms326nqBYKyU283NK8qLrMLq+y2XpW+j7W3j3nEwQTCHvPrza7m1kbbea3s6zXskwVZyoLU03K8 k/Or8NnCe+zxWtnbNVvjIZtS828/uilgPF39nxolqmf82NrCySYBNUs62HMm1fgnpoTOdCGYjK65 PdlK1PtpCyYkqZc59nkmA63u2wXHEQh7zDWrRl+5fNiTsrUi9QJfSSt7DXy737iGqA1ZnAryE4sa Tw3Y089ogtwWUbBQ928DPyXN7fparhTrv49GS84aaKnD255RNev41FFsF21Zm+PrK3ulWTvHj2bh eCfvrN/g32k80tmvWq/EqU2ihb2d0/BS6WbzNbd78KMs37x71CIkjisQ9phLg1wsOb2vbAVfOzmb WeWa2Z1W313PRk6O5WiwhilDIr6+qVNdLjehXo/W2wZtlRl9xWQJbMuK+aBVtfYtNOeDdi7OONtr J4xTfQa3vrlKFr39XtjNAm39My9l1P6JjSx5TfgU67mSumUfXHPCN0nTCLxdY2fUCPgzGoJoq57Z e4nBtluFGLNMv1FoY7hS6Pa+5BgCYY8FUVWl5Km+cUk9EyfVS5Mln05UxKOQjJPHvS0+LWJHf4l1 hS52ljXZovhBt1Rp/V5Z+5AsiTMN+eS0IxErjehCX6zSQNU0t+e8e5ep5g996XrGkC3n4HNtGtoa /i0bXklV1SzxYH+PMdd9z+tneLsS2Gda5ftm3pC9r2ZyjUujHsDpd3LqfWsjpbuujWK0ean1GJQ1 UTKs+uJapD0Ie8yvOsx2V7blenFT6mGMeoxFfD2P3AIzhBPz7K3CnTjIUVe9tjyYxKYtsII+BQ3M YItD6nYLTcpSw30YYyq0ESn1OZVGf4g+VvrChXYtBiGkUkvmKlT1tBeXZfnbCj+ESo4yP9P41ifm +jrtLLpl3au23XpF91x/R3S/U2ppI7Kkj25pw9XSfWlpwLf0Z3lsGgGr0OulIcSGg6TuYMj0awXi aI6pdhC8y+phLv2MdFOSra5yJIGwxyKwqrSoF32pKrtEtFnoa7SSWeZOBLw/UcWPZuJEy2a7HasG ua0IaU8onaRCt6HB7oYatn3N10Hyrpc539dtFiHXx6QYbOK6l5XSVWWxlC9VxbAbW34p9lzPlePl tjShulrZbJmhXQKWZSHPhz61vbYKEnSLotW7iy3tK7T1tVYs8GNIy1qDt3XPl3X3lvS9WSOwlKwB qBuB+uqCeoppkjR+IvdEw1bPuLQOStTGRKx/0QwXZdpMLRdvxC1T3YOwx5yzWxIGsTUcraq3ythZ SZ3bEjDxxHBGHOsW+GhjMXZhqoZkpY8rtYoeaoBrwPuBpmNfH9TXGr+vjUA3+djPo+9XTgaZaAVf FsEtt8JwIHEjulC1Y7W/143trIjdjQ19+d3Te1n/d18bp+XOshRhX+v4LGu1ytz1ulm5vOHb0dvF TlnwoeXjYMn5Vju5clkL/WXd81X70je6qvuypg3Bir7PFQ36dr1IWwo2imV/sbc9YTZQsBO0dhY4 t4Yw2eBQCr4oCsk4hEDYYxHq+u18IHnhpQ4wuwuTXaVkd2wNKTtR4dpp0eQ19mIdj/pVxiwbSoyD JN6q964+vy8t15WUupqIvZDKgYTU1xp+OGhXxbXVrNh7E0I7ux4He6/S8n/4Iv7SHaa1tV7sFv30 7atO2ryzmdwZZz1ffPdM7t7dkJs3V6TbXfVFvu9XWpVknbtSXNdG4KCdBZFWK/N5O89aqcrauqsr 2qasxujXvPMbUdKGdiquaW6vam9mVbNdq/7Y0v32wfo5Fvr1mv3NbCRfTxeyk8N1tmca+7Y+jvYv VpytGnrUHXCO9dBA2GMO7XfeaHot2RC2VCH6JsxS5m2lY43/OAp7/YEN6CRNwaCVcKVxOIhOq/cq dJPkB86Vh7nIQcikq01AP2+3esVwOExtX+jPi8FSv9rYWKt67qvQXXquof4ybW4+1HTccj/88Cg9 ftzMwDme6DktNO1hD+s5mk+fPhW73dbm5r+ITSO9o43Av+XaCNxekdbLa9lgreXD3jBrr7ZyN5S2 tl1Luu8rMcR17QNohyLeSLG6rtm+oa9n10dp9S/LNsZvA/jaXbHTwc0Km/WC+xK052K9nubmLtoV yKqBuLzlXrx4JrZfAGGPuVaUwder4URbe0Bs7LsOtVHsajVvcxZtLEOK6FLfBenoo/c1/Pb133s+ SsdlrU4sh4OWyHC1iMOwXFU/VYfh5u0H1e/uuLi9vZVevLBgfzCql+Uovd2TJ7Pu6WihMjlK/rdP FLtp4MNRI/DYPa62vnKyu/TS7/ScX1paG6wNu7nufTe01w6rsuiIC4dOGyqJ7oZW7df1DV7XAn5d eydr9fROaQLdLgSwER6xMfvRTCVX2YVnXkrtQgwGO5TzIOwxr1JdjW7eue/KqiN5liSUWslqNZ80 6G2tL5tx0szGTCFZRe9k4H061L9rQMqOVrs7eeZ3o8SDlJa6qXc4sEp+d2mt+mnYDf/pP/5jGG47 DXhXV+4if6lfePZgv9gbqi+UHTUCT+pGIElKD+LTp042N121u/u8bG/cKuLPh8N8bb0fhrEn7arj S2cN14GIHOrHclND/kaM7pq+71Uf01Ky2Un1VbO2vWR3Ksnsxo1JG8iiVYoLZD0Ie8y5zuGOLGdR C147LentKqh6nr1dXFVfnSrRRjDs7GRfQ3BfK9udWKXdTNIv0fmd0JdO5spuPxRD/5ulsijehJs3 v44W8A8fWsDL+wz483oB6bgH0AS/e+rCf7/7PPhXS2VaqYoySX+lqnppqdXR93koMTuMruprtV9q w1FF5zZsAR7dQNvV8+uj3Wc9a66zEikrmf1OVwBhj49r2flQSr1ScbOEpC2EZuvZ23CJXQTVE6cV fAq/xOR+1or/TeHzXTf0nX6M/faX7WGlIf9ff/jH4B7fOxqi+UgBf27w21WzlVb74e6N56H96la5 53yxvuq00g+DZR97MaaBNniFBr5NAQrRZoiKXS5mF2nZIj42S6nK7PaES1rn+35GaQ/CHvOvyIaS l15Cve6L3Z/bZlTWU29sAci+BtxelruftZD9qUpxW6v9PZ8VHZFicHOQl27tm/DP//yoWYDyydyv DXPU26hD/y9/2Yp//vMfwl63KG92V0p3/eZA7MSyj4NkJ6B9KpMt9mATTF1aq5sNWzPI1mOIdm2C lzaHEAh7zLuuVqU3fJDS7u4RRlfQ2rJhPlUacD39zq6m48+hcD9pur2uYraTtweH8Zcbgx/cT5Vz D+OTv9hUSVm0BcCOQj/+9a8pbm1tRffiftje71Y31/NyUGZFCrFIeVZ5rexDDLYcjg/1ndidNYze rv+1G9G2tWf0Jw4lEPaYZ19YZV8VElyrXlQmpXrhG800uzAq7UkUrejjq9Rq/+R6aadfuY5bWR/+ 9pt/qR7/ta7mF32Vx1Hop/hEeyUa2vF/+7+HL92/CyE/rKqQRbvfrDZmrWjDONGmZyb9VnOxWRa8 dPv74lYecjCBsMd8s5OMztYks/ksdjLW2wVSrisu/Zy8vEoSXue9ame/8p3fumLwYmez+m9bX9uA /ie0nG99jsFGbNL21h/TTz99Gzd2ihRzWwcitbS7sxRjXLYJOfVtrGKq79hbz069edO5AccRCHvM KRt6+DerSteXnKvqueu2AlnhQyz072+i8z95H17HwdIbjbQm6N1m9aQel5dPct32pqeS4l8ffV2t /5dv+z/uFD5V0q7ysJKirNnK+5rzLe3+2CBP6paFLC8vczDhSjHDC1fseOghWkkbna1x09dQ26tc 3E6p2HZBduKy77Td15980I9X+X/ZcvHwf31dBdcfZDEcVCG90U/p55iC/ikHKfhB0pYwt2uMd7XR /PE5M3JA2GPODesFhWMMqdJ6tZdc2kvB7Uhs7w68HLYHfrj1zVb4PIL+OPAf/dVF96MrfdXqeW0A UxF+cVF+TlXcSy72XKhKca347qJtAGGPORTsllEhhhDT0AV3mKqwlzm/N3T9w2s7xeCHZ99XW1uP 4ucT9KO4F0mvfvcg/N+fX5VLLd/VMn9Pez47STTdy9ALyRXDQYjD3nVuRQjCHosR9qG+ZUg1rGLo hpQdxEq6K25psDdcrdzDh59d0B+pezPfu2r3sBrGMhzGotrXdnGvTOnQFtbP2r5aWwnaKHQIfBD2 mF/DXpXaWR6cuNJF6Yv4jsbbYVa0+m96Wblz6+vR8M3nShs5beyWhv+vWhq2B/pL2A1F1klB9JNL RSjKMDgMBD0Ie8yvv7lnLgsbsUjDqgjJ7ih1mCq/76I7jCEOWuVO9c03W+lzrerHq/udW1q+S1ZW VWtQVUUv07BPEoZZ8FVe9ePm5jaBD8Ie88nWk+91qjSImS3n1U8hHQYXOzFmvWHhi4PrL8P9rReE mPrmm+202lut+sVe0cpcr4ium1fZIGRSvio6cWuLzwiEPebUlibU7Wwn5FUs3KDoh5R3YpkOyzIM dob71ebmo/DEPSbstWdz//6LVLTfhGFYGQ6XXE+KsjPsud5+LxR32xvBfv6594BA2GOuA2wjWGBZ gAUt5tfa1eHa9f7grnPlixdPCbCRJ08ep/+5+120z2XwujNM/Tf9QdEZ2r/t+/ZzPiVc2W8nHwGu VpJHj7b8n2/+wb8qOtndexv+1fedaJWqBdjnON3yzE9LP6+nT5xsfuPkxf36z6R/psdPXLPQBEDY YzEC7Jn++ZAAO69LVN8LpfmNlLFbKwKEPRbg2Er1TbxP3xsWAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAACg9v8FGADAly/GGy/RdQAAAABJRU5ErkJggg==",
    transform: "matrix(0.24 0 0 0.24 268.32 429.64)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st107",
    cx: 313.48,
    cy: 497.07,
    rx: 8.71,
    ry: 5.03
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 377,
    height: 431,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAXsAAAGxCAYAAACDTRbZAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAJeZJREFUeNrs3c9uHEm23/E4kVnF fyIptaRWq9ENy4PBGGBvDGg1q5EfgnftlZf3FSS9hh/B2hrwVgMv7uJCuMA1moAvGuMeWB6Nmk2J ZLH+ZWZE+JzMIlUkq8gim5SK0vczUy2KLFZlJVK/OBEZGekcAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAD4jAm7AJ+DlNK1HssiktjLIOyBzyjYCX8Q9sD8B/xV H9MzhTrhD8IeuL6A/xTHbyL0QdgD1x/y83bMJoIfhD1wNSF/k47TROiDsAdmC/nP5bhMhD4Ie+B0 0Mtn8O8pnRX6BD4IexDyn98xnSb9ncAHYY8vPeg/1+MxUeWDsMeXGvTyBR6HicDHp+LZBfhUQf+i +fNLKjhk7DPLhF4OQGWPz66i/2KPvRejPzebCp9xfHwUObsAX2LQv/yE22Ahfxj4z3U7nlrg2z4i 8EFlj88x6F9+4cfftu4eC34NfGeBT3WP68SYPa7d8+Nj9HXIv6TQcPdfNmP4T20fPXfC+D2o7HFj q/rRMEUd9JtU86fpDtnedmlr0yWqe1wnxuzxUdzEoF99df3b23lSD+W4Fy/0vTbrBpKTtSDscXOr +vuXCPqPEbbz0KC87DS7jKMG14kuNa4t7O34sor1/n09zp58GeF96Qq/45IN52xuukhlDyp73OgK 9kvfB0tLk/dBv99U9ZubTQHGUA6o7HGjKnut6r1V9U+0qn81J2E/LXA/NQt8q+51X0XHiVpQ2eOm BP14IXEy6Oc1cIHPGfPscW1sWGJ11cnjx03AHz7YM41224k9DhtA6wHVs3KaJpP9BCp73AwvXzrR sHdbW/Mb8Idh+yltbNT7CCDs8flXuOwF4HoxjIMr1gw/2HCEDUvY8IRVrodDFpMen31FlTs56/HT T80+snMbNvTVLJ3AkQQqe+BSgcteAGEPXCOrXAlc4NPiHx+uVL1MwnMnT586efXK+cePm2GKmx70 17n9VeWSPYrCpY0NF9zopibMtQeVPb7Mg5WeAUBlj/mp7EfHlWxtucxOwB6eiPzcP3uWXe4zhtBU 9o8eufjypYtcRQsqe+CaAhcg7IFLsAuqbOrlzz83Vf2XHMLb2/rZH0z/eamPQh/VT83qoABhD1w2 cP0nbGwesP9B2IPA/axMyvWdnXM+dzUq79dHS0E/5lgBYY+b4kkzv3570Uk7c9L6SEE/rYg+N3Cv yM6kb96f1PJxiICwx2fke31krlmX42ME7s60H1xV4N4/+8fZuwmf8d2kJ5542fsuDYfuaKmJzU1u UwjCHjdAPRyx7tzbt1rVt0ZTL+9fUXV7/4JhO2PgzuTd9ewvO4m7tsZxA8IeN4hVpr/7XXMR1Lff Ovf+/Wg2zrsrCNtrDNxZXNesort3XfrLX5z88Y/O6Z8AYQ98dtM47zq384uT779v1v4f3YsWIOwx /+zuVP/0T3WFX1f18x7QezOeQL5zHW++61y475IbctyAsMdN9P3NCdzf+pr7v2G2ka18NnjnpL/m ZImjBteES8txpUZr43hbF2dtzWX7+/X6ON5/hKmX+x95Hv/tK3qdGF0q11w8KF1YeuiqjSb/I2vj gMoeN8LbzMlAH4sawtk1BfHtKwzfzgW3sXNFn8GSfbirVX1P3/8hxw0Ie9xA9/TRcrPf//JTBe5l ZAdj2/obp03e/cq53qpz7Z+cvHzdrCsEEPaYfxsa8v/qZHfZycI1VvZXGbgXdoH38wfTP/+tZZcq rezzgT6n3XzPbgDjHBdWgbDHHLMVL7/7zkn1QCtWLb371xj2VxW4v9nq5X9+sOdkcZHjBoQ9bjCb YdO+AYF7tH3dS25f9/KbfWutvnmJZNmv8vr1PSZNgLDH/LPhhz/9aXRw7Ti5pRXr4GBf/PqazHPg Xvit/MHM27jqbp35cxEnnY42iu177tEjVz/+/GeOJRD2uAFev3by9Q/O7Wtw31tbc73u1Vb0Fwnb WQL34p2Iya/Xk9Pb1XMHU19neeVW6u53tKpPsptV8sB91fzgqT6eMW4Pwh5zbHSHKjd85yQr9uTg q3XpazhfZeCe9VoXDdzLWJny/pO+3+93pzZMUjdc4hbWVt3dgXNv8tey8+qtPH38WLM+OS6FAWGP eSR1RTqym72T5fWvnO92ZFXDrNc9uLLkWjkj7C8auGO/OLP+RcaMTryu739IcO+7Luvon1VH9rqV fL/4nXvrvuNIAmGPmyU72Bd3Z82JBr3vi3ySsD0ncMde9HosT/97v+dkZcWl3eDkzp07HDAg7HET pLqwf/XqlRQPHsj96jv3znfkK6voV2/VZ17PDNz+NW7a8jl/t27JeY3RZZ3xuZaWUzo4EFltJ7e/ vyv37t3mMAJhj5vicb0G2lv/Xtb0EOuJk9VeV7ycCPfljxS2F2hIBt7J8kfcU/aRvU/6ELl9+7Z7 +/aN7oNmzYSU6pk6AGGP+Zbti/hlVw/f9G9pbs0Y5h87cI/1NkRk8BHfb3GQbMUzbRCT7qw9+fbb h+4h6+OAsMc8S2OTBK1CvXv3oXtfHdTLJVjQz7ry5ccO3PFlhWXSNvau771lUbRxS65l+2cosl29 lffvd2RjY4MDCoQ95txjfbx56Dq/7kmWMum3RG5piA5kemX/KQN3MNaN8IMJ7+2v772LQj9uW6L3 SQ60lVt0D/S7DziGcPWFBbsAV1fZ12vZy9bWVl5VdzXiH7TTsmuF/V5uY9IiZxxv5wXuNRr6D43Q x755iJ1KaLVTLMsUVmS5+HvcHn7t7hc//vgibG5usqY9qOwxz5ohiCzbl9jPJNVJ784cxhkWY4Hr P+7Wjp84/i13BjxvLbPh8PTn9wsu2ftbA9dd6cjX8f7oJ9yIFoQ9bgjfVMwSYxP03k8fxvmUgStX tOLkcML72zDNh/1x+nei/pJPIsvLS/UTt9//KjYF07nfcwCBsMf8evHihfzww6bL820NrPuuL736 BO34MM68Ba4rLvgmC5O/Ldo7KU9+T85rEFO9ENpA+hJ9kHv37rkHD+65f/kXjiUQ9phrh8MP9zXI OuJTJkOtXLPiw31o5y1wL0y3tZh0/kGmbtYZ9IVs2uXASWZ/WeAIAmGPG6LddvI2OFnuSl3RL+rf S5t+KVcYu1cauOe8VTF7T+SsNmvSr8TYfA5rCLs2Q3X3ndy9+xUHEQh73Ax279lhVoekDDXMMjln Ns4nDNzj7zOUk12HmXsiC+e2T9rzKI59jqTCMLmlpQWxdfzvaNC/fv2zbG4+4iACYY/5t6sV6tK9 r9yw35cFsdEVLVtHwzizBe7x5LzOwD3WgMhv6Bfoi5dSnNmgtU83WfWYvT1WVpzb23vPdGgQ9rhB tEL1/a54rzV9oVmmVf7hjJuyODsQP37gXkxZntFYtM/ZNv15+1iLZOviaO9nmCQEG+aylS9Z/RJX jyoCV2Z0UZV/+fLn1urq+sLSUntpOMwWUipaVWbD983x1j73lc5/xlmB684JXHcqcC/4+pfd9KJ5 gow1Rim5lGUtjflUhhCH+rPe7du3B48eOTvPzEVVIOwxx2H/s2ut7lia9pazzOufGvZe/Mkx+7MC 99Jhe4nAvSp20/Az33807NQe+3mMLsWYon5V5nl7kNJSt99/PRwOfyqfPHkSCHtcFYZxcOUeObtL 1a6kVGk5f0sGNvVSxmbjFE3aVXLW2PlvCNxwxhNCk7rt9sVetyzPL4yOtlnOLq3GP1sI9TUI9WLG g0Fflpdtn9idqrhbFQh7zLGXL1/KwsLvZWnpOzfwO3JL7LxsW6qqPJpn70JxqsK9irA9CtLyjOr6 ROCWpcz+urN2l6sp2+qPGqTx1031PPuj5STWOYhA2OPmODjYk9XV5XrKpLSb5Y2PhnEuEbgXCVvr MbSqKWl/InBnfV1trMS1WmOtz4QntY79MfPrppSnGLX3k4kcHOxLu92V4ZBF7UHYY649qf+7vm5j +H2t6Ie+bTV9HBuzv0Tg1mFbJ+n5gSs2Jn+BsJ0lokX059XpHsLJoK87LtXsTZO+bmqq+pYGfJA8 595UIOxxU3yvlf3/3Zd8tVWP01tVn5KbelFVE7gzhG395CmBO/broq8X3GxjRCLtGRuDs9uDVmhN bwjOeF2bjWNiTB+GuRxVPQh73ADtt28kZLfqOy8lDbCqEh+j89OWS7iKwD0etrMF/bHXnfZZZLax mVlea7xlOmq86s9vY/b60P2VrTBDDoQ9bgyrTDv1xUK2vLGMZuKcrOxnDchZAvdiYXs6cI81Pto6 HX4dWqOuRDivhyAT/zlVY6819t2jrw4r+yzLZKj7y26e0tp5K0/a3K0KhD1ugCyzq0LtRoTRmxhP z7OfFrYTA9fG5/15YesuFbin2pH2pMZkpsGZCQ1V8+f46QUJ7thFVZK52MxW8s2a/988cK/KV/K4 vr8jQNhjTu1oZXr37rJr1rBv26h9XdWHUPlp4Xgq9k8GrsZjFa4ncOsGZfxfQpjUmEx/R/1c9TmH Sf+YDl/KT2tZNO1DEJ9lbe0FBen3bemebVldJehB2GOOra6+klbrO7e3J7JkN18qNFez0mda2ceT lf1Y4IaTR+PJwPVnn/ds1pVxlwvc+vfHh4FaF/rMrVEPJZzsQbSmbFEcz3obrE/xcJ59CBxDIOxx YzxwWfZWq/lFqULpJfcSYlPou2sLXHfpwG0q99aUiv38fyRx9Azxx59Z1b9fnbfpyblM26HSh5Bp Q8nUSxD2uBEeu3fvtqXdXnFSxPq0rA1TOF9p1rfkIoF7GLYfIXAnvsPhwEylH+Ds3w3HX+Lw+oG8 OWl7VqNRj9k73Tcxq5eA9v0egQ/CHjdHlvWkV3q/4JckxqHPstaEMfuzD8fxUfDrDNxjvz/hO4fR G867+cph4+XH/1596HVMOOfgfR6j9n7qL/XngzrzG8+fP5em8gcIe8yhr91913FdJ2VfQq5V6yjo rbK30J01cMOxqn8UlueX+BcO3Fn5S95W8XCTop/w3r5ywcbtq8rHpDmfLes3lzmIcPUFGLsAV8Wm 3fzhD0/8Qfq1leetdirDks98u4qhlWyCocadj5VPyddX1F70oaWv/mJ2dA3SRR5p9Ihe/NSnhQ/P O/mwdWtive1RZtv+Sprnfni+d7b9x1/Ya6uUSXN3Qm1MSsmLQb4/KH9++3/C9vZmfPnyOZU9qOwx v2y5Xs04yYNNMqnr7HoiZrB5J/kZBfKU4fU8d2PDMbMettWpQ93LGcNBfnpNZDcGt8XKRlsxS9N3 tAXN87OzhoG87hff0gZlMNR9ZvcbP+AYAmGPOfaXv2zJrVvfyFoeJS42V82GKtjESd9ML9T/xjPC ckrgxqhhWY/by4xh+yFwDweFLGzTpepk/cVYic+OD8tMFY5/HHt+kCh5kgmfy56c6oawqk/QinS0 UfnBbbgtDicQ9phPT/Wx5aww7WqVulC1NeJivS7OYdiLXG7MXGJoTlxmM4TticA9ClZ9+3zmPsDY S2lvQON49lOlYw1WGJ1YzlM2cbvtXo1Vcl4bAl/0S7+8tOo61cC5H+pdCRD2mE+WUR1N+6Wuc6XN MvHJ+2iTCp3FZZ33sw+6jIXm4cnNCwaujM3i8VMC92SHIo6F/If3zGb6R1OdfE93fm8g1sM4zY0b h0Vf7nhmXoKwx9yn/Ybr/O295LmTLDkbo7eb7tlZSK3wg7cKd4aCeDT0MTa+fuL3Zg3ci47aRH3P 7KhxmNxViBPefXxb02FYhxORnmXHv6lfxkpLep/F2FxhXI/bd3KRX/76k77I7zmeQNhjft3RR9eW SRCbTujsgiGf21COPmYZgjkM3GlhO3Pghgk19MnAtYYhfhhakiTnDhPJhJO8h9saxvsAJ84/xCqc 2iixoNd9ZBNzbJ7QsJCT14UBhD3mk1Wmtkpk27XqO2mnVNarXtbzyD9m4E442Xs6cLPZqv/xhiRN /2cko16JLWo25YWOb3O01ws+xei9naf1A+l2i3oKE0DYY2799a8/ydLSPeeLgUi2rBle1iv32vx2 n5r4na/AlZkaEpemj6PLhPeZNasrawUt6q0HpI2h7hpZ9+uu49br093POKRA2GNedbv7spK1JQQL eq1aU6ZBFrIqiZ+3wI0T3ufM6Zkazk2/4UNjlWa4NnH884RRA2dfaTUfkw1vaeY35zlEunlHuzbr HEgg7DGfrBL9H/pY1//1yoEstOqLqGzlXh/dh8p+HgL3sEcRz3gfmdgzyKZsUpTsjNYljTVUfqyR q5zNv7cWMXi7D21R2Vpua+7t25/FPX1EaQ/CHvPq967bey1Li6suxEF94tHGpOuhHDsJOWPgZu6s YZjfHrjHG44pz8/Oev74z2I9ofTshuNk9yXWTZXuEN0tWuDbrKW8uegs73XkEQcSCHvMfWm/tubK aiBlMxxtF1NlIWgOiwX/bIEbDgM1c9cauJJNeN9Rh8G6JbM0MtN7AW5qz8N6M95nKdj5C9Gt0Aax KFo+i0ONfhvC2eF4AmGP+bX09mcJ6y2RxZb4wi6brSfJaOjbUI5Nwzw/cA/DNoqGbZitqr9s4J61 8kI6cTGVnNULmHDe4fiduT7ML7LOh804CqHeGdFOzAbrAbnKTmRLbB3ILUp7EPa4CXzZrBKpMV8v gpZCzJrgv0DgptMBf9WBe3JF5HT0+qevfT3ZaYgpnhqI9+Mj8umw0Ti+zePTSkPdIYmZNYT1rbwq keX6Hi6kPQh7zDPNqP4bLwvteiEaqWeaaJil5oJaf17gpmNhfoHAnRC2swbu8b83DUs8XIvnDONP iKMeS5hh5R6JY0tGxGR3K2lOYtvFVRr4/b7IQf+1Puc7jicQ9phjq01lX9VLJTRLHKd6RMf58dCd HLhjlX8M5y4Scxi4FwnbU4E7YSusQ5DcaCjpWMNzRotxrOcxvakYb7DsSl/d5kyS96mwJe29DIqu uMUF9+LFCxbJAWGP+bS9ncstLerLBc29gYZXlrytT2x31ZYTZffkwB1PUBkNxcweuDKxZzA9cD+8 9mS2+U1jEmcK3lT3IqxYP/8ysdh0PXQnpCzU+6hZ037l1i23V5UcTCDsMZ+aSvSP9dehbxdU5ZJC lYnL6yWOXYjZdQfu4WvOGrju6L0nn/gNR68h9RCTn9iAjLc4+q76mjOvuG/3JLT1LlP0Uev8qvJS Vj35Lm+51xxSIOwxz7KBFqteY7QVLPnsEtHM13Nupix5eaWB2/xs5sAdbZKkGRqSqNl8cim3eHo7 5AL3qrUTyKmelmpDXM77zC5EW3E774PUK8oBhD3m1SDv2dR6kdSy4tpOymbR+Sy5mE0LXBvL9zOM t9vCaqfG5ePpv8weuGnUa5i2FoM/3ijNcEpg+mtNaOfqFixlwS7hymwBuVJaZSXRLehPNzmYQNhj Pi29zySutp2vhhJyu8G2VvT1iIoFvWRTA1cDcnqO+gm9gEkh++Hpvp4kf7oHkM6p4OOJn4+vPpmO lmk43u842SuZpZdgFb1PTot6m45k+0g3ubJOS+EHuZd2wbEEwh5zbjjsSbuV28IvNuJSD+NIsju4 xjOuiDrjdoVxbOplkmN3BqlX3LGbgdti+WLLR8b6R+no7q9n8NNC3o+Gi5o3jIcT+L1MmOcvx3oU zev4GdqsJEH7PvViCTFlUayujz5U+gX/KkHYY77ZsMMbt7Ky4qr+0IZbvAsWYjZO48bG7P1YhRvP vd3gYcDaNPT6etxmGostgpl8Fe1KVzsdqzGf6iFw+36c4eRsCpNn7ohutL6mTRayy1wzV3dO9IUr mzsTpTn5Wy/COTZf3o0t4TD5vcd7FdYY6X5JNs1eNzbzdgPHUM+3lyJ66e5vy+Kdh2e/IEDY41Ma aGUv9UwcG4aPdhdaG5QfVfYfKm4rbE/H2IShl7pDEF1dY1f1AE2d53bpabLzma7O+WBxrG8Wkv0s HbUK018/jY3rj90Wq35lV6/jY9vcqq/+tW5DGp1ETalexdPCu24EpL4uaqx3MN5wjDUox4by0+ij a8Tr++gnsH1ke0qW9Qd7Dx5wIIGwx1yqk+y9VqSt/I60NHdHNwfMRmdgR2P26aginryMcTw2fGNL xtgLWfWe6go3hGZRAa3pk5SasJVkWamRX2oMF/rESjsUISZLzub62eOrZ469fnYse+tv2PRO8ZnY NNGkQa9ftet5RUFyXy9YlnJ9hrZk+m8nSW5XBttnq3soNn1yNOUzSZx6D9zUXEpct1hSn6vQnSUu 08z3RVFpa6Xv2uKAAmGPeaYF6XLpXF/r7MxLHfgpRlssOE/1qLeT8wYlbOVKu9Io1aM8MY2Gtyv9 joa8FPqEQo/coYb4UF9wqLk61GJ6GLRToZV0kWWu0myOsSzH26HTTszNrMJQWq2WZnayee95Jakd Xb6o7cmCd9LSBqTlXa6VflgMLiw4u/OiS/qQlm5T3qwGocFvw1f1eJI1a81E0UnLNdgioHVvIPms XubYBy+634r2QB5o2u9xNIGwxzyn/bAobRRHi1+7t6rNwfRW+WrZfHh9lD8KP38UfK4+0VpXu81Q to2/l1Efmr6FpudQvzfU1+trkPZ9DP3MZb1CEzqTNMxlYZi3qiKGVMVQhJaX2ButpbA845a38gU3 HNoJUhucqbJ2nuflYLiQXNbSUr+VWllL339BX3Y5BresMb6ojcuybu2ifoB2DHFRvNhzWvXc0+Sa 8xbNiNHYLRWbz25j9j7ZMJSW8tY7CC6z7sOSW3J7nR1xiwzlgLDHPNN09X2RYGPcNsukDjPJNMGz Zo34cKzCrYdnrA6ONgkx01+zGzjFIorvpxQG2kPoavr2Ygh9LZ8PSkl9jWbrPAwyq+RTVlZ5typ7 7SpVIbSz9dhdtf7B2/o9Zq+QNVxbzi12vBSh7yXPstaiq4dvpAp5KHyuqd8qYlzKNYo1yJe1B3BL t21Z383alJXk0pI+lpNV/dG1m55Ksspdjo3fWzOnnzk0C/xn+jt2R0JflEFbxoFkHEUg7DHPFrUi zdrrMkilnWv00YZw6rFuG+OOWtmPLwFso9f1mcpUT0C0Kj7Eof6tr0nd0+K+o4+DlFr7Mcu6kkI/ VLGfghsO2lWxVmbFrtbx8fZB+D6she17B/H9+3766c3rtHH/SarD+xK2/vJSHj5clTt3lqTbXfb3 igXfr3p+ff0rfzDo5fmw33blYjsupIWskOWUazHu/Yq2WWupqtb0g6zpx1zRD7WsLdiirWhZf/a6 lrfrvZoGL9bnI1KItm+kbgjrE7RlPf3yvtvaeinNqD/roYGwxxwqioHGmE2tj/Wql1a51icx68o+ SL0ygNSnZ6NWvfokp8V6NkwxaH9AuvrDjhbC+ylVe9pUdFouHthqO91qULTl1nCw0K9WV1eqnvsu dN+/SncWH8cnWy49d8/d06dPx+bYXCYkbbOe1CcMnj9/Lnb7rZUNJ1tb/1se5n0ZDtf9wkJ/8M3i 15nbG7TcQtUpY1rQoF6KPu7re67pB76dYrydgtzWz2kz/5fs5K3mfC51Azha7EcD39a5rCv70JzI 1n0jWTmUzqAk4UHYYx4dnnW978qqI75lS19GK+4zLeDz5lirV7+0kLMh7GA3a9I8HoSUej6FA/1a Az7tR0m79nUWfSdVsZf7dr9X9ctCQ37lzkb17X0Xt7dd2tKAf/r08Sjcm5k3z549+42fo8lYOZr9 f/h6TfP0/LmTjQ1X/f39Kz/M14t/n68MimE3l4WVblb1tKHKOlUoD7JMtEeSBtrYFTHFdbGiPtVD PO3m1W0sX/9f2akJyevAt4YxBO8WF53rcgktCHvMKRt22Lj/g9OocsMy2CqXNk6h1WqzCFpqKlcb tAm2OIDmZ1+DsKNh974O+OjfZ97txUorex+6Q1/2q74U5ddlWRR74c6dx7EJ+KPznek3Z/vsjUD6 0AA0Zxgs+L/R4NfeRdlu50XcrYZLt5f7WZn6+vNeVRXDVp4P9feG+okrZzfvsssBnF/QV7Cpnb45 H13fdT0T773duSpoZc/QDQh7zLXOwTtZzNoiWbLJKN5OTtrc9HoeuU0+cbE+AZsF30t1BZ9+lei3 9afvNet2+0XoZgsLvap7UPj+Yvm7Pz2qnvzZRff00ScI+OndmMNtaSr+x9E9d+G/PnwV/t59V60U D8r2qh9674bRTiaH1NMWbqjNW2mX50YXV50N5djcy3o8P9Xr/buqymx5ibwS6fR3SXsQ9phvRaaV ael9lmvcVa5e7TLavWhtgowt9+VcL4rb1djb1qr/72UWt11o7aas6qYqDGKnLKuHB+FN/z+E//xE 0/Q/iY2mzOmSAUcVv135Vb148SK6rfUwyCrtlCxW7X4o8rYfaEE/1AreTj4XLvlQ32k8pVtSD3HZ Rbl2LYLdeNxm5xTylbvr3rGiPQh7zLNKK9OWF4laqUYnNt+8Xq1M7OpWq+hd3HUubGt1/MZn4W1V FO/zdutgt9oertxuVxbyT/9LU8k/e3Zj1oUZVfsp1tvcdfHfuZ/DymIsO1VZ+CDaAqZB5fxAd0hp /ZvU9HaW69UdtLr31iCG4EubtM9hBMIe82yhn0lcCfWYfT3l0IYq6ok3KdhceQ35XYnZL867NymG t+0oO/3+8oFbqobfffPHanPTxRsW8qcqfdt28+LFPye39UMc6IdeardLCYMyy9tFFYLdhz2X6Nr6 UXNbsNNmZIao/R9bUM0vum5/T/60xPEEwh5zXdl7m18o9axKW9nYLiQNqUiS9rS63dYS+E3mw1s3 HL7brgYH37jVwda7jeof/7G+N8lnscKjzb45rPL/5FzcXnwd9veLkOUx2J1cYoptDfgl3R9tLfKX mtuy2Pi9SBaK0V22nnAwgbDH/NFQc/9PH2U1tBVhpD55GeozmGWSrOsy92vm5O8S01tXyU5WrXS+ ca3BltuomkpePrOlfMer/O9StvVzCsPcVVmnlaJowMfVVM/Bt0UidE/Vq/JntqKzyJ07zg04pnB1 PLsAV+dJPfyQ2Xpe0Zaht8GbFLRy7ccY9lxw2zH6X7IyezfI84O2Kz7joD9e5W/+g4srG4/K4N4O sn7Y96HccVX8JVZpR/dPJ9jyEJb1o6UkeoN9ZuOAsMccuzO6S7bVqSFpxmtVH1xXo/x9FcK7WMXd wg0Ovl+Ogxc//hg+96A/Cnz9jHY+wv3Nlb5q9aoouynFX2NM29og7ur+6sWg8R9TqkJRB/2//e0V gQ/CHvOrqgq7+5KNXoQQ00C/2quq8E4D7X0qUie4O4OD//n76sWLzfglBP14hf/m28eh28+KFHu9 oIGv4f4uhrir3Z9eqGIZqhT1wZ2pQNhjflklasMPw6EtelPaAmelBn6/iqmjNf5ezGy4ohq80SJ/ 64fn6UsK+kPWk3n3v16HtXJxkPvY0R3w3gLfJdkXif2QpNLQT26X4wlXixO0uFoaUna7j1CK3bG7 dMn3XBb3QvL7vpf1BrEqNn7cCP/w4unYujNfEm3gnqS4u/NT5VvvBqnvD1y+sBtcmde9IYlFzPIQ 9sv0H799TIUPKnvMp+WFNTsjm8S1qxhcoRVrTyv8gxilNwwHxcJwWat690VW9ceq+7uvQzeUhY/t brDVPVN6r3tkL/OuF4f9UqpB/LN7yQEFwh7z5w9aiQ57VtVnWthXZXDSD04zrXLdPMbBau7KheFe vLkXTF1hde+exP4vpd10pact426s0nYMslO6vJO180Fr3VcbP25T2YOwx/yxSjQLhd1SsHSl70sV Oy7G/dIV3d4gDPdDq3rzbx0CTD21Bu+Rq/a77cFyK9/PvexI7n9darX3l/pLg/3Xr8PWD1tfdA8I hD3mlFWiw4W9EH01DFk6kBTfxeh32qXsr4a8b0M47smTSIDVUzGteYwPnSt/WVztt4ulzn416Py6 0+1vf+2KDefCs2dPCXoQ9pi/oQmrRK0itcrUKtTosx1J1bte0e78EoqhjVM//eKHcI6kZ8+epTff /vew8eM/l9tfbwweDvO++7ZTaLNZbX5h01LxMQoM4OryS/7b5gu/9cMPmftbP1+6fSvrH4Tkvl6u Hv5tJ1iwWcA5R+Cf3G/1DhndbnZ0ryz2EajsMb/VfVORblRWod7ePRg4rVitciXoz95vUq+L3/xJ 0IPKHlSqAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAIAb5P8LMABd2b2a3/OL XgAAAABJRU5ErkJggg==",
    transform: "matrix(0.24 0 0 0.24 440.16 380.44)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st107",
    cx: 485.44,
    cy: 447.76,
    rx: 8.71,
    ry: 5.03
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 377,
    height: 432,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAXsAAAG2CAYAAACeSCZhAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAJchJREFUeNrs3c1v3Nia3/HzHLKo 0quttt1ud/omxkXPDGADAQKv7iJoD5DlbDXr+5/Y/jeyynq0DZBNFr6YxSwCo4EJWgEGjU43YrTb V9Zrqd5InnPyHLJklaWqUsmWbMr9/cyobatKJIuX+p2Hh4eHxgAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArjNhF+BzFkK40DEuIoG9BsIeuOZh/kG/LDQE IOyBaxfup5dz4SAn/EHYAx8/4K/yWD431Al+EPbA1QT8pzx2A8EPwh64upBv8vEaCH0Q9sD7h/x1 PEYDoQ/CHpgd9J/TMUnog7AHrlnIX2T7wrR/E/gg7PF7DfmLHIfXvUuH0McnY9kF+MTVvJz6+6yv a1lQbb77Gac1eACVPT67oJff43GooW82Tqr78PaDU+WDyh6fedBf54r9wjbqwH9nP5Dy+FhSdgE+ QdB/tgH//JzPNqrsZVTlm2f1/qEPH4Q9rn3SV+GnoSZPRpXtxicO3IY0BuHMfiLwcYXos8eVV/Wn g/45x11lOwa+7pStDRN0/wSqe1wl+uxxpUEf/yToJ7vzXPfFRr1/nj0zwggdUNnjs6jq73C8mdUX J/ug80gre239trdN2NiounWo7kHYg6C/isD91Ah8fCxcoMWV2tw0oiEW86yxgfupG54OIzBBZY/r XNnH4yuG/Z07RlZXOdZmVvgdE0bVvaeyB2EPgr6hFhff/zP2+ybEsH/8uO7GMXTl4ArQjQMCtyHb /fy5MaPABwh7XB/HVf11DWHgc8I4e+AKZJmReb8ePKire63qqwva9RIYcw8qe2CusGUvAIQ9rkxd kR4PudzaqivXH38kfAHCHriuv0Dphzdi2hAabRDDixdVAxnqqRPiiBz2Lwh74FIDF/jc8UuCS1VN k6CV6ZMnRrRStY8eGYldOATybGVpQp6boBW+M4y1B5U98PmdGcSg538FEPYgcAF8MH7BcKmOp0qI X1tbJolDIGOQX/cwT5Kr237nTIjV/f37xj9/bvzjx8YbunFAZY/fo6sMW4CwB96TVqjVHaE//1xX 9Z9rWG/bD/9chX7l+lXGexEec+yAsAfOhu22BuRd9gNA2OPTeFzfNbvdNpJpVd+yV1TZf6Sgn7aa nZ1L+FzlqLy/MXqoyyMOHxD2+B27e1VhO4edaS/cOX2qwf9OaCYueuFSHY/GefHCJDduGHtwYJJW 6wpH49yZ8L3tS1rOmGT3akfjrK8bPxwar42X++kn43liFajs8fl6n8DdnfTG91j37qf96PHaw9oa hwAIe1wjccbLP/6xvlHq66+N2dubczTOJwzcTz1a6NYtE7Silz/9yRj9EyDscb3EijWd8yj7HIdn HsxxYTpen3U7Rv7wh3pK6Dg1NEDY41p49MiYf/mXusLf3/904+wP5hwFtH5F659nufF22Tx2YQ05 bkDY4xqKlWocLZN8aaoHYB7szw7eqwjcy1jmob3ahipOcznYNdJfM7LIYYMrwmgcXKrRaBwb58VZ WzPJ4WE1P461HxiYVx24425e8vI652y78yYMS+MXe8al/9EUD+r8ZzQOqOxxPbxOjAz0q61hl1ww rG9ecgB3LrD+Dv/TgbAHLua2frVM1YtzbQI3OTq1nR9hSGRq98TcXTfZj0aev6znFQIIezTfAw35 fzWyv2Rk4T0q+08RuO+7Lnv0YV1MK0smlGbdDOLdwFn9vfi0L2N4qAkIezRYnPHym2+MlHeNuaUl ev89wv5jB+5Mqx/4ety+7vTti9cz4jWJ7I4xL3/gOhoIe1wDsSL97rvRwaWVqm0buaF/731oGF9x 4M7Uvfr9Fq9JDHeN3L9vTPz6y184lkDY45o50qC3N5ofuNVq7NHc27dqVi5lnSJG4vWMjEMFhD2u m5cvjdy790asvV3N+dK7QMh/isCdZ3k9eXe7eubog9e3tLwSuocdScog+1kpd80X9QtP9Osp/fYg 7NFgoydUmeHwtul0jHzxhVb2F+iz/9iBO255xrpPv9bvd2WOBZ5X1Rtr9T9rq+bWwJhX6UvZefFa njx6pFkfc54ufBD2aB6pKtKR/WRXVpNUul0Rq2HW685XsX/swH1neRfpL5qwXNs/lc792Yuwur5O z5is7MiBVvZ/MN+Y1/oFEPZosFBl/YsXLyS/e1fulN+YfM2Y7uBI1rqxupe5wv5jB+57Wzr/e9Kf /Zn7EqrK3togyaG+9zZHEQh7XBuPzB/0v68P9mS5TCXJtbJf7cqZEG5I4L63CzQi07qxfL8KetPV hnD95k3z+vUrfd+9uukMdTcPQNij0dbX102+oMX34EgrWM0tuYLouoTA/RgGUz57W4P+yItp9YJ0 5EDM1/eOsx4g7HE9HB7uy9JSIv3cSpLUYdfEwL0q4zNYyqTP3dNtamtlP9ASfm2l+ndr+7Wkezti HjzgAAJhj2YKY4MEY3fErVv3TFkeVSNxBvq11LTA7V1x4zLWnWQHE8LeGuMH9Wgc2++KTZyU8bbj iY9WBwh7NM0j/Xp1z3TeHEgIibRaInbUh/NRA1fDdjAWtnZC2F6lYX7SsC1OXVcw3tdnPPNewAbe BwcXLrGyr+ayl62trbQsb7Vu3rybHR52s6IlSTIU+ym6cIajAP0UDwUZyvmf1wcTWlnbF0XPLctS /pvfHn5p7uQ//LDpNjY2mNMeVPZosrq/uZomIVasmlifonKNYXtcUH/oE//a561reDbYpX3+cuP2 WelLPPPoLnfkS39n9AoPogVhj2tgN92Wr2xburEbR4M+VthWPqyyb180bOdJ6XkbjgmLyvOTddpJ 3TT5+cv1mf7ssG4Ml82q2d57I/HCtjHfchCBsEdzbW4aefjQmC/NHdPtduqKPjNV0MsHhv2swLXT +sTzC65kYfK3JRcpTn/vEs5TbB6MtIwMdN943Ve3b982d+/eNt9/z7EEwh4N98svP8ra2k25c+d2 NULHDQci+Zzz4yxMf+mqAvd045BPapRk5qa9/+qqi7jxLlrjk96R7PdzuXXrCw4iEPZovr/5m2+N c0Yr+yOxy4lkoz77uW6qGlXiHytwx7ti3q6mffGThPa56xlO3HrdIyHuFzvUxnAh7h+CHoQ9rpkk 0SAdaJ5lddBP68a5jMCdp2t+UuDO3dd+TitTaIk+63WRyQuI689HZz39vpE03ZOXLw9kY+M+BxAI ezTf/v6umOUFWa56X4yUxdC22wtXFrjx7fKegTvfKYAGukxffvYB3UlSXc8YyPJyy/T7HDu4Goyz x6UZjbO3z5//3Prmm/vZYGAWrR0s9PvDVpK0rVRh+WHPY5oZuOf+9PnvKIoZDcYcm57NaJEmLVv3 WXDOeNP2RVK0BkmS92/evDm4f9/EyxOMsweVPZrt4GBPFhdjb33ytgtnntE4M8M2ViczArd4z8B9 t8qW9yuN8nrDyhmN0eRF19Mbm9iVk1B8gbDHtXK/+m+/35PYb2/jlccq7BfkvMA99xrulQTu+cpS 1+xmvMHV/U7ZBU9cRv311SOp4k1nHf3qv3opP//8ozyOj/wCCHs0Nurvxz77fQkhqy48hmCkLAt7 XNk3KXCLYr5qutrmwkzvypF3G5OikDmXG0I9SqktA/ESn8t+VD2piqdVgbBHgz1//lwWFr6VxcVv jLV9KYqhjZdgY9U6bZz9VQTu/GF7gcZGzxha5ZSV27cN0oWWq42gxn0rtFqmGn55VOpPxie//Mix BMIejVZ3PSTJgfR6TlqtVGL0OWes91N6ra8gcC8SttVfNG1PWp8Jb2zFtiSbu1O9Xm5rjsYm08o+ VN1cx3MHZa9fyZAnmICwx/VwQ+v53bfdOLPG2V9F4L5d5jmBKzJ6vTx7hnD6x0WX6eYcTSSSzbV9 YUQDX89+WqOHvBD0IOxxTRwdHUqs5GOMaeBrVW/stLC/isA9L2zfbRCmtwktN77yCy5zhmz0mYP+ 4VyQoojDVge6rxIOHhD2uB6y7JU4tyJZtqiVazE29PJs50oTAndW8T/vss40XJNeK8u3y3Ktsjp7 CRLH2Qct69Nq/8TRSzs7r3Xf8bQqEPZovNgN0TFFMbAaa1ar1dhfP7GyrwK3dTnhfZzcFw3cWU+s qtundMp2lRO2q5zedp1up6pHvcRWsKWN49BmmZVeT+Srr+IF5hdSP/ILIOzRYPW8OCJhYUFOjIZe ng5cd161fJHALU9F//mBW7rzLgOUU84M6j/HLy/I2LLc6d+w059TG5ng9P9doZV9Jnleykr1Qqzq X3IQgbBHcz3Wr3/deS3FrSWTWyML+uVcaZPxyj47HdjzXHOdL3DlVHDPE7jTVq7bXY2omfZL4k4W MbV10SCXGU1PnAI66H7x+j6bJFb62kjmu9uyukpVD8IeDfZi9YW0Wo+MdUfVSJx4M1UcZO/s2AVa d7pyn768Cwdua9IyZgfuNK1Rd5Cb1F3TmvLr409/ttaEzzN2BuRNMJLo3hnN93/UE5MwawIIe1wT /X5XRBarAHNObOzW8b60Vx64/uwypgXueQe/H71D7Nl3ltUyygv/ip1utkK8qqENoguJDcPcpivL 5sv+smHySxD2aLhHZnd3W7Js2djCi7TjZGhO6gu0LWlS4JbaCs3+OXf2x4/vkE3r6wjnfw4341+j bpys5cX5+sHsfSN7rTfSNrfNs2fP4rKZ9RKEPZor3hwUsz5xhfU+zlgfq/pUmhS4x91H7rzZOMfP Fuz490oTm6+4fv+ev0pV2OsZj3WJLWK3l/TFcviAsMd10GrFCrWnhXxbNL3EhtLGp6zGCr+JgWvl /Z9kGzehmgYinbGIclajqJW7002w9SBMOwhyWFr59dctXeATfcdTDigQ9miW2O3wD//wpPr7QCv7 NPbXF9V4F2uTdKzPvjmBm6bjF03n/XUo3/kVqua08TPGj84o1b2Pj2RPrOiZjw2ZmCVrvjgcmCMO JxD2aL7b+tUzZW9gTRZsCIk1GvSx375pget9Yo4naEvPG/D/1nij4s4/K5khhPgkKlc1iMYXtjX0 Yr4Q81DTfosDCYQ9mumJ+emnLfn3K19JuebjI5gklPEh2qbqoahDrVmBKz4OFTo5QziXm9SOTD8r Kc/5ZYtNYemMTeqBqTLUP8uOyOrDB6Q9CHs03BfGDLsi8amzMcjEV3V1NRla0wLXxbHtFxnvMvoE MnZhWc9c5jqhiJ/NybsXpG1IfDVJnKkD3+ZBDFdoQdij6R6aB+bXzp6khabvspHMGyl93U3hQ92N 06jAPfVz6YwGwo2v74L7xes6kyrcT29bnOg/WEla4geFzVulpEdDXc86BxMIezQ67Y35Vb8WF82g 37FZ0rKxQyeN3Tijyr5ZgfvuacLxiJ7xBqI43lYrU84sfDWs5vQLekbzdltFC/aJZy0+xOGXNl68 jpX9ommb4uai+eWXH/Vnv+V4AmGP5oo1aTfvi4+DLeOFWY2xwrkkzgNwtYF7dlvmCtzx94/WM774 JMw4VTheexl/7p2fmqsxKrUJslazXv8oXG6TVir97mG88xgg7NFsnSORciXOPN8S78o4Y0LdX6+x f/WBay4cuEbGu4NG3xr7FTm9vd5PuxFMpvz93c/17ve0tvemmj0o2ExsbuSGuWE6ZpsDCYQ9mit2 PyzevG1sT6MtLW0IogEfbxoSG/yMS4+XErhyzr8nB64J0wfyyIT1zFN0+wnrCWFyA3Gyj7RVzEW6 g46YlW+5pQqEPZqt2z2UJMmkXaZxZImEeIFWTi7Qnh+47/Z/v0/g+th9k5wdthPCzB+S0+sO5vzH BJ79PEnsij8jmdBIxSGjNtb2SWwMS1tY/c7aWn1hg7QHYY/m+tbcMAemVwzES5wmIYv30SbOSRKf RTtf4MY89HMHbgzQ5NRb4lhON2fgvvvqpOX7OAnxVGHSmUH1Od7ljs82xlZj4+Q4wVdnPXEW6Lw0 Msg7cnCwq2+8z+EEwh7NEwvR/xEr+7QjaRlnu0xFK1xr4sQ4scd+VNmfG7jWnBlwPytw4/1IYcL7 J713UuCeDejxH/XVCH4/o4Eavwj89meSiSs2XpvA8YsRXneKpNbFfeSr/SSy5hh4CcIeDU/71//t Z7l37wuTa2Wfpc5aDXiNM1s6n9jRdAnnBq67WOBWDcGpjh2ZVKhPCdxZVX0d5rNn5jx95lH117up bx5bnzMSUhNcmVixGva6v8pU+rkdPZ4QIOzRULHjwfU6Uiaxsg9Sz4cTqtCPlWtipgXu7K6aWYFr J4y6OT9wk1PL9zI9zM++5N+ZnuHUacVYt05sgsLbZZ++vUs3Mfg4BZyrLtL6VAqbi1m19TPbAcIe zbZmbHEguVuwJuRadMeJfEOisW/dlMCdFbaTAndm2M4VuH5ywX38ahi93x7/1Kkzh9EPhDB7u/14 Qzapwaq6gCTxcQW+OhOqpoU2K/c5jEDYo9mlff/oSGwRO9LLOK7eJrErp5ryK1avMRzPBu6kHppZ gTtv2M4VuJPOJEar8qP+eDffrD3aaE2ao+f4Z2WssfLVaNRg6ztoQ+zm0v3jrGjyG7O9/VLf/A3H Ewh7NDftV8wrM9DqNKSi2R6s0SDTSEu0bLVV/3YDArfqRjrTtWKmniyIP+f9pxqtk+VPlsTdEvSD xfvMdN9o0lfdXLGqH+S6/W1jNjc3efI4CHs0U6xIV0wq1cj6oppmvprRMY4kD9VoHN+MwA12NCrI zxWo4e0ZxfQ7sPz4lr1d9+RrEa5aolTrt1WJHwcVaeuoP7e8YsxBybEEwh4NVVeif6qzroy5GKcA iINwfBIHFXrjk+YEbjgZFWTqPn17phE5+yxEd07FfnJNIqm6mOz5ZyPinL5ZtLrX/TV0pU3SBflG fzNfckiBsEeTJVqgGg37opS6L9qGJFRBH7+SqYF7drz6Rwvc2JDImW4if+ofdloX0ZQl+iDT11zf TOClGpuaBCv10Eut74fDnux0FoTB9iDs0WiDQU/iDJfWxonQXHVhVlMtiVW+zLig6iZNZnOlgTu2 ZDFy3hQMIQ6Lv8jEyrOenuVHWxUk3niWSLyuoc2i/kOWzbJ+0tiPs8HBBMIezbS4l4hfzYy1Q82v OCGx2DhVgtatcX5jG+8YPVvhjv4r53fnXCRw43igGLdV186UH9KgrUJeqt6hOpyDmbwdWoTP2D47 1nCMfv6cu26D1ajX/aGNYVI9trF01qeJlLYnWZ5xMIGwR7PFboislcYHgFtvQiJx8oA4DCdeiJSz UwtEZey3D8mpmRKOO2ROJic7Dtz4r7i46m++vm0r/qX+XnUdoMrPOPWMxKnYQhX88Zl/9c/oMuMF 37g9LviqUaqerxKfluuPGwKppmjwJ4P8pR4OOukcwI8amHDqqVuTzxficiROiRO3Id6DoKuqtqGs bqoFCHs0Wex2eFX12ftQaNJmtn6kdkzxEGcmSyZVuMd9HlUf9ql+kJMglbfxL6NbpmKgVwEep8gP 8UuqacWquNW/6+txZp7YxV9qajtXuiC2HEVxTNUkvslWs6ZpxAbdvjgpWex+qUI/xPagqvjtaHLK 2NZIdYG4bpVOpmWWuhE4O8nb2L0EYxeWbX0GEKrGy/skxNmDjK+eYtLStmdvcVva9W20Yi7+UC6A sMfHEceL+2oQeXWVNM5ultTPH7Rj4edlnhSL/TZ1jtfVewzzUD3yo3rih4vDfvR1PTmIhXk1JVqI 42vEWi3a9fvW5MGVpa47Pg0x1N0n9WghG5uh0rc0yzON2tSE+kFaVSdQPA3wVdWd6urS6k5XV98J bEpdSv2Yc6nyv5r1IEyaw35i148f9fPE04xQzfGmgR8nQ5PSDgsnpnWXgwiEPZqZ7/E/sSJt5evS it0dST3jZZynTOoHzSZVWI8q3Hc7ON6dN6YeQhkL6yq4Y9C7UZDHIer6d1to4muZ7gvN7cIEl2tR XkpLS/dCv62VvL6u0S65RvHAmiQvjHcxWhPRIt5rsZ+Kdd6nuj2Z1tULuuxMszuNb6nvbZVEmxFt CHymny7TdbXi69oAtGLw64dLqjnYjEtiJ1AM9hBvIrN1yE+74HvcLWTjB6rneCud1y022jppo5GY JY4mEPZoursaVbkpY1JrTR2kmqVMQ9PEAZl2vNL1k7o7Yrwnsas/Jnuc51KDXKt2Tc/ciyulCnaj fzdDfTm3YodB3FDfOdAUzm1oFa7lfJxm07RS550rdWPyMk3i8BbX0kju6TqW4vXQYmgXFpZttyhb kqYtb/qt2NUUGwHN+jgRZepdsWBD0tb2pa3brg1CWIhnAbruzGsjERuAqiFwRv+MDYGvbyILVde/ zKrw66sQ2pwEG7uPkjh1pzhtRbKBtDuHYtpU9yDs0WDDPD67yVlNTSveJXFooY1VvY3F8MlIl+O5 b6onFvp69ExM+NgpotW2thfJ0IkfasXb98YNUp8Mgv5bQ3Hgve8nXoY+80MtsPMs0b+XZal1vmtZ q381Qb/hV33bldmw7O93fZbk/mD1ljYgr82BNkrtTkcO+rr6NEuWc5NoTCdlnJ9mOLRJuiz1JG6+ lftyIZOWBrtZ8KVp6/oXrZe2NjJtCXZBN1lLcdvWhmoxNgT6YbKqgZPjSr96XJdMquxN9UzeeNYT 70mIjYSzuTZhCYcRCHs0u643ZjsdSKqBFazT1I193japOnWcS96tcKXqj69G4mvyx2JYg6/QINVq XfpaNff0lSOtgY90UUdeQt9LGav4YVpouKeSJ2lSuCIre728DKVzWZL57qoP66UP7oYLb7rDsLzc 8928H3581QkP7jwI9VYas/XT/5F791ZlfX1R3nSX7PJyS+LQ0b3ltlbWVvIbfSuHWeKkaEli08yU rYEE/UZYKLTKj7e66hnEkn6EVY3wFf0Eq9qYLWuKL+onWdCTg1Z1ZcHEYTfBVleWj4Pe1Fddq7Sv HnUSkqK6C0xGT926c3xOYIxhihwQ9miYg86OLGY3jNanUhYh0aSzPg4t9BrNpyr7EOoLqfotpxlY WA1xqyGvpW7XiO+4IB19w4FPbEfTsuuMDE1rIS9zDXZpFSvpUnkQfvV/kDW3fbvn9/ZioL/UQH8c +u24hk3zyy8b4cmTejTLySj54wEuj6vRM8+ePZP45JUHDzalv74R5yDThuC53Eu1Ibi9KK2Xa8lg uWXd/jDJyjxNFxfSUlxrMCyzpWxhQT/Aind2VU9Gbto4v7MLa86EZf3gi/rpdHHSCjHf48XdqoWz 1QT2VS9/nB8nhDRe04g3nyVpiHceS6K/mVtbzyVuI0DYo5HyfBCzS4LW9t7XF2bjxc5Y2b8tVutB l7HzptTIG2ru9/S9XX3hMLHJQQj2QNPw0KdJx3rTK5Ph8Oby7fyNL1z74KU339xwv+1th/XVR/7x lgnPzDPz5MmTsdueTgb6PH06aStHUzS8vf3p6dgL7zYET8yTcvMbI3sLL2321SMpX75MBrdbtt3v prlZaA1cr9sqfCdNYuMUg96vG5+sefE3dCesOKfVftVPY6qndsUHsIfRltq63k98fS+C1Y9nE1dI Z1BQzoOwRxOFqhJ9cOehKcqOpElpTanhFQc3auWqIZhq9lezXmoM+2o0pTWFxl0viOlosB4E7w+S xO7lwR9mYg5tknWH5dGgJbeGw3ZZ/r/u/3WvXnXCE/PYP9saD/c62J9OTvWLf5BTDcHTqiGIgz8f +ePwf3b43N679zjPsp+TsF8O/fJKrz8c9CRzRy2bdnSLbuiH7Ornuqnhvi7WrmoFvxT7+OMds/WN VEbbv+pMJ41DU4NoY+hb+t98+lO2AMIeTdA52pV24sWZLGZZ3Wcfb6jy1cyOUs1WU42Ll4GWsx1n wqGI3/VBdhKb7qWJOfCl6w5lsb/os6F/U5Z3vrtTbvzljjdP7lfh/vRyw31ObydLOA7/UN1A9ey+ +6/3Xjj7aqEIi2XeDtKXxdAtnD/Ss5mueBf/HOgnznWr41DR1VA9zMXHKRLikFQJoz77WPz7ODl0 1ZE05GACYY+ma5tQxOusNlav1Y1IppqvvXpkeKnB1tesPPAiuxr9O/rnG2vsrr5yWC4U3WEnDG2/ KO589+/KLQ35Pz/WRPz7KuUbdCfpyUw5ceTQs2fG3bv5wg1f3Sr8+spQ3P7ADd2gbSV2Tw20bB/G CYOq23qrixXV00uqqZ/jrbyxq6u6tiFW0jCUTj+hGweEPZotT4ZiijhM3Vvv4vSXcZKaOD1AcCJa +QbZ09jftja81ld3giv3Ctc+zL3vZ1k2LG/uuFf9v3Mx5P9eQ/7p00ZPFxCvtL4b+uUL1y3zcr27 WJgbC4NWaQdF8AMbQl+jvjRVq1ftk0TDvxXv0tXMj9NAx9mYbWmtfKHL2+VQAmGPpur29+WmvSll NdwwzgLgqxupNOjjHVYDDcQDrWq3bZL8qt/+qw/pnl1Y6iT9ncH6IC3M8g/uz3/eqCYfaHjIzwz9 zc1Nb7YeukH5RZEmB4We6MS7fIexwaueum5jJW9a1lczs0np6mklpHog11CyqisHIOzRUF+YWyYv ++JMK16HtdXUwXE6G2tyF/yR/ntHS/3fnM9fh9zvyPJKx78pBr+Y3dKYx/7pP8Zx8HKdJ/4ahX7w sbH6rmv892s/+btmJc70XMaZfOL0bKEMLQ33thOTVhPFhWounjgpWpyuR7r9A/lu8TEHFAh7NFm7 mhCnnjmymrGyDM4M9M89K/LXYJK/hiTZKdL9w2HSHnz14PvyyUZVzX9GsztKiGEfbW/+Kfz2249+ dfco+HQhXrdO47QLPvgl8SHT9y76as6g2PMlYi1HEAh7NNh3+vVvWpGaZCFODClxhgQfR96YMLTW HmrZultK2PFlvr9i1o6Olm8M/vmfvy83Nzf8Na/mp0d+1YAF/08b35cr//k/9X/dzW1ZuiyksqTf X9NKfmk0UUQ1MX+82cr4RGR93cTmESDs0UCx2+FFVdkbl5s4xaSGXa5Jnmuo7SaSbIfS7bbS9mHr r3bw1ctvNei//WyDfrzK/8dNDfw4u+XDF4PELxx6G9o+l5Vq7H18/qwfTXEv9YNVeoND+bdfX2iD +YjDCpeCE0ZcsnVNtFziAENvQumdG1jn94O3b3wod8RnByv5jf5e93W58U/mdxD0J4Fffd5fTWHL Vm/g8wPdQ2+889tO949x0tPavoxTwMX9x3EEwh7NP10sfcg1tEyh/+dNz4Vw4LzbMz45EJP3fts5 KF59/ch9Xn30c8S9ft74ubv9JE+Gy13nZT8Yu+NLv6+B33OlL5zGvSsDT6YCYY/mqrsd4jNo44Tu toyzUzrnjowzezbI/tDIUXZUDr/67dvymg2rvDTxc+/+75durcgHqfWd0pca+LJjQjjU5qDvCj0x intun+MJhD0abS+OtfSuKEvjw1Aj/cgEf+jKorto3GB/uFRuPTTh99N9c6a+D+bxYx/3g/PDgR26 jtbzB6X3h96Zrgsmd0nqhno+9LdfP6LCB2GP5onhNOzdCBKcD1YK53zfG9spQziSYdLf6SXF7q1v 3e+1qn+nur/10nXdjdz6rBsk1vF2V3fboXWmtzDsF1IO/F/Mcw4qEPZonhhO/W68V8qWLviBVvZH sWoNLhy5ohi0it3yhx82f8dV/Vh1bx77/l9fFWXa7en5z74vZVubwDd56jp5lg5aN/5D+eCHbSp7 EPZongcPHgdbrHqXSFF6LU015EvjOq6UXm/o88MbL93DzS0CTD2JZzf3TbnczQZLPj1MbbFTmnyn 1ZXDxf7i4PDlodt6uEXDCMIezbO5uWluJ7uu7B4WoW/7idOgz8ujQT4cDIwpHjzYcE/NE8LLVI+r iudC8fbiYvHuaj/LFzt9Yw6PjOltf2nyB+YH9/Qp+wqEPRrYNfFQK9E8W3VDtzgMy757ZOxhliwc 3bqT9O9pqG1tPaNSPRFimL/6+r+75R/+V7H95YPBvWHaN193cj1HKjc+47uK8akKDODy8ks2Njbt f1n/o32Vd5Ll23nSfZO5e9oA/M+9n/wmATZ1v1U7ZfRs8dFzsthPIOzR4NjS4Hr21MiDH4xsPXyu fz4Ocahl7KMWAgwg7PG5HVehemD36Bmxx3UrAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAABomv8vwAAwz+KayuE/uAAAAABJRU5ErkJggg==",
    transform: "matrix(0.24 0 0 0.24 434.16 322.84)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st107",
    cx: 479.39,
    cy: 390.33,
    rx: 8.71,
    ry: 5.03
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 376,
    height: 431,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAXsAAAGxCAYAAACDTRbZAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAJUpJREFUeNrs3ctuHEm+3/H4R2ZV sXiVWq3RaNADtweNY0ACvNFqViMDfgWd9TyBX0HSa3jj/dEDeHMWGpzFWRjCAAZagI1GuxuWj1rN JiWyWJe8RIT//6wiWSSLN4mUqqTvp7uaZLEuWdnJX/wzMjLSOQAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHy5hFWAz0FK6dq2ZRFJrGEQ9sBnFOyEPwh7YDHC/Sq3 6QuFOuEPwh643pD/2NvvuaFO8IOwBz484Odte02EPgh74OqCfpG200Tog7AHzg/5z2WbJPRB2AOn VPKf4/ZI6IOwByF/TdvhvGzXadb3BD4Ie3xpQf/FVfb7PxP4IOzxJQS9fIHbYSLwQdjjSw36L3H7 S0cCf5z6hD6unWcV4BMEvXzBhYY8m/r8pDw+lpxVgGtO+ibUnmq4PZ7DxXv+kRudh7pGHulXC/xH 4/VijSFdOiDsseBZP/n6eCrgPmXYzlHjkk40igQ+rnOXklWA6yvqD7tvpoP+OdtdY9MCX1fMy0cu aWOYqO5xneizx7V6OhXsFvIE/aHbz3VdPBrv9Tx96uRTT90MKnvgvar6/X56q+pvL+i2tvbi+pb7 wQOXnmvrt7np0qNHTbcO1T0Ieyxm2N97pkF/W7ezh/MZuPOg13OJwMd14wAtriXo3SToNcCs++az D2yAsMcX7flzJ2trBP2+bvfMdUFFD8Ie+EiBCxD2AIELEPbAEXZg1rpwCPazPXgw/vpsfIwj2TFa 5zhIC8IeuFLt9qdrjL77zqWXL53cu0d/PQh7ELgAPhBn0OKKjc8CtS6Jhw/HffNatTZhftbts6+q ciezbj/8MF4/L16Mh6mOz6RlKwKVPfBBgctaAGEPXBOrXglc4NPiDw9Xqpkm4amTx4+dvHjh/IMH 466KzyHkr+Mz1LVLditLl+7dc8E5pkwAlT3AngFAZY95qewn25W8fOkyO/i6fzDyS/j8WXa5zxnC uLL/9lsXnz938eFDF6nsQWUPXEPgAoQ98J5sAjQbevnTT+Oq/ksP4M1N/fx3Tt5f6a3UW/3Dh00D DRD2wDmB+1HcYf2DsMeXFLj+E1b4dz7d22xtnfK560l5vzGZ8/8B2wgIeyySh+Px9ZtLTtqZk9ZH DvlLBe4V25p15+1ZLR+bCQh7fCb+qLfMHc7L8VkE7u2zf51tz/iM27MeOHm52y4VhTuYZmJyeUKA sMf8a7okNpx780ar+tbU0Ms5DdxL2eb/Lwh7oKlO//Sn8QlQf/iDc2/fTo3G+QwC96pHFnnv5PVr J3/+s3M//sj2A8IeuLbA/dT++MfxV5v5EiDssTDs6kv/+q9Nhd9U9YsQzjsXPIh884rf145jrK87 N7mICUDYY9HK1cUJ3Kt4zd33GHFkM5+NtCEc6q3LFoNrxGnluFKTuXG8zYuj1Wq2u9vMj+P9Rxp6 ufuRh3je+MDnx+hSVbm4t+5C962rJzNfRubGAZU9FsYbrVatal3SAM6uMYRvXGH49i65nL0PfD9L 9sKqeju79z+yzYCwx4L6Wm8td7nrX37swP0Q2d7Usq6/32vc0tvgjnPtH5w8fzWeUwgg7LEY7mnI /08n75addK65sr+KwH1vl3w/v3d0Pawuu1TrusntZLP2+D67+ItznFgFwh5zzma8/OYbJ7VWq7e0 7B5ec9hfJnCPh+2VWrv8Y/Z2nCwtsc2AsMeCs9E17XkK3LWLvYzvv8cy9i+/uKvrzcVLJMt+k1ev vmbABAh7LAbrgvjLXyYb15aTVa1aR3u74jfW5TKB+15h+56B+776fu/Cy7jmVmfcu+f2ZFWqnjaI 7a/dt9+65va3v7EdgbDHgnj1ysnv7ju3q6H99fq6G/Svp5r/8MD9kJ2I019vIEeXa6DBftzyymry uz2t6pO8y2q5474a/+Kx3p7Qbw/CHnNucoUqV2w7ycod2ftqQ4aTUP5YgXs8bE8L3A+xcsZnOf67 4bB/YnlEl6fvxXXW19ytkXOv81ey9eKNPH7wQLM+OU6DAWGPeSVNVTrxLtuW5Y2vnO/3ZE0DbdDf k48VuLPunxW4M554YcPL9BmtzHq+SNZLztc92enX8selb9wb9w1bEQh7LJ5sb1fczXUnGvQWwPMU uH44o3QeXtOKWD55Vze51LNlqtbczZtsKyDssTBSU9i/ePFCyjt35Hb9jdv2PflKg96tadAPNOjn KXBnBLAM5Xr6TmZ8JtG090Nxvt2T3d0gX399g00IhD0WyYNmDrQ3/q2s6yY2ECdrGvRNsM9Z4M4y 8k6WP8JaGlrQew18L3Ljxg335s1r/dx3x81m0vVAlz0IeyyCbFfELzsNeZHhqmaXmrfAncWPREYf YQrKJQ36vSiuHiRdMzvi/nB3P+sBwh7zK00NFLQq9datu+5tvddMl2DV+mVmvtRiV0Yfcdmns12b JDkxmc/g6t9ztKRvM9LKviWS1jdca/ON5G+3xDGpPQh7LIQHent91/V+25EsZTLUMFvVoB/J2R0T RwJ3VsMwuL5FHk3tRjSN0vGWxl/9e0Zv79V05dgoTKndHb33DtsPCHsshu7Ll1LXt7Q+vtOMgPG7 Axn5phNHLhy4oxmP9de3zEV52BB1/UdaUbLkoli/1ooGfk+285H8zt12z549k0ePHnFCFQh7zLtx N0SW7UocZpLsCKQG/XndOJ8kcPfbkamGqPiA1zlvTrOiOHyfJKPU8nahEif9vpPfdW9PfsOFaEHY Y4FYxlv9GuM46Cc/z1XgThXZV7OHMGMZyvLw/fxUIxb1wb49PpaxtrbmNjd/k93dd/rY79h4QNhj vlkXxP37j1yeb2po3XZDGTQHaP2xbpzrDtzjL3Va4B4+4JJv0pl9t0z2Tqrp++S0xjA1B4NHMpTY t3H2X7s7d752f/872xEIe8y9/S6I200/tE+ZFEkkK51fWlrS0B3Jxwjc6vh9Vz1mXZe1nHUMQs5c tBMPFkk27EiyjIlwQNhjwbTbTt4EJ8t9aSr6Jf250uq+qgqRq0zdMwK3c8WfaXrP4CJ7Iqe1W9NP iXG8/NaN07fRqe+25datr9iAQNhjcdi1Z4txtSqFBlom54/GucrAPWsnYenc9ylO1OeX2hPpnN0I SFk2r59UKJLrdjuyElfc0q0V9+rVT/Lo0bdsQCDssRjeaZXa/forVwyH0hHrWdHSdWo0zrUGbufc HYKDwJ1F5AP3C/QNKjn99dtyuAtiDeB4pFJfdnZKunJA2GPB3PrK+WFfQ0xr+lLzTKv86dE21xq4 54Tt0cB9P1V19uufuBbj9LJNftdybW3ACrGD1SFY/5ZNfcn0l7geVBK4Mikl25788+c/tdbWNjrd brtbFFknpbJVZ9Z9f3R7a5/5au0PC9z2OaV92/7tfFCgv9fil9O/LF2WtTTmUxVCLLRVHNy4cWP0 7bfNYJ6oTSQnVoHKHnPMLqS6ZbM6DppRJk03xaS74niF+yGBe+bBXjmnxNE3r8+p/t/3WLJdQNyF U34ZDhLf5blLtk6qqvB53paUbrjXr1/JTz/9IA/tcl8AYY+5znpnV6l6p+FVazm/KiMbeimTWS8/ QuA2YTs8o7qeBG67fbnXraqL7QmPTyU7vxGyYxB1XTVnIIxGQ1letnVhV6rialUg7DHnnj9/Lp3O d9LtamAtD5ox7961xULtyHQJ1xi4Bw3EOYG7/7iqkouH+AVJfcq7+yONUvI+pcOpJDbYgEDYY7Hs 7e3ImrSl1NCTyZQAR7px5iBwNWwv9ZraYI0f2WpNtT4zHthq/r2QECofYy72+et6V19/nY0HhD0W wcPmvxsbOza/vQZY4dtW00fxR8L+QwL3AmE79eXiIX7OM0Qmv69P7iUcf3qoz/9ENs7e+7beoiwt dS34JcteS1FwBRMQ9lgEf9TK/v+K5Gvjfnqr6i34zzqp6lKBe1rYvkfgjl/z/L6kw+U7fRFboXX6 cs1+Zw34Uiv7oE1f0CYxc1yqCoQ9Fkb7zWvpbtx1w+FIkrfqXjTQnD9rroTzAvciYfs+gXvkdc/6 THJ+38xFX+uwsm9pVW8jcjoiRZBshaHQIOyxUO66vb2etFqtZnpjmYzEOa2yv0hItuVifTOXC9zW YdfMrAZIW6mDvYRW7U4dTnnQYMmpf1L11Gsdhn1tpyYkG55aaKNoV+pqbb2Rh22uVgXCHguiCbDC LkQYvYnH++wvGbhN2DbfXGXg1seW5HgLc/z5F9pXOKWxOnl4oaX/BCknI5X8eL7/399xL6oX8qC5 tiNA2GOObWl1euvWstufw74ZjjM5qWqeAlfC0dcKx/8awvGG5PR3DME+V+vUPyh7qeNT+4SsSiGM K3ttDGU47Mvq6iobEAh7zL+1tRfSan3jdnZEul0N07ItGmoHlf1cBW7r+POPdwG1Lvy5W5O9k3C8 MWud/qeWok1mr//VteKrICFfcdvbm7K2RlUPwh4L4Y7LsjdayS9JHSovuRc/OUA7V4EbjzckrVMa kPP/UOLkEeKPPrIO+8syc28jOZfp6qh88Jm0MuEALQh7LIoHTXXabq84KWNzWDYE8c7Xk9E4cxe4 Z/457O8n1Pohzn5uOPkS+naSy8FrH/8cKbkkTtdLzJrpn/1woHtFBD4IeyyQLBvIoPK+4/PJKJyW hn7tP2XghkmXUX7e82fcsx/B4bwLsEw3Xn7651rXwHgZ9u+yU82iNYT2be5k1GT+2NOnT2Vc+QOE PebU79xt13N9J9VQQm49OOJTGlf2nzJwW/vPD+8/nt1/wHUVbTGirw/3bnxyIVm/fe3jwKYQWtY7 l9mAcD0FGKsAV8VOlv2Hf3jo99JvrTxvtVMVuj7z7TqGVkpi25pvNZcotNEnGnVpfGbtZW/W42ER edlbmtyi18bntIeFw8cdv2VaecdY63JH/dlfYFlrGT92/6Zv7JonNi/otSXSdWHD7YM2IpXk5Sjf HVU/vfk/YXPzUXz+/CmVPajsMd9syt6WX9JKPtpMvj7LcrFpAfaL7ujPqK7P6OnJ88M+/IttvvWJ zd3LGd1B/ozKPGbOhkiOXylcpPk7sgT5ib2S5nC1D1G8HZwdFSK5XW98j+0HhD3m2mP3448vZXX1 97KeR6mWmu5ysQkBmqCP1mf/IYFrYeveO3DHj8/O7wY67ZWsgz072VN0qnD041QSJU9Tc8HFpMsV /HgCITtAK9LTz3bf3XMv2ZhA2GPeWXHa10q1U2s+Su3T+FLhzVh7C1wL2/ReHRTW/1O/d+DGprI+ Grhn7VCcGPJveyOXWe5JyofJgeU8ZUeX2YvTvPe6PH40rPxyd8316pFz9/V3pD0Ie8wzy6mepn23 r5VsqKxb2gaaNGGvQdl049h0OfmFO12mwlb3BpIG5JUG7hk7FHHyngd3pOxCfzj2GWRq5JB3pzdO ep8vdI/HzjYuyqHc9Iy8BGGPhUj7e673b28l14TPkmsmSbCDsVpRZzHFZgS8v2DgxqmQH4et/efq A/dEAE/erzminGbsJrjDMf3HG6ODdmE/tIM7+Ymyyf1a1ifXTGfvfZ5LJkl6eyK//vyDPvk7tiUQ 9ph/vtSslVojL/exCplmmdes8/GCz7fA3Y/1Kw/cLDt+pw1+P3ieTLp5zlpWmXHMYX85w3STNOP4 Q6yt7z9LddKUTxr1kkvQ6r6udSXd0AcM2X5A2GMRNqpcmssRtq24jkHzLDX99THtnzN0scA9r2F4 38C1sD3+3umio5An7zn7mMPkDN6phsLOmprxIroMcdxlb11bErzNESR+JP1+Kd6zDYGwx5z7+ecf pNv9Wiv7kchSS2JlR2c16DPNsHQYuycDN7t4V/ypgZtPxenkJKZ42qgfOefn2Y2JO3Jw92iDJTPe 66zctrbNhtuL3WLldZXIht9wPbfhHuvvn7A5gbDHPOv3d2Ula0sYadB7rexTpoEWsvqgsp8VsBcM 2xOB6947bA9C11I3OzmM89QRQ7qbMg766KY7e87bO7CGJ8sO9zy8nckrKSaX63pqSZaC9POe1vsb bEQg7DG/rBr973rb0H8G1Ug6LY1rO/jo7GQqf6SyPxGEM4L9zOGZB4EbLhy2swK3eQ3vTh3hIzP3 DLLDluT4RG4unjqcxuZ4TnHqqbpCrNs+T7p+JHnr+vL5unvz5idxj7+ltAdhj3n2nesPXkl3ac2F OPLWTWE3TfyDPvuTFXtmA1NOdWbgznr8JQJ33ACc/viUySkNzX5rIUc6Zs5un6Jkk3dtKvso4kVX U7N+UnOlqnzQk2/ZiEDYYyFK+/V1V9UjqayqT9G7TL+EmPnJpI4pnRGglw3cY2HrnLtw4O4/x56V TbUd4bDstyPMctFG5vSGab9xOTwu4SdNQ4q2XpyvS++zWOh31oWzxbYEwh7zrfvmJwkbrebgrA2/ tCDT2jVLNpx8UkxPj7rZD1w5lqEfI3Cbd57sZYRTZl5Ix8b2yxmN0rihOfrreGRqhnhsOZvJ0EIa z5Amle7zxNaerFLag7DHovDVeIZI66q3H62yFxmH/fG+9SZwz5jm5roC1xZmeojnfr2fDl7/5KlY s/YaYpo83u8/63DPQdL+Zzi5zMFOJXYx0wo/s9kwfS2y3Fy7hbQHYY8FMBx56bSbOREkxaDZl/kk mY22983IlzkJ3OPj+OOxPYf9K4uc5+DsgckeS7jYrD375wSMh6Ym/dHbRcdF9oav9HW+YUMCYY85 ZkXp3riyr+0i48kmuIyWnpmdQOTmKHAlnnYhkvFzZTLvWZTjDc+pC31sz+PsJW9m3wzNGQg+lTb7 pZf9pzx79oxJckDYY35tbuayqkV91dHMG2mAZb6pXEO0UDuZfp8ycNP0XsFZuZz8eFT9Od1H069r 1yfxZxwqjuNdDvsna45puPGc9lmu66NmOwJhjzk2rkb/PI7Yyq78lEsKtQZZnon1Vowr/NmBK2cH aZb8pHK/usA96E6xeQuag7rZqa8WJk3PuCGZNR/+0WshWpdROGeXRFIzZ7K3CeJ8lkldl1LVQb7J W+4VmxMIe8y70UhD1vd93so19aw/Oma+GW+TsrP6VCaxPrvL4yC0penP9zNL8WOBq695kcub2GWz 7H0lXawhCbNO941HfxD7PDE7t0Fq1o2uLZsZ1Mamhrjitt5qw3OT7QiEPebcyqpzxciNL7PanDVr I068VvhnpN+kHbhI4CbN0nB8/sx4Mn3lwhcHT5O9hnTG4/3hf+X8ZRxfTeu84wbedj+yoOvFKny7 JHtZDaTrOvq7R2xIIOwxv2wMyaZW9llt58lqJPvmOt12YFbTXLL3D1x/dC/glCuBHKntm+EuJ/cA 0hkNSpz6XbP34I+2JrXtVUwapjhd6x/bKzm90TocXRRFV5LLal0e31xHPZU+y724ku0IhD3m3Nbb TIr2QNqt3AK5mQ8naNBrmX9O2O+npDvzgO24sj8MUpkMYLTzYL3NzGDDcWR8Xwru/Orazwp63xzg DTYmNDRDNw8O4NoB5XjiNeXIMo5fZ3aHvZ/skdi1dKWZOF8bQV03SWIzzj7xFwnCHvPPuh5eu5WV FVcPCwnWGR5EC3sN+uRP7bM/ctLTmXMdTALT5oe0cE9WEzfj1ZPYzAPNuE67vK3+G5tBNOd34Bw5 O9c3B4Btn6QRk720b4ruullKG0na9E8lmdlvPzWFw+wPEiZnfMn40IN92b8glg/6tpXuCvW7m7Lk 7p79QgBhj09tVAy0uLaROHZ1quiT90312lSxh2c9TfXKnN5XHt14hGLzXZPirglzaa7VnaL9M+m9 CckGLcbx/c2VauMFyvk01a/fTMspMp68TZfVTguLLrPhkTalQTOhmzYv+0cDmu4XkeZgcTzRbeOP 1f5RjjRmts/TjADyzRm0LjVrSZb19zvuDhsRCHvMrSbM3u5uSiu/Ka1U+8mFAccVvVX3sRmRM868 qXCcOfOxRrhlrm+eYJlusSy11eL2Ve+w6fFrTWabW8bOT6o0dUv9XgPfB/u1t2PCBy8XZs9RM72v YZlr2d2Me3ctbYXauluShxD1e2lGFOlStbTpyWNMzXXULa2jNWh2td2m3dJXaLp9jl8J61gjEII9 OAYXrJc+szOMy7L2wWZ9a7ExgbDHvNOidLlybqhZZmMKLfBtZkcNxqa6l/0O7iPFfJr+zo5VNhW8 RLtqn9TRAt5CXKTU35a61Rb6WoX+Ut9JQ96lqk6h1L2JkaZsmWWxDnVbM7g63hbN6FeZeoSP0kxR k2Kuid3WhV+qY+po5d7SRkQjWFraaizpUzrOrroYU1vsArJOcm2Lcm1hvLdZ6u3EYdvPmDr31x80 cJMR+/oZbW9AGzE7fq2t2vjShGV7JHc07XfYkkDYY97Tvigr68XRAjdoojVhppVryLW49ydPnppc AcQOWHppZv1thrKkJuQrL1LoC5VaLxf6WkPN7KGPYRj0+0xSoa9eptBc0bXS35WtUNUxhNDS1xpM 7TEsX2DJi2IoWb4iLakzn+d5NSo6msUtcaGVWllLG61O9H45hrisDcCSSFzW5ezocnZ02Tq62M2M QMkaC11gO2YxDnn99M13Ux993Jw1l8q1sfZa4ttAHOm6rtvpbYlboisHhD3mnSZrGFq9asdQxcaQ Z/Z1XNkflvTj6jY0veTJRiI2vSShluQLzf6RPmSoDcYgOT9wIQxzJ3uVpKFzraHzor+vqlDktVtK wfeqUFXtuq5DaGcbsb9ml0N5c7BIF6qUW3fcUs9LGYZe8ixrLTnL30zqkIfS5y3RfzWGsxS7GuQa 9HFVP89ydLKsn21FP1pXM7yr7ZXuDWh5bhcTb4b2uKbSn76oin32NJ7YP0u2fvQOO0Ab4kgytiAQ 9ph3S1qVZu0NqawoD+OzZ0Us6F3eTA1wcKKTjZ1p+jqiTZ1jXTFaoRdWuccYB/qons+kl5LvSZb1 tREYhjoOtW0oRu26XF/OyndbFuzD2C1vxt/WXFxZ2Ytv3w7TD69fpXu3Hyb3Hgc6X/74XO7eXZOb N7vS7y/7r8uOH9YDHzacz0Z53klVqxilTuykTlbKcsq1GI9+RSN7XT+rXZ5rXRuilaChrx9wSbO+ pSV87pppEVIzcN/OrtVGLnmbIk7Xix3PEP0xZdHXtde9i9vu5cvnMu7eYj40EPaYU2U5shOPxKY0 lvGlCJuqPthRyGaQjI1RFBteE5sRNClpJZ8G3uV7WuL39He7KdU7VZJeq5lDMwz79ahsy2ox6gzr tbWV+sdfRrHT2Yk/vO6le/e+Tz+/fKTJ+NQ9fvx4anzNZYPSwvVh08Py9OlTsUtvrdxz8vLl/5K7 +ZpsF87re2a/X/13A7fza8t1lntVTNZ909UGalfTfC05ueFiWtcqf0O/X9W9luUYU9dNKnwbdWOf 2ir7UO9X9jZdnO4F2HGOqpDeqCLhQdhjXu0fZL3tqron3savVDFzmc+SjVyJzuZztBOsbGBLGE96 IDZ6ZqhfexqOOyGFnTzL3tZS72qR20t1HOS+PRzUw6rUkF+5ea/+w20XNzdd2t526fHj/YGTcnCE 98mTJx/wGSYTnR0Mktx/rSTjBsDJvXuu/uXtC1/kG+W/zzujsujn0lnpZ/WgX2d+Vz+Rfvi4oU/p 6yvd0Mr9RnMkVnQvIDibCzSzBtBO2dLsb/rs7RZqp/dH75Z0Z6DPKbQg7DHHrOvh3u37TuPKFZXN +Rh9shBrqtemb7o5/VSDzpKu0Djt6UN3o8RtcfmWPu5dKXFH6tQvfDWsh1JWv6uqstwJN28+iC9f 7gd8k8bpg3L9co1AOmwAXHOEwYL/9xr8/bcvqnY7L+O7uqgzGa5LNqiS2/OZ2wvB7YkLI5e87gC4 WpukNRuZGVPoNEc09I6mGyemZvpnu3JV0MqerhsQ9ph7vb1tWcraWryn5uSkKM1wy6wZTC/NWJta 43qYvNvVqNvWh21pkP6WYvHWxc5u1qn6w14q/HCp+tNfvq0f/k33CR5/+wkC/vRdmP1lGVf8D6J7 6sJ/vfsitF/fqgbdopBuNpJQD2P0w9xloxTrIjXDRptRRvbETJu8drSD1nbClv7so51lFXxe627O 8B1pD8Ie86/MtDqtvJdcA6y2i5Y0E6HZCJRaq9ZBiumdFrWb+tBfQ1ZtZbK0XdWtXhnjsN1uF/WN rfB6+B/CXx9qmv4nsd6UOZ0y4KDit+GVtVb74e6NF6HfL+tvyjvl205RtMs0il4DP7mhC7HStG/O u7K9HnFNVW8nFWS6w5M1V65ypXzlbrltZrQHYY95V2t12vIiKdgBWpspoJn0oA4uDrWCfSc+/ar5 /7oS96tL/l3Ky14m5ejmKK/cyvfhr3991AzaefJkYeaF2a/2m9B/9uxZdC83Qje7VWfZTpXshK86 2fEJuyBvrJtDDTZbW1qxuR/sKEFs5hHS/Z18iQ0IhD3mX2eYSVwJTZ+9XZ6q6aa3AeY+lZLSjlb4 mylmr0MKv2jRv523R3vxtxujn90vWvU/jE/+8V6aPuC6YCahn2LTUPVdXF//MS4Vq2EpLGsTGEOw eX3G0yvY5azsg9rZt81sPzbuPuqjquGO/KXLtgTCHnNf2WvdHmNz1b2YrHZt+qsHGvpbWZQ3uY9v Ylu2un3X2+6uFr///n/Uj/+pqeY/kxkexY4t2ElT6dmzP6dffvkhVgOJfiQpbzlXxmT7PeMLsDu3 Or7qoc0IHaStOwHjCRUesiGBsMd8+ove/p/eqrqQ3Ldc0Dq2GWQSw0i87Dgvm5ppm1WdbbeXU6/t ytH29r36vzz7LrnPJuinIr/5TCn+06O/1+7+o+Hb4QuX8o7Y6bkhJZtTx2bTjM1cxzZVRD35i7x5 c3z+MEDYYz49dP3hC3GrHa3ua812m+fLlc1U89G9k2TnJYV3eaj7X7l28d++/z48e7bQ3TYXqvL/ 8VmKT+679NVgYzTo7smSy+1EqpZNpNZMxx/dkvX1i8tioSFful1G4+DKeVYBrlxhkxI3893UVtW7 Wnb05y2fwttOSL3gbo72/uW7+tmzR/HzDvrDwLdunX/55e/1DXdjFArXc3X1VhvB32Id39r5BjGm oq7LZkqg5eF6+t//9oLAB2GPec/6wqXgQx1iWdexr1Xsu1jLu7pMe1q3jtzdu9XL+0/TlxH0h4Fv jdvP7ic7H3gUytArhxr4Mf6m62nH1XYmsavEtTTw37IRgbDHAsSaBpbNKC9RhklkJ8Tw1mmg1fmw X7pQ3vxnF588efwFXm7PGre/xf5qXu35fNjJst0Q3bsUZKeOYRCSK4tRiMVgg0sRgrDHnFf1GlQy DNFrcIVos1TKjk/+XfCxV7rW6LXr1o/+ycUvq6o/ZI3cve/vha+WymIvjAaZ8zsuhHcSXN/VeRF9 FVa6Ib3+Q4/AB2GP+fQ399xZUMWsDFalxrrupzpY1aoVrB8sa1VvQSdfdG+0pJf3XSq2fg1hb6kY hkor+qyXQj2oU1H66OvRXiDoQdhjvllQhTLXsE9ljDY1gtuLMRukQV3c1Kregu5LreoPq3uXtm91 w7pkVV63RnVdDmJwgyShyIKv83oY793bJPBB2GM+WUBZUFlgadQXMRcNMQ38Ua9ol+36pfs1LtAU CNfq++830/JguR6W78pW5gZFSP28zkYhk+p12YvPnrGOQNhjTllAWVBZYFWtaiRF6rtUDpN0Cgs2 CzjWkpF0//7LVLa3QhG6RdFxg1aQ3WLgBjuDUN5trwX7/Ze+BwTCHnMcYBZUSb4u4o4fhizsWZBZ gFmwEWCH7EDtP7/9Md51rhq96RVpuDUclb3Cfrb7v8zRSrjWv1BWAa5OkkePnvn/fPNPXiv8TIPf vkZrACzAvpyTqC64tnR9PX3i5N73Tl7eb742B28fP7GrsrOeQNhjYQLsuX59SICdt0vUXAdl/Nco bv/CKABhj4XYrlJz4e7JNWIJMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AODz9P8FGACHF1VOodJEiAAAAABJRU5ErkJggg==",
    transform: "matrix(0.24 0 0 0.24 364.08 367.24)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st107",
    cx: 409.22,
    cy: 434.57,
    rx: 8.71,
    ry: 5.03
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 377,
    height: 432,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAXsAAAGxCAYAAACDTRbZAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAJl5JREFUeNrs3c1vHEea5/F4IrOK byIl2ZZle9ULb8ODBSRgLjr1yRpgjnNln/e0/4ak/2TP5h+wlz2o0Yc5DIQGBrCAnTUMuyFY1lAk xZd6y8yI2OeJKlJFsoovEikVpe/HzRZfiplZieQvnoyMjHQOAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAB8xIRdgI9VSumtjm8RSew9EPbAFQ/zd/qDoSEAYQ/M bLif9ffOHeSEPwh74P0F/Ps4jk8NdYIfhD1wsSE/C8dtIvRB2AMXH/JX4VhNBD8Ie+B8IX+Vj81E 4IOwB04O+o/tmCT4QdiDkJ/RY/FdtyWd9D0CH4Q9PsWQn3YcfizHZpr0NYEPwh6fajX/sR+LicAH YY9PLejlEz4O06HAH6Y+oY9L59kF+IBBL59gwSFrY+87DXcORRcuXckuwAcI+o8m3J6c87080N2x qv9a4Nu/j4eBT9qDsMeVT/qcYxpq8nAs5D5k4M5C46D7IK0N90l6/NiJNoj04YOwxxXO+glB/4Rr Rfv7IK2t6b8PHSGPS0efPS6xqE9iVStBP9kt2xe6U+5q4FuDmOi7B5U9rqyHx6rZT8ry0+nvefe+ S7eeOFnXdvEhRwouGZUELq+qH+u+ufUBj7WTAvdDu6+B/0RbwfV1l1ZXc3dOou8ehD2uXNhbF8Wt W3qcPZjt0P2QdnddevBgGPSEPQh7XLmwt+NrbRT2y8sca6cFPtU9CHtcybDXoPcW9Fq1uqcfUVW/ sHCx76XXc8m6c/Yre8Iel4ELtLi0qn7/68sI+osO3A/deOg+surejbpzAMIeV8fq6jDotWp1z55x Fgl8SPwB4tIq+ydPnLe++o+pCp+k3X639/fddy5pY+ju3nVxbS3320cZzpBGlQ8qe+AiAxcg7IHz 1fU5dG0UjnXjWPeNVqzup58IY4CwB67CH0t5OQ2WNoTWhZPs+oYNvRxOjGYjctjnIOxB4AI4B/5w cKEOJj97mIcT+vv3nVgXDiE9vaFqGpfso6pc0go/OMbag8oe4MwAIOxB4AKYiD86XKixu2fl2TNX 2JBIC/erFPBF8X63NYRhN86337r45ImLDx646OjGAZU9PgXvO3ABwh54C1qh5gnQfvllWNV/DOG9 vq7v4fbFL7fWj0o/mp+GU0EDhD0+eZcVuGdym/0Pwh447MHwrtn1eSdtrepb/oIq+/cUuJNWs7Fx SWcnzai8vz56wMt9Dh8Q9viEvNfAPbqeSd+8NelU4y0WfnQ5cfjx/P/mh7wAl4KLYLhQ+6Nxnj51 xfXrzm9vu6LVusDROJcVuEcUm+/vb8NG49y86eJg4KI2ZuHnn10cznzJaBxQ2eNj8DaBuznphW+x 7s0P97YnXaxe9046L5z86U/OadgDhD1mn814+cc/Dm+e+uYb57a2pozGmbHA/ZCsy4qMB2GPK8tG z5Tl1Qjcd7V9xovQNyd8z65F/OEPwymhbWpogLDHlWCPIvzXfx1W+K9fv79x9u8SuO/qnZZ5y7mX f89P9QIuBRdocaFGF2i9TZWwsuKKnR1X7LadLyeE8M0Z3P4d//7/JlaiS3Xt4t6KCwtbrhnNfMkF WlDZ4wrRivXzbU3/GQ7cG1M+f1u759z+Hf0Y6JnPgt0w9o8cMiDsccW81ADrbzqZbzkpTgnAiwzc 84bt7gfeT/Z+7b6q7m3n2j85efJ8ONUEQNhj9t11rvXvTprFYdCfFvYfMnCLvbFtW3n/67f3Xun+ aXHUgLDHx+6DBu451+f3Lrab6dqiS1bZ9+3u4Pbwe/a0Lzd8YhVA2GM22YyXd+5oVX9bD7DOllb1 N0+t7M8TuBcdtocsX8xrfOfs2+h139h1ivYt557/yKAJEPa4Aqwi/f770cGlleq1+Zv5IOueJ6CX 3/HnbxG4Bzrvb191/J4sxWtpT/dNUW9LMbgu337rnH385S8cSyDscQU8f+7ky3vO7WjgfqFVqz/P RdP3HLhnb4OuXfBJxDUbpiRLSy5thuvO9ThuQNjjCio2X8mNuS9mP3Cn6Mrh7eq6vQtd95KuO2nQ d3a0sm925HW7kdvus+EPH+rHI/rtQdhjho2eUOUGgy/yMMjP5OTKflrgHg3bywrcs/6s1+vIGRZ4 Zj09hVmQJee9vqeVFfd537kX5XPZePpSHt6/r1lvOU8XPgh7zB7JFenI62JTlvdK6ZQifmXZdTuT K/hpgTvp+5cRuOdoGY7xvSNpfM6uGK/r3+061252ZVsr+z+4O+6lfgCEPWZYyln/9OlTqW7fllvN HVetaKD190RydS9y0YF7LGzfInDPbPH070lPzlWK9yRpZS/6kaTY0d/9gqMIhD2ujPvuD/r/L7e3 ZKkppVuJLBcdmRjM7xq4EwL4vIF7jtOAM+l7J4tnXGTs5aB3HW0Ib9644V6+fKHb/vWw6Uz6XujF AWGPWVcUkvvqraLXTBMzi4F70XxfpH/G2SvnNej3orhWN8mubIv75uv9rAcIe8w+q1CLYsF1OiJz c87S/nzDL99j4F6E8VVZl9Wxmd+6UxqlpC+NWsKvXMuvaa2/lHJrQ9zduxxEIOwxm9L+IMH7+vHi a1e82hb9nuW8XNOg78vldkq8beBehP7YaURu1PpHW5/JvxejG/bZ9zriiyCN3XY88VHrAGGPGbPw 7JmG1ufibmho1RpmTTcHvVgIzmDgXoRB9aYhWzjXetIo8KdfwAYIe8yoYRdEsbcjMRaSgh+NxplQ bc9E4L47L2+6qAbn+L2ov9ian0+9uitLbtltluvypbvl1tbWZHV1lRuqQNhj9u1pxl9zTgPfyfuo XN82cI+aP61RGRy/9iDzb7nNo+22/dORXfky3hr9hAfRgrDHDLOK9N691VyhfqUVake60lpc0Kq7 L+NhPEuBe2zZE7ahqt6sz086a6jOuZK5UWVvy9P34mttCKPIVveV7Oy81nV9x8EEwh6zbFiRWldE x++K7xTi2z3xw4GXZw77wYTAv6zAPdZojLqD6vHvXfQ5yWhbG7vrOPTt/cTl5WtucfGau337C/e3 v3EkgbDHjPv1159kZeWG3Lr1hUuLzoVBP1+c9dWEsD8hcOuj37uEwK0mNUBy4qa93aqqyQ2dtF2y LpzB8OK19Hqb8vnnn3EQgbDH7PuHf/jOhTCczdLHa9KWYdBPvKnqhMCdu+DtmhS4J3X9TDtRmD91 PYNjzYWfNvRSVyItbQutK2fO5v0h6EHY44opuhauPdG0H9GC/RyBe1KvzIUF7rSVzJ3cCOgbmXqe IXL2Zsq2qRpdoO31nJTlljx/vi2rq99yAIGwx+x7/doeymGV/ILU9cDXteba8CEmMxe401ZQy/Tl t9+xS6muh8tOyaXgkpuTqPtmtNRvCXpcPG7iwIVJKdnx5J88+aV158637a2tzuLSUtHu9aRVFM6f 5wJtDsQTwjYHrnv7n44H7rkXUQ1/1j6lo+nU5Q/3WQrBBuXEuiha/aKoejdu3Ohr3tsli6inQ4y1 B5U9Zte2zXi51M7TFox/nCcQpX1K5f2OgXvq7A1ywvd15c0pjdHZLigPpze2T97n3EEg7IELMOyG 6PW6ohV9DrGmqfykC7QnBq6cEsQXFrjHNY0NiZzywzBsbdrt8y2zro+/I+vG0f2ThmEvsrsr0us9 l19++Uke2CO/AMIeMxv131qf/WtJqZ2D3iZDk3OOs8+Ba/Pfty8/cKc2EnJyI7TfkNS1nH2Zx9jO mdOfJOlLlOvXndvbsydV8bQqEPaYYU+ePJG5ue9kYeGO876XL87amBOrWve7KWYvcKe8tpmydn9Q /Z9rmU1TD1/Zao02WiO+1LYwVKnVauXhl3uNLs2e/PITxxIIe8y0YddDUWxLt9sWzTCxOAzB+RiH sThTgTsK3WNa+X/nW+YpvyEy+nkz1mDZLbSjbi7vW3k57ZcvZMATTEDY42q4rvX8plbz5bFunByO p4Xt+wpcd+TsYezXQ3PWs4X2Obbv8DpSHo6TUlmW+czHnu7Fo6pA2ONKaLdfyN7ekrTbIlU1pyFW a1X/ZuhlDtxpYfsBAvfQqkNr+nadtsyT9olMbrnsymyQJFInreb70u/3ZHl5mYMIhD2uBqtQBwON 4Pabqt686UaZ/rvvO3DfZln7LcbBmcKkBqhpDpYVWo2bNLrHCnuvlb3oGZANV7LJ0DY2Xup+42lV IOwx86wbYtcNh1zW3vvG+utzZT+LgXv4DEGm/lk0Y8safWfaCcmodTn6+5OGXkoqpBV7IXprGLtd ka++sgvOT2X4fEeAsMdMV/YuX5gd9te3xIcmj7OfxcCdsJYpZwZHpj0Oh5cVjv5FhaPva/LaQqj9 nFb2rrI+e5sMzar65xxEIOwxux7ox79vvJT680VnM12mOc1EDfqiPX6B9hID9+gRfcbAHYauNSSt qX8Utih/YsuSg1tOfMGxyt5pZe+0sq99UXhxacltbq7L8jJVPQh7zLCny0+l1brvfNiTntdszd04 cznw31ygvbzAPRy2Zwvcg1eOuoPC0bOH1pQ/lzjprKQ14f1M/0NL0aUgxf4kceL2uuIKZk0AYY+Z dz9Xpu32Qr4gazM5WtDbaPKz3EH7roE7qf/+tMB9s6jhK8QffmUT9relOfef1H6z1YQw+f7ZPHtc 40MqfBpUvry25L7sLbkeBxIIe1wVVqlawMdoXRRt/bfxlx+4x9dwWuAePm84sgi76amUg2Wf3nCE iV/tn82EIw2e961offb2gJcow7uMt1qvZN594R4/fmyvZdZLEPaYXTb00qYwKIraa7UumuK+cKW8 a+CGUR/9WcP2LIE7ocUZS+Pxrxtn97jaNsS3bQCPzPzmdZm5K8d6cfxcHmc/7alWAGGPmWJTJPhe V6Q1L9KIxNT45LwfTXP8ToHb2v/98PbTAXt5+6fZ2mZEb9X9lD+dE048yvJNl9Kb37edUmpRH+2Z u+L7TnYaL7/99kxf91B//ogDCoQ9Zot1O/zLvzzMn/e1si9rGyzjcn99cocfXvK2gbvfBsST5n4/ d+CepDn2JzPc9injR0+oymMs3P78QOXo970rdA2a7vqOfKstA91vn+kq9zicQNhj9n2hH13XhL5N cKxBX/iiKCXG4N89cMtRY3FCd9A5A/dkcmgLyrOclUxbUgziiyMnLj642BQ+b3Wv9gv22WfO3dO0 f8aBBMIes+mh+/nnZ/Jfr30lzUq0RzDZM/VEw90qYT/8sLB1bx24w9cXFxu4JwmH249aopTpbCcV x4b829nI0cutMTnr5ip0X1mPzkBPG5pdkeV7d0l7EPaYcVqZDjoi8xZcQYvwmLMyT4aW+6hj89aB G3NlPT1wm1MO8ImBe5JRyofRheUyFSdu8/hJxXBbx85AUjHhF7RNjPY/p4Ev4it9Y1ygBWGPWXfP 3XW/7W7l/vpmyYkGvdi8OPmpe0m8hV/y4i4rcI/m5EmBe9LBb42GjI0c8u7sjVMcrc/W5NOEVuvQ 9hauifayoKdByVe+kXJvoL9/k4MJhD1mOu2d+83KVM3Knvh24ayW9iGGovZh+LRVNxuBGyesfbxh yI3SsYwerb04nt8HdwiPzjrOsp2hiVLoOY+XlqSgZzw2yujGDffrrz/pQr7jeAJhjxk+qPa2xX22 4mSgWW2zXWrIR/3Px4Ma/d0DtyiOVcp2FnHw+RkCVyZc5N1vGMJ4kzShWyU2R3+3sHluTndkncm7 GPMjx4MfBG0j5xdcp7PDWHsQ9phtVpEu3PjCFVWSJjZWyWtc58uPPibxFxW4w7A9HPbJFWfbyNE6 J4fz6A7esYYixkkjf+SUrye/N3fkWoPEZNvh8+Xs3Gfv5Lq77nbdOgcTCHvMvkElIuWwvz41wUZe +hTHIntq4JaH4jNODduLCtzDZwgyYV2nFdnRziiK4/3xJ1b60bpvdNfYDooupqL0IdW+FUrp9HfF XfuOW6pA2GO2WTfEUtGWYOGu9apP3jcpFDax47QK913C9q0CV0N2GPTRjXf2nHZ2YA1PUbw58xhu YDHxgnNxYkNV2Fw9zm6dzWc/KXjrr6/9QNyKO+MwJYCwxwdglej/dt+5627bdeu+lO1SA9/G1sc8 g691V0wO3HCurpjjgVsMW4QpwS4TA7d405IcnTnTxakD6e024BQPN0IxTn592D/bKCY3Nj7ZbQjO HlUV7Kwn6bfsnoSyK1Js/yLu4beU9iDsMcOVfbkrZdMWyROGSR5SqDVsUUohhyvd6cF+UYGbG5BJ 88Pvvz6MAvnND9zJvS9RiqNtlhtdLz6e9PoudD1hQiOTXxL0feTL1t4+sSmhbfI4/ihB2GPmS/uX /+sX+frrz1yllX27tK4JDbGi8MnlwPeHnlxyENByJDrdOQM3HgvcMBa4NiRoYlXvznMmsN+4FMe3 TYKEaTcCHxlqKocaJW20kjUGUgwvYOv+akrpVV6ucTSBsMcs+9YytrsrjfXZ2/jHKLmq18q1kNIq +/2wu7jA3R9TPy1w04mBOymfD/84HpqaIR7ZlvzQ8MNfHyz/+J0B6di22Q1muo9CKJLYINVK3LIf PrMdIOwx21acr7e12p3zmma+SMNhl0Gr/P3QvajAtTjNbYo7HK/nCdz80zR6vd//rbGBQ2k/mI9v c5z49f5cEOH0+XvsfWllb9Ml+GhPaJc8LfR6r+TZhCDsMdulfW9vT7z1PafhOHutuC3vC8kXaOOF Bm6cGr7DwLVrBGcZzbP/oji6MSuccTiMxElTNceDJB82VEcbnrFGLSS7gcqnfAHbKnvJyQ8Q9pj5 tL/mXri+PbRELELtHlix+2A1zGJx0YE7OWzfBK6M5j07KXAntRoST3n92FlCbqROelnyo2GYx88M 8i/aA2h90rMf562q71f6nuadW1tbo7oHYY/ZtL7+XK65Umx2yZYMZxSONol8IVrZ6+c5dC8ucNP4 WcFbBu605SbrRD/DjG12e/CbUUbFxKWFsUp/f1oHW3jSli3YeKGUCg19X7RbsnTNue2GYwmEPWbU sBL9k+v3O9JuL0pdBC1YC61ZnY9avYq3/nt/yYFbTF3apMCd3trkJJZwpju6vBvOjWPTe55+NhJG G2G9NykPTwqFXdMopJR+v/ZFOSd39C/zOYcUCHvMsqVr11xoko0Z98lFmxinsK4cmxQg5OCWfAHV TyzFjwSungmc5fEm+4Er6WwNSZg0t0I8/IV1RLl4lvl2Ro2RnrrEsRUcaY7e/P9Bl1LS9iHprhkO Tc1DL73IYNCVjd05YZZjEPaYWXf0Y73f1XJ1QZKFlyttFE7h86THb5IzaZYGH0/sxhkG7lmfVTsM 3BjTmV6/39DkyRJG4Zs3Z6z9GT5N6xxXS8dHDE0Zt2Nz4dic+j5/bn01NkmC3faV7CK2b3T7lw5e vcoBBcIes2ljS3Nrue28VvbBJje2i7IiWrVa0KfiIE1z1XyGgv2M4X0sd/PJQ34Q1LE+oJisFyce K8ztLMIuDg9vaLVrAEW+FlBMaS6cG7/w6068E+xNt9Fwerc49nkSXYXNCGqNY1lIX6v7dsWxBMIe M8sq0ReuHHSlbpWSuyVSqZFvN1X5ItlFyFE1nw7mxTnSuZKN3QCVps87Y/MwWGraM7D249PbCMaU g14zNMUQ85D9dLRhOXT/rVbkw85zO43IDZPPTUwYXvS1xiF3O3k/Gh46nFDHj7pupi95v7MmytR2 QH9dGxm7eJ27uqTRJZZHzhfO91wvgLDH+9EvNTRT7VNT+ChNkUtkN6zsLczGK1x3LNfedHmMB+t+ kMdcevvkRpW72HXZXP7bzPD6vTTMeotquz0pWWsRnD0fJI03JuGg4s5BrGEfrafJSvrSiYwecBW9 6FLykEhNel1PvlZsdz7lFcbcSy/Hnzy7H/JJjsf/0bnggl2BbkJMReFtOvvoFyovWwvrMs9ttCDs MeuaxgLfrpp6Lzb0Mge+FHHqBdSx6SftubWj8Pc2YCXnqc20kMt4zcdkvelas6dgtbAGfND0D4VP wZ6HpeEeNI4bfXmVtMmx+7p80BeNCuTi0GPJbdM01KMvJIZSs7atK2zlwM8thG57lEL/LTW8tRmz 7+VhkkU+G8hjhZIfNVWyX8mPh/rhJs0mrx89xUX3kJ1/6HYWtqN0A+36rAyanrjWbQ4iEPaYSTno rCJtVTellXL/t43DKULKw2Q0KJP1vEwcOx/TkakFrHfDpgCOVqZbL41ltb5IXK3lcKNxa/fo1pr7 tS6r0pJeQ983dk9q9LHR3610XX3dgEp/weI/z7hQFOVBl0gITb4AaxW1Fv+lrqetsT2vZX/bHr2i 7UlpDZSGfEvX39Zfb2tQt+xr3fqW/qzUBij/DaVhZ5Ld45WnPLCNP5ioIR2/tyAOW4U8IlRfONxH Wt1HXW2xuMjRBMIes+62W3SVa7z1c9uDxm0kTp65TKvj/PEm7lI6NvWBVrY5AiU/rc+uz6bG+oS0 xh/o55UG8EB/baCxP/Clfh5Fv9/0Sw13X7q6ThrsVQy+7XMj0EjRLOTe95S6ruvqeLh5WtT/mnpg kxQUTVnqEmLbl0UpQat88UWstcr3qe1TMa+5PK9V+5z+2pwuZl4XOaevaeuWtnVTtREQPTNIZZ6s 2C4Ch5QH/di9Aoe63UcT/9hF5JSvB2iDou2Q5G4jbV0qkflqQ9w81T0Ie8wweyRhsLE4ommpdbOG 9DDwRSvX5CZ34+QODetzH81A4LSCl6jh7vr6eS+60NXk7GoD0tOXdHWhfQ3cgYZt1S7KQWyaJtZV KOZbYdBIXK7mQtMeNL3XHS3dq9hf/lwXs3VstdvuhpvfnZcqbHspi2LlRruInX7R1cRvR++Lsim0 6m9VsZlrS6utC5nTE4UFPUtYjEEWnY8LuuULmtzzuuXaCMQ5H31L32bLrgOM7rOya7vu2HvPd41p ZW9nEHm+OH2t7reqqqTgMAJhj9mu651bL/tSVt5Gj+cx9pIfGDjsEjna75Mvpdp13OENRtYrX2t4 Vtow9PTnXfGyq7+7p6m5mwrX0cTsuaLdi6GqirKoQ91uut2qSU0IbQ31hbgUw82QXnUGaWmpGztV L/30YjfdvXU3DbfuuGc/P5Gvv16WmzcX5FVn0Vdx0y/MtaTY/Vqq6z0vO+0iSK3f8GXbNRric+0q 1gtSyIJvZFG375qFv76hRUl+Sb9e1K8XtKLXswANfZvL30I/2RO7LPSH9w5Yn1Ye6ZP3i+4tG6Ia 9YtCz0Xyswn3WwSmyAFhjxmzvbshC+3rzuZlb0K0YTP2nKg8tHC8sve5ircRjhrwIVjPjXWgD/Qn PY3Fjp4N7OrLdlxw2xqyuxI06F3qNV4GKwuxer0RQ1zYC3+QlbD+RTdubY1C/a6F+pr79dfV9PDh sO/kzW1ZMvGUwrkHuc/o8ePHYk9guXv338SGkeZGoNRG4IsFaT1fKfpLLR9eD4r2YqssB2JdN219 P/O+lIWooR8lLGlqr6SgHy6tJC9LrolLbjSvv13ObayrZrQhIW+dXVzOcy3kZ/QmG7rU9MWVLffs 2ROxbQMIe8ykquqL5rcXm8sx99mLXfy0Y60YRa4lXBo9oSToNzTdpBujdPQVO1rq7mguvtaqfsen YtdF1y1j2S/m5qqt5tdQtu43nbmn6eb8/fjgmUuP3WP38OHDUb0s+wnuHj06y9aO5sqR/eR/NPaD dNAIPHQPm7U7TrbmnvvNrvNzc0v9pUGnbC/Ol27QtHt1b75oFwuFK7b1na+4GG/qm7yhIV/rspe1 hreqf254A5XdbZByz37KHfrJrhoXwe5D0DddB5F+f5NyHoQ9ZlHKlejdW/dc3exKWeTBj3nCmpgv Pg6r15SnbrcOmzxsstIQ7EXndkvxryWmbf3Zlga/hr3baerYHfheb0E+H2wvdZqq+j3cvHk/PtOA f/jw/n64j4L90cW/IZv/YNQIPMqNgL6ndD8+fuzk7l3XbG09rS34/5sGfxWari+X2qnp7lkDpW99 TyTsxZj6em5TaaA3+l6X9Ws/vJss3/1lK7B2r9DvF9Y4eg36qhjYA004pEDYY3bt7m3KfGFD3dt2 12keheNcLPO12jwePdjF16BJ3fch7em/21rhbsYYN4JLr0uXtkNa2tOs6y0U7UFnvdPc+v5Ws/qX W9E9/DaNpspJF5/tZzoLSG/OAOxGrJSD/ysN/o4Gf7tdVvF1M5AFDfjU9PWMpudj0dcwH+gZQmX3 8UoegmN36FqFb0NR89DM4VmPDRq1ETzFvMs9WgBhj9k271Jd+/wMJhdtGoAipoMbj2xCgJ4Wydta 127qd6z3/ZVv+U0taHfcQt0ZvN7Tgn6uvvX9f2meacj/jwf66n8S62GZpWkDDhqe/Yp/7c9rceuf /xg6napZqm5Xbm4wmPetfuFi3xovDfk62sSYMTd6RT7ryfcguCLF4dmPPXq81PZit1dQ2oOwx2yz boiytpkGYn4UoUah3WZqlyltzHzPJ7+lte26a9J/+pZ7lVLYqv38TtXEXqezUS3daDcvev89WMj/ k4b8o0ezPjfMQcUf0w8prq2tRffseugXnzc92a4XUqpDKqoUQ/A2RZCFvdjcD3YTlWvpaZC3wZk2 PYOrnW+8l890YZscSiDsMas6WpHe8EFqC67gcndFfnSg3WKVpJ9S2o6FW09NfOGL4mVI5ZafW9wt uhv9m/2yvvnH52F1dTV3d8x+yE+r9lPM295xcWX75xi+vBbmw2Jjz1fJF6btzmKbHi65UgN/adhM RJ+f5GWXraMN9ZnnYAJhj9llFWnV2ENUW9KkZP04eU7J3Gft0q5G4Ssf0u/6k9+D62+Iu7YbX9X9 X90/2oQ18dGf76Y3jxe/qsSuKdibTmtrf0q///5TbLsUepuNTbxgsztrc5hsegS78arweViqzQeU vP2s0bag09uW7xcecECBsMfsqhuRMs97kKe3sTulbFq0nn7+2ke33ri0LgvFRl0v7gwWm/5Xd79r Hq7mi5cf1VS+w/eT4urq35rVe6v6+U+uSn2pfWF9XDavTltf0YouLtn0mfbUKmvp5rydFPGYKlws zy7ARfneWTfOtgx7JUJ+OElo8jSPfQ22XS1dN6JPr5pUbM1Vrb3BYuz/9a9/a/78548v6Mer/LW1 1fjMuWZzww3qcnGnSG4jpfBSz3Zehpg2dQ/txSj16FlZecZQjiYQ9phh+90O83nq+Gi1aoqVFqx7 KfkNl/x6atxmDN3d1n/6/ld//a6xILz63TanB7516/z197817f7fB/3O7l4d6y1N9VexcRshpJ0U Ul//DTbzm/1Gd2FH/uO3p4Q+LgzdOLhgN10T+lLaJPMa+TbWPKU0kEJeRd9sSJzb/tzd6m51/t78 zx/uRCfyiTyFySr8FFedq6t7T3tNp9pJrYVXLoXF4VO84rWQbNrmFOswcG6PIwlU9ph1fecqq1CT 1DGknpar26mpXrtYbIurur9vbNcvvrkf5JMJ+jeBv/qDi+43V4elm90o9baro1b2cUMr+h2xhjGo JvIYQhD2mF373Q6llvVSp6iRVrsUuymHvWyHetBp7zWDr37/rrmCwyovJu5F3P/Z+jkuu7KK0XU1 1rdt7mU9DdrWRlHDXmp70uJgLhD4IOwx2waDgT3RL0Qr8DXANNb3BlG6vt8MXg8Wm2f3XPr4++mn yhdsq982gturBqmJe9o0bkcXt2PTdGqJA3tw72K3SS++2SXwQdhjNm3pf5JasRoMQmxClavVaI+I 6g9c6eq5wXb8VKv6sfp+WN1/fruqS9ctXL3d1HEzNe61tgWdKK7eDL3I0QTCHjPJKlGrSGNdB+cK m/yrK87vxui7ybUGL3Z3w4v/oFq16v6HUXUftvqDWM3tFUVrK6X0WlLsJFkYrMzNhR9/XGdfgbDH bLKKdNBeqIpSuq4JO41Wqyn099rVoO++dI178CB+wl04Y7W9y9X9wtJONZjb7vaq3nZZzG1VvcFe KJrBUqfd3Lv3LLGvQNhj5lglahVp2bhKD6yOc63XPtXbEuc7nV5dff3bcnj4yXfhHMR9+uGH1fjV 73tNb/HmYL4dunUr7n11+05vZaeurCF49Ogh+wqEPWYvvKwStYrUKtPO7o6Gfe91r4rbVrlaBWsB xl1CY3tMJK3mm8ruNnee/6n6fxrySz9+m4el/vBJ3GyG9302CVyQJKura/6fb/7Rv/jm82Jpb6co QifuXL8e7v74Y1j9YTV+emPrz9hS5mnxh3+RMvZoRYCwx2zGvQb+40dO7v7o5Nm9/G+yoZbWfSNU qgBhj4/tuBo+rPvoQ8ABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAO/H8BBgBZ z77EOAEUyQAAAABJRU5ErkJggg==",
    transform: "matrix(0.24 0 0 0.24 49.2 249.4)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st107",
    cx: 94.47,
    cy: 316.85,
    rx: 8.71,
    ry: 5.03
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 377,
    height: 431,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAXsAAAG2CAYAAACeSCZhAAAACXBIWXMAAC4jAAAuIwF4pT92AAAA GXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAJcVJREFUeNrs3ctv3FiW5/F7LhkR elm20nblo7OmE4VsNEbGNDDwqhaD8mI2A/TWve7VLOdfsP3vlLYDzNaFXvSiYRTQgL1oJBJZA0/Z TqX1CsWL5L13ziFDckgKhWRZskPO76dKaT1CJIOgfvfw8vLSOQAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABzTdgF+NyklD74uBaRxJ4EYQ98JqFOIwDC Hrj+4X6R4/u9wpzwB2EPfLyA/xjH8ZmhTvCDsAcuN+Dn4bhNhD4Ie+Dyg/46HKuJ0AdhD5w/5K/7 cUnog7AHzqjkP6djktAHYQ9Cfg6PxcvahkTog7AHQT+7y+ZzOybTtM8JfHxsnl2ATxT0cizY5TMt PmTj3fs6fI+f4oYwUNkDnyLof3XHoIa+e/iuuk+Hb54qH4Q9PuOg/zUfe0cDn7DHR5CzC0DQv5+n H7D9D5qAl3GV7540+4fAB2EPgv6yA3dOGop0bEcJ3Tm4SnTj4MrDXqtXeeTqPmt5eI2D+rJtWuDr Tnnx0CXdP4nqHleJ0Tgg6D+Ru091X+hOsf3z5IkTRuiAyh7XOuzXNzToH/56gv7Gs/O9z+59rex1 p2xuuqT7x6p6qnsQ9ri+Vb0dZx876M8buJ8agY+PhQu0uDJ1941W9XfvavA+uD4B/LEbpe57PjAF uAj67HElVb1V8wdB/4Cgn8n2T90gAleIAwxXHvY3bnwex9ni4tW8j8HApW7XpXFXTqQbB1eBbhz8 6sP2U7t/37lnz+ozoPqGK26yApU9rlVl//Sp81bVf64hfRXVvQZ+dFykBZU9MB/a7ctrwL7/3qUX L5xohZ82mmGqyfLeinz2NAh7ELhtzhgAwh6fSHMX6LhCdVaxrq8798MPBDNA2APz/EeSX21DpQ2h 0wYx2UVa68Jppk6wfnv2PQh7ELgA3gN/QLhU9TQJWpk+euREK1V//74T68L5NYf1We+9qlyyj6Jw SSv84BzTJoDKHuDMACDsMW8mq3oCd3ZDZJX906eHN1cBhD3m26PxVJeTN1PNe9Bn2afbvhCacLdR Sz//zPEDwh6fuU8ZuABhD1zAuDvC/fRT041zXYN8c1O3+8urXUepH4V+VD80U0EDhD1+lT5G4J7q S/Y/CHvgdA+ai7ObC07aWtW3/AdU9h8pcKet5u3bj3BGUo3L+5vjef/vc/iAsMdn7pMFrq1n2jfv TjvVuMDC7874WWw+8pGbnGqCETkg7DH/6gpVK9X2G63qW+e/qeqTBa7KtqZs49a0F15g3VszfhZ0 09ZcGnHYgLDHZ2NeA/eKnXWBetM76b1y8vvfO/fjjxwmIOxxDVg3xO9+14yt/+Yb57a3J0bjzHHg fkrWffXjbzl2QNjjmrKRNHl+PQL3InbPeeF57Yyf23WJ3642U0Lb1NAAYY9rwZ6r+q//2lT4OztX O87+sgL3Ii5rmdu6fwb6scihgyvCHYu4VOPnz3qtULPVVZft7bms23Y+Hwfy2pxu957/eH8Lt459 HaNLZeni/qoLi9uuGs98GZn1ElT2uD7uOnd7V9N/jsJ2WuDe+sDldd9j+7vHvrZkH1lVbzeP/QOH DAh7XDNvNMCGW04WWk6yKWF46xLD9kMD92PK9o9u540ll+y+qv6XzrV/cPL0ZTPVBEDYY/6tO9f6 dyfVUhP008J+ngLXrX7ElR9bVzc6KXT/tDhqQNjjc3QkcFc/8srfc31+/+q6mVbGlf3Q7hRuN9+z p305x120IOwxx2zGy2+/1ar+Sz3Aetta1a9NreznKXDdjQ/8uW1f72Lb53Xf2DWL9l3nXj5n0AQI e1wDVpH+4Q/jg0sr1ZWFtfog658V1OcI06sMXNf7OPun5/ePbN/y8kraj06y7q5ko5vy3XfO2cef /sSxBMIe18DLl05+c8+5PQ3fO1q1+rMunvY+3rYdD9zZ7cvKJZ9ArBx/37K86NLWzZvODSa+b0/7 ekxXDgh7XAPZ1i9yq3Nn/gN3Ql+Oblff7V/qupdPrHvf9XorklV7stOu5Ev3BQcOCHtcD+MnVLnR 6E49HPILOVnZz1fgnv6zwaAn51jguQ2OncIsLq0k39X3u7rqbg+de5W/lLfP3sij+/e1sLeini58 EPaYP+IevftiJ9uSG/u59HIRv3rD9XvvQnyeAvd9l+sHxxJ4cPEd5nVbun3n2lVXdrWy/6371r3R D4CwxxxLddY/e/ZMii+/lLvVt65Y1UAb7ovU1b3IPAbuTEtnf08GcuHyeyDJ6X7RjyTZni7nDkcR CHtcG/edzdb7xm/Lslb2/ULkRtaTEwE9J4F7xmnA+av0C0z5EAd10LueNoRrt265N29e6TK+bprO pO+LXhwQ9ph3Vqn6paai10wTM4+Be1mGF3h/Cxr0+1Fcq5+kK7vivvn6IOsBwh7zKU0MErQK9fbt r912tS8dDWCrvD9GEA/l49bCk1MSy/H31z/H9iat7KPuuNWV+vWtzTeSb78Vt77OAQXCHnPuvn68 +tp1f9mVLGUyaImsaBBeVRB/aOBe2JKG9cEZxdBWffw04+xFxOiaPvtBT3wWpLLbjqc+dh0g7DFn Fl+80NC6Le6WhlapYbbXl+GyJv3wCir7Swjci59GODcaX3RevPB60jjwj17ABi4bBxcuzfjBJfLi hcuryrXyfK8TY9YKweci7sq6cQ4D9yO/35F8+PvpJJd6MSWfpWpZlooYN0fO3S2eP98IDx8+5AEm oLLH/BtXqqKVq1xV5WqBe1BUjz5wWQuz1jM6Gexy1i+dZ/udOxx62ZOuLMa745/wIFoQ9phjGxsb cu/eQ7eVb8pX7q4bSF9aS4tuVAzFn1EJn5WbVxW4k8F7fFFF0azCn9ZNU7xvKX/0S5vR2AYb+aE2 hFrHby/9Il9mdzjjBmGPeddUpL/RoO/5rviUacgP9KMeeClnha276sDtnP4jKUTK49+77NjVbS0m 9kORXMpbKdq+sYey3+GuKhD2uC7+8pcfZHX1lty9e6ee3SWMtGy1bpxxaJ8WuBa29u+VBu64YSim NTwysy242OqKKWcjk62ZXZzV14x0/3TiitvZ2ZLbt5kMDYQ9roG/+7vvXQjNzJY+rkhbmqA/vKmq OD1szyi+ryZwz3GSsHCu9YxONBdTz0YmVmIjcaSlbeFI91GnJ46gB2GP6ybra8guOSmHzpel9eS8 C11ZOLP4fu/AbcL2ZHNxVuAe6szeJimKmecYIu/fTNm2HYxUGgyc5KNtedndlYcPv+MAAmGP+bez 42R5WWNs6CSN++uPDL08LdE/IHAvErbHV1DK6ctvX0J3UlkeXX5K1tOVdNuj7p/xGr4j6EHYY849 fGjPoP1Jvv32O7e9bYHfVKx28VHOMy79igP3eNieaDDaM373YBtmtEhnLv/EBYjkCv3mgg2oT339 by5EPQh7XBu7u9sa9G0Nt6HIuLI/CPsLB641BO0PC9wzZ2yY9eOiWXkls5b/vntKnNdzH7uukGVL 9Zt89eql/PTTD/LAngIDEPaYV99991194XF7uy8hjLz1TKfk/MEF2gsHrn2/vIrAbVSVriHMeEFo +p7a7fc5k5h9NmPdON66csbz/Xe7YmdBAGGP62Fvb6fug06pDrvD6v6DAjeMy/tLDtwjjUTpmjud ZjRC9rqylPMvcybrr+/oq5KeA0Wx547v79uTqnhaFQh7zLGnT59Kp/O9LC5+q/X8oJ4qwTIvBOfP E/YzA1eOvu7yAneisdEzhlZ1Str7wwbp3MusqrJ5Zas10fpMVvbaHqZCP5L3IZf9SpdsT375gWMJ hD3m2oP6v1m2K/1+W1oti8WDPvvzReSpgeuPnAFcWuAeall70j7XacDhMl3rjIZm/PNqeqNVrzO4 w/1z8+aqG7x5JSOeYALCHtfDzbqyt+GWZel8jGXTZz+ngXv4bV1mcGf3EYm032P7Tt/EPKQUQivl ear31f5+V7KMoAdhj2ug3X6lobUs7XbQeF/Sj1I/2k2f/RwGbitMrvw9lzlrPxw0MjPaono6iVDo OUv0Gvt6JpQxCRoIe1wfWSYyGllHS+FDqLSyl3Fl/wkCt3U5yzpI7sMzhWkNUFUdLiu0qubsZcaD Tayzvi36j1b1KTUdU2/fvtGGkqdVgbDH3LNuiK5runCkHpXTbs8ejXOlgRvOOkOQU/8Uqolljb9z bEuOty7HF66/EU5/3/UF2uBSppEveibU74t89ZVdfH4mzfMdAcIec8oq09u3l+oLszb0MoTSZoDx sy7QXmXg1sM5zz5XOOXMoPn34PKCHAvucPyv6HjD4s9+HJw1graP8sJLlvWkeQbtSw4kEPaYXw/0 49/H4WgzXaZO0z1hbPjlpwjcWaN2QrCGpHXqH0J4l9mntCy2jMmzktZ77a8suRRimTLJbIZncWnZ bW1tyo0bVPUg7DHHnt14Jq3WfefDvgy85mxV+hjreSdPHWf/KQO3Ne4OCifOHg4Wc2yr4rTKvDXl /ZzvjyvGXJvCVhQfxS7UtvRTHg0Nwh7XwP26Mm23F+tqvrmLNkhzgXZ6in3KwI3jV4g/+cqqXkb1 3n9GB81WFcLZ98+mKkkreRcyL9bd1Fp2v3HL9aMKAcIecy8b9MWtLNR90T4G75L34qeH/acN3HDy 18erk7y5jnB2wxGmfnXQfRRk9gVa/QWfSXNRwy5qb7d+kQV3xz158sR+L3E0gbDH/FpZdmUZ66mN YxCf5bkGf/DzGLgnzhb85PcqPfNozhTiBf9c/IwL095n0RrEYPOg+Y4Mh/WNaABhj/lnUyR4reyl ZZV95e2R4xb09aiTWaF7ZuBqw3HBbfJy8SfZ2jqjPRI8n7GIU04+8vxdl9L0PzebK6EV7eElpZ3c DJ3sVV7++tcX+juP9OePOaBA2GO+WLfDP/7jo/rzYSaSlxrOmvwxRp/GF2gvGrp14HoLzfwKAves heXOph92ccaA/VOq8RizpqFozk+m/Fqma9J013fnW20Z6X77Qle9z+EEwh7z745+9F0VhpplyaeY 1ePsWy0bT35GYJ+a3Pm4Or/8wJ1OjlTfQS42RKbpwzp54vJum4OLVVaPVnKD0i/aZ184d0/T/gUH Egh7zKdH7scfX8h/WvlKqtUoVg4nsT6dog77GHMblSPnC1w5Evn5VQbuyZ6VKe3I6Wck1Yw/qGAX pWddYo1J/1/5TPeVPcBkpC1a1RW5cW+dtAdhjzmnlemoJ7JgwRUqb8/StrD3KXgL3fcJ3Mmu+ysL 3FPOEGRiJE9K2blOKGw7g0yMADr2e/nx7dWM99H+7zTwrV1M4rhAC8Ie8+6eW3d/7W7X/fWy3BTV kpINqvTRBl+eN3THgRcmAje/qsCd+N7k+t53zGPUddqafDr9NOFgRM/B9qZQScp8TDHU+6nwueS5 cFcVCHvMfdq7tb8618vqwth7m8c+aprl1o3TZNxZB91k4B4P8bPC1v5938A15UHj4GXarzRrn9LW SHzXtSRalJ+1jTJez+HQUNs7euaTdN/UPV7Dobh80f3lLz/o677neAJhj/nV3d+VaqUjS9WiJpmN xil9bl0547CfNl79SCV+nsANkwHaBK6F7XkaheOBWzcQacapwsHaq+M3aGXnq/5lsjto/K2D1fjM xRRsLnufhplW9rp1vT3G2oOwx3yzinTx1h23WCU3jJVddtQgc3VVH5P4ybA9kq3pjL6ZWYF7nsSd Ebj2Z3C8gYhx2p23csbX09+bS6f3ylRVXdZHyXKxO4wX3IJuzaLruk1G2YOwx/wb2RSOuavnxKm7 KHzzr4Xu9HA+eSheXeBmR+p6mbKeswrr+kHq2clhOzMbnmiTnB1dt7Z/Mdk+0qivUukXQi69YVfc Cl04IOwx7wdVT6TKkgSt7OtZAFRKIUvOLtDKHASurepdLZ9cdsZ6gk37cLRB8ZkLU9aTndpIHfz0 eFMlLqbkxUYq6RelH4lbXW02j9IehD3mkWXT/6kvKu66ohxJ3m5p4IfmwSX6Yd05TXraaJN44cA9 jHcbx3mRwPXuRMd+tJ6UU1oXu3k2TXn9tNeGg7ON7LSG5ujZiC1HMgl21pOC+LztJO93Jdvd0hd9 x0EFwh5zm/aul4vklUi0Pvvk6/H1pUuZPwj7UwJXa9zTJwybCFz/oYEbjgaubUjd/KTTGhptCI6d Z8i0Qn3cCkU5WMfsqr45o0naXsUsE+dLm/i/zCVwJIGwx7x78+Yn+frrL7Syd9LW0I8u2MVZu0G0 7peeFbize18+NHBnnzlIPH0qZD9l1E09zPO0VE4n1yenNUzNY7xCFYLNFyel7rdR4WWFQwmEPeaZ dTyEfleqrK35lpqA1//FKlqY+Vmhe5WBe1rYvnu5HFv25DemDOacuOBrTVA6XL6f+jsntt2uymr7 F6xPK1gPkl3AFl/PDXrDNc9sBwh7zLdV58tdkU5HggZ+3WmT8rrPflbovk/gWqRO3sR0VuBOO2uw wJ18uZ84c5DxL6QUz7ybNU6eOcRwrrtfrdlLduNBslMQ8Xpe41MVfLagp0MDkc1Bzl20IOwx36X9 YH9ffCmSF9Znn/mQhSxZV046OZz+ooEbLylw65eP74IN55u1R88Spk1ncPC74xu75HjDM/3lKSab OzlzNmRJ8nq/HZysbGxsEPgg7DG/aZ8NXttNrZaJzdS9QcMs2GTHJ5NvHgL33TLPeP2xs4R3y5/2 Ij8eFTT7zMBmPRO7/pyij6nu7pKi8OIWOJJA2GOObW6+lBU9rCovksXgo4TMZvrSmt66KrITQfoB gVufFcx62TkD93iISzr9ltc4uWWHYZ9NXVqYaHisi+lkW9cMPw26X8Sm1QzJZ+2WLK84t1txLIGw x5xquh1+74bDnrTbS5r2mpuVjcJJ9jztekROPPNCaf0Q7nNNj2l3Ib0bT3924E5OWja9tWnCOMjs bTy8JpyyuovJn+NsJNmEDScG9zc3VdnGW5+93U5bDkuf5R35Vv8yX3JIgbDHPFteWXGhSlKUdjNV nckW8vUdtLO7X5rAtQAN55kILHrXzI1zvsAN0+ZWiMe+8Kd1EZ0W4endc3FPjAzyk6csMn0Jlvji Q4pZbuNzRGQ06svbbkfcGscSCHvMqW/1Y3PY17RcFJvJ0bvchxAzqW+RTf48gWu9/XbN8twdLzMD dzJ6/bvOk4PwjSejOc7oxjlhcsTQ8d+KE6OB0vEGJLxbq/VzBT0DssGpMcny4WY95IACYY/59HY7 E3ej7bxW9sE3Fau4lIVkd9DavI5nP1owHk6ncD51cFtRLgeDfaKGa/O5Hz+jKibrxYkn2okjTYee IdiFYmsUkmsmLbPrAtmJ9U28hxm9TUe7jdKJVuJwW+3yhp75ZPYUk9yJXe9oFxxLIOwxt6wSfeXy UV/KVi42T3sr5X7cOZLV4+zHFW48UeFO3ACVzndBNdRhrjVzsihtwl3XkVJ9L1eK9ef1tdFjlfuU ir9uMOpRkOKj/s8iv77Jy76V6tkUmu2uLwr7KRdxT/Y7xVPfx8RcEVrJJ++reqy97i9L+lH00tvb lIW1rw9ahcSxBcIec2eYi2Zt6VNlvRPNxVmN5szVF2iPh6QcieAmIKd12MfDyr0OcP06s5llrIiv J9Wpb6nSr21KMV1tdHpuod8LmqHjq73h1DOJYO2Fhb2luFbZ9ncRMpvXx7qebEhkffdvahoBXbK3 O1/rMwA52N44PjtIMj3+/UQj0FxUrmd9rk9jYqaf6P7JfVFWfin3bvdLjiMQ9rgGqsoCvx47Xod9 suGFzqY6nqx2JytcJ+OHih8WsvXXvrmGqZ/EukIfB7t102sBHOwprhrwlb7Ieo1srZUGZ6U/K3Rl lQa5vtZOLo5HfXakG0hCbou0bc1diB2bjV+DO9cGI9e63m4K06+lbgTq66jRZ9qu+GbcULK7g+ur 0W6isYpHqvwg/ljwV7pNNsG/NoDWX6QbVGbeZzIqBuJapD0Ie8ynOsS3FzflZrEmdf+3PaXK1Q8c z+rADCGbVuEerd8PK15XT65QJ6YV8ilo2Rx0ORbopQW8luOlrrXQFxbaAJRaZpfaZpS6vkJbmmEI qcwyX4Uq1oMcsyw/7A4JoXq37lbbWf9JiD7XE4V2lvyCBng7xNTWSG+l5Fu6zI5uR0sbg5ZuS0t/ 3tJl5rqB1ijUT5kKNt2NdSBJ80iu42cpccpnwR7flfnxXP/aKtmMx0tLHE0g7DHvrCIt6i7vVDnr T7HHu2bjCev13yDHuzYOLpxqmVz3sVs226NYY92JrVV7kkqXVugy9CMWWuUP9bf032yoeTrS3B9m vjXS6NSwz8oYUtVyMurknaoY9WLLd2Lf9V05WWrLu0BdqoKroj39NcuykOcjn9p5iroIe4CutKIG ffI2vMh1dNkLuv62bvmCbl5Ht1cbAdfR7WilphGw92lzm9V3ER9266STF6bFuqVsmGkIuV3T0JMW bxd1M22qFoq34hao7kHYY47ZIwmDjcWRutK1C7NWUufeZr9MJyc3S03sx3pq9+aSZaUBW2pYjrTy LfS0YKjJONDfHGj1Pkgh9X0uw8zFUSla1WsDILEsQ9mqOnm78lHr9nxU7e70YjsrYu/GDV3u9vGt PPxsVxuohe6CFGHXS55lrVaZR/2kfhp4qUEsrZaPw47zrbaeTCyk1FrQLV+yD32jS1qPL+s7WNAt X0zet7RC10Yi5HX3jp3ZSD1t/ZRHJVovVP0MxSzaaKXMqvvgi6KQjMMIhD3mva7fzIeSa6Fs48br iR1t0Lw9QFDL3SMVrl0SrfMwacFskwaHKmXZSGIcJvEDLYp73mV9PTfoa4ncy1LWD6kcuqw9GPXL cuGmL1zZrsrCVUVVhLu3lsJPg5Da7VFcXu7HXjFIP7zqpvW766nZstO9+PGpfP31DVlbW5Reb8nf KTp+UG37wc22lz0t+EUTP/N5O89aqcraLpaL0YWlGP1ycv6GtlErWsevSEhL+oYWkhbnWulr5R/r O2Ndc3OZixPj7X09ZCjqCUOd7Zl169dDRG0sZn73oEVwzjEfGgh7zJnd7ltNro5oskkVom+CzMbY +6we6TIOe+vA0JI2aWsQ6onpvRtGp9V7FXpJ8j3vY9en1A0+9VKZBnm71S9Go1Fq+yJ3e2WK7aqn P/6trIbNO/24va3B/uPLtL6+mV68eJgePWqu8r6L1lmBaS99UI/TfPLkidgjt5bXN+TFi7vyda4N wJ1Fab1czYbLLR92Rll7qZW7kbRDyjp65rIoIa5UGvb6x7Sqwb8SRYM/uBvakq3oohct9O2irp6u ZAdDOO2Cbqp7rfSVKdqZT/OAl2SnCM22vnjxVGy7AMIec6sog69nw7EhhRr40TWBNo5du9Jqo2rs htpCvxyEkLre+10Nvt3o0o6Pfk8Pz/1YjoYtkdFSEUdhoapeV/thNLoZOp3duLZwPz544dIT98Q9 evRoXDM3EyM/fvw+WzueO+egd/3wKd9NHFsD8Mg9qja+dbLdeem3+s53OsvD5VEvlyL2Qtvva2O2 GPOwI5Vb0SWtJolrMcia1u43o12zDXGx7qS3GwLsAeOiKZ9cPcI/jUcrOT2vsZ6vUk8jhsMtynkQ 9phHqa5E1+/ec2XVlTzTfCstvJIGWcy1aLVJbLI662y4ZD3pvAy9T/vaEOxp9G+FVG3lmd/Wyniv qNo9X+wPrZLf7ixXr0e98F/+89+H0abTyt3VlfvRcH98Be/p4BYwlx7XDYCF//345ImT9XVXbW8/ K9s3bhfL/eXh3miz34nL+yEru5mLXRd8X9uzoRM/0ndb6YLsksSSr7t2dD+kesymntLYKlLuos/s ToSkjaRrleICWQ/CHnOsu78lC1nUgtfb9VhvDy2xcfZav9Zz49htqcmGUDo30Ep3V/NuS4vbLa3o 30bnt8JANCzL3iAUI/+bTlkUb8Pa2vfRAv7BAwv4phfkSrL9PcL/IPj1pCI8da56/cVu2R7tjvpD Gd5YWO3HOBhIzAYxd31t2EYS6mGiVXT20EGxFqptt/26ekqFpqsrVnVXjpSViOdQAmGP+bfgfCil ecB4PaOZTYTm63uibCilk742ANsxhV+03P1ZC/23Mcu33WjYHcSFQfvL9qjSkP+ff/n74B59d1jB f5qAPzv4zZ+efB+33NOw7h6Uw/xN4RYHRegGbfPSUGv6UeZl5EI9BCjEGOxyra+Ho6ZoUwZldkNw 8smXZfKdXJwfZJT2IOwx34psJHnpxcbYW8jbkBtpht5UMcpA83Eny93PWsS+rlLc1Gp/x2dFV6Qa rg2HpVt+Hv75nx/Guop/PP/zwkhdqDfT8jx5rLHd+zL+rZ2bLMRqyY9GrloYlmE0dDaENKXSpvW0 xxE2Mz6kVgr1GU+WrLK327sqL20OIxD2mGc9rUhv+SClDTkMzR20duVTky1ovA00FXf0Oz+H4F77 FN9UMdvK28P9+Mut4V/c68q5B/HxP62nd0+gvT7EtvlxU+lvbPxbWn5xLw6z21We7ZZlmZUpxMIa POukt2uz+h+bhmG5Hpck9VSbukuCr3ypYb/g/sDhBMIe8+oLq+yrQvOsJZWNOrGpBKyS9a7QDNzN vP85Vem1z+SNG8nbQeW6bnFl9NXzf6se/bGu5q/9DI/Ne0jxsQb/H3ou/nn1x/il+5uwX+1XWacd UlE63T3exZTry2yqhNz67psx+ZlkwUtvsCtu8QEHFAh7zC+7wJjXgwttkGXUjHeFi7EvWfZLiPFN FtIbV+Vvdyvf/coVwxdb69X/2vg+uc8g6Cci364x1FX+5sbv0+vXP8SOLESvLWCweXjKLNfd09HK vq0N4rJ17cR6PmV7DK82lmtrzg05lkDYYw5Zt8N/WEW60qmnDY5N34Q9Onugn+9ISJv69WaRuy0b Q/9VNRy+cOvV48fuWnbbvE+V/8eHf65ef/Vfh+5vtKAfhix3eatKcVF30mKI9bh7G6WUgrPbjDuu P9zjAi0uFSO8cImabofKnsHRTD6cYnBliK6nBf5OCmGrSrKdDd3+b5ficOP58/A5B/1klf9PGw/j v7z+c9Ue+lEYLXTLym+nyv8SU9zW+n8/aTmveys1+6+og/4//vqMwAeVPeaVPSV7aDOepeBtynYZ ioSBuLQlPtt2A7cf2mvD/X/5utrY+D5+/kH/LvA3NlK8d+9ptVx+MVzodLrZsNoOmX+rraJV+EvJ prj3PJUKVPa4LoZDV9hDAUtXauU6iCHtac26U2pF324vDl657erFvSfp1xP07wLfuT/F3kpeZsNi ECV2pQw7sdL9U0Wb+K2MRZlGIw4hEPaYYwfdDiHYU2Bt3i830i/2Q5Kdqox7uZde4TrF+vP18Pjx o19lBWvv295/r0pFMXS9KsQ9F92O7rH9qgpFcK0qr7Sh3OF4AmGPObat/5PUiqGsNLLiMDnfdSnu eXG9rK1F69teeHHP/Qqr+nfVvb3/zmipGtoTU1zqxRC7MYSeizIIZahGKcRRJ9CdA8Ie8+nVN910 N61EH33lqjQKQXoupb1QWZhJ/20/K7dufz++KPvrZe+/M9qNfikWo1E2qGLW1UZgL4W070Mcdvxi KbofbX9yVIGwx1zaiqPoskEZ87LvXdhNRdp2Wbbns/bgN0ud8vnzjV9xVf/O2vb9mAUbfZkP8rLa cy5txZC2o4v7o7JX3NpZDevPNwl7EPaYP881nO6srAbJFkbetXtxVO6Klx0Z9Hu9N2+L4q9vwx83 Hkb2VNOV839H/6+K1WCgZ0E7ZYg/Jx9/HhVudyFb67/6xi5iP6RhBGGP+Quwe/deJAv0bKEYhSLu l632dhny3dbajd7i8l7x6pv7zNI+9uixS//t9f+ohkV3VFTD/Txf3K4/9POt7sv6IvajxwzDxCX+ hbILcHmSPHy44f/72u/8q29uZ8v79vDWXty7eTOsP38eHn4mc99c2t5KSTb+yfnttWf+VdGtn+L1 dftGsC6eh3907CtQ2WN+q3vrprEKfv35d2Vv5R9G3778feHcevVwg6A/sbfE7qx1ur/+d3DfPSjs wz6377GvQGWPa3JcpXoe3/GDR+pClt0CAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA AAAAAAAAAAAAAMAc+v8CDAAY4YjdTRI5ggAAAABJRU5ErkJggg==",
    transform: "matrix(0.24 0 0 0.24 4.08 241.96)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "st107",
    cx: 49.29,
    cy: 309.39,
    rx: 8.71,
    ry: 5.03
  }))), /*#__PURE__*/React.createElement("g", null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M307.81,146.54c5.14,14.51,1.63,33.45-7.84,42.29c-1.83,1.7-2.05,6.28-3.99,7.01l-9.56-2.95 c-5.32-1.44-10.12-6.41-12.92-14.32c-5.14-14.51-1.63-33.45,7.84-42.29c3.45-3.23,7.22-4.67,10.87-4.49 c2.24,0.11,8.34,1.29,8.34,1.29C304.31,135.46,305.7,140.58,307.81,146.54z"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0526 -0.9986 0.9986 0.0526 117.3129 452.3148)",
    className: "st2",
    cx: 297.03,
    cy: 164.33,
    rx: 31.54,
    ry: 19.47
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.0722 -0.9974 0.9974 0.0722 111.684 448.7246)",
    className: "st56",
    cx: 297.03,
    cy: 164.33,
    rx: 28.99,
    ry: 17.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127027433680902689280000002604851537929772457_",
    gradientUnits: "userSpaceOnUse",
    x1: 280.606,
    y1: 142.3107,
    x2: 308.2198,
    y2: 181.1953
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#6971FF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D31FA"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127027433680902689280000002604851537929772457_)"
    },
    d: "M310.32,148.21 c3.93,13.37,0.68,31.24-7.27,39.9c-7.95,8.67-17.58,4.85-21.51-8.52c-3.93-13.37-0.68-31.24,7.27-39.9 C296.76,131.02,306.39,134.83,310.32,148.21z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCohete);
export default __webpack_public_path__ + "static/media/cohete.c91a1b431ddd65d0e07cb94b487039c4.svg";
export { ForwardRef as ReactComponent };